webpackJsonp([1],{

/***/ "0fkY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BpBR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EUPG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GT0P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-analytics/dist/vue-analytics.js
var vue_analytics = __webpack_require__("AYPi");
var vue_analytics_default = /*#__PURE__*/__webpack_require__.n(vue_analytics);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/js-search/dist/commonjs/index.js
var commonjs = __webpack_require__("5KK7");
var commonjs_default = /*#__PURE__*/__webpack_require__.n(commonjs);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FeatherIcon.vue
//
//
//
//

var feather = __webpack_require__("/qmR");
//  feather.icons.x
// {
//    name: 'x',
//    contents: '<line ... /><line ... />`,
//    tags: ['cancel', 'close', 'delete', 'remove'],
//    attrs: {
//      class: 'feather feather-x',
//      xmlns: 'http://www.w3.org/2000/svg',
//      width: 24,
//      height: 24,
//      viewBox: '0 0 24 24',
//      fill: 'none',
//      stroke: 'currentColor',
//      'stroke-width': 2,
//      'stroke-linecap': 'round',
//      'stroke-linejoin': 'round',
//    }
// }
/* harmony default export */ var FeatherIcon = ({
  name: 'feather-icon',
  props: ['icon', 'options'],
  computed: {
    iconSvg: function iconSvg() {
      return feather.icons[this.icon].toSvg(this.options);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3395e3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeatherIcon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{domProps:{"innerHTML":_vm._s(_vm.iconSvg)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_FeatherIcon = (esExports);
// CONCATENATED MODULE: ./src/components/FeatherIcon.vue
function injectStyle (ssrContext) {
  __webpack_require__("0fkY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  FeatherIcon,
  components_FeatherIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_FeatherIcon = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PublishPage.vue

//
//
//
//
//



/* harmony default export */ var PublishPage = ({
  name: 'kpPage',
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  props: ['page', 'width', 'height', 'classes'],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['basePath']), {
    styleObject: function styleObject() {
      return {
        width: this.width + 'px',
        height: this.height + 'px',
        'background-image': 'url(' + this.basePath + '/static/_content/' + this.page.original + ')'
      };
    }
  }),
  updated: function updated() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  },
  mounted: function mounted() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dc8f292","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PublishPage.vue
var PublishPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page",class:_vm.classes,style:(_vm.styleObject),attrs:{"data-page":((_vm.page.pageIndex + 1) + "-" + (_vm.page.sectionIndex + 1))},domProps:{"innerHTML":_vm._s(_vm.page.content)}})}
var PublishPage_staticRenderFns = []
var PublishPage_esExports = { render: PublishPage_render, staticRenderFns: PublishPage_staticRenderFns }
/* harmony default export */ var components_PublishPage = (PublishPage_esExports);
// CONCATENATED MODULE: ./src/components/PublishPage.vue
function PublishPage_injectStyle (ssrContext) {
  __webpack_require__("ZQhR")
}
var PublishPage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PublishPage___vue_template_functional__ = false
/* styles */
var PublishPage___vue_styles__ = PublishPage_injectStyle
/* scopeId */
var PublishPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PublishPage___vue_module_identifier__ = null
var PublishPage_Component = PublishPage_normalizeComponent(
  PublishPage,
  components_PublishPage,
  PublishPage___vue_template_functional__,
  PublishPage___vue_styles__,
  PublishPage___vue_scopeId__,
  PublishPage___vue_module_identifier__
)

/* harmony default export */ var src_components_PublishPage = (PublishPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobilePage.vue

//
//
//
//
//
//
//



/* harmony default export */ var MobilePage = ({
  name: 'kpMobilePage',
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentMobilePage', 'mobilePageContent']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3190bf5a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobilePage.vue
var MobilePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mobile-page",class:_vm.currentMobilePage.cssClass},[_c('header',{staticClass:"mobile-header",domProps:{"textContent":_vm._s(_vm.currentMobilePage.title)}}),_vm._v(" "),_c('article',{staticClass:"mobile-content",domProps:{"innerHTML":_vm._s(_vm.mobilePageContent(_vm.currentMobilePage))}})])}
var MobilePage_staticRenderFns = []
var MobilePage_esExports = { render: MobilePage_render, staticRenderFns: MobilePage_staticRenderFns }
/* harmony default export */ var mobile_MobilePage = (MobilePage_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobilePage.vue
function MobilePage_injectStyle (ssrContext) {
  __webpack_require__("QkI9")
}
var MobilePage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobilePage___vue_template_functional__ = false
/* styles */
var MobilePage___vue_styles__ = MobilePage_injectStyle
/* scopeId */
var MobilePage___vue_scopeId__ = "data-v-3190bf5a"
/* moduleIdentifier (server only) */
var MobilePage___vue_module_identifier__ = null
var MobilePage_Component = MobilePage_normalizeComponent(
  MobilePage,
  mobile_MobilePage,
  MobilePage___vue_template_functional__,
  MobilePage___vue_styles__,
  MobilePage___vue_scopeId__,
  MobilePage___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobilePage = (MobilePage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileNavigationBar.vue

//
//
//
//
//
//
//




/* harmony default export */ var MobileNavigationBar = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['title', 'companyLogo', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-772adcfe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileNavigationBar.vue
var MobileNavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar",attrs:{"id":"mobile-nav-bar"},on:{"click":_vm.toggleContents}},[_c('img',{attrs:{"id":"mobile-nav-bar__logo","src":_vm.companyLogo}}),_vm._v(" "),_c('div',{staticClass:"nav-menu-button",attrs:{"id":"mobile-nav-button"}},[_c('feather-icon',{attrs:{"icon":"menu"}})],1)])}
var MobileNavigationBar_staticRenderFns = []
var MobileNavigationBar_esExports = { render: MobileNavigationBar_render, staticRenderFns: MobileNavigationBar_staticRenderFns }
/* harmony default export */ var mobile_MobileNavigationBar = (MobileNavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileNavigationBar.vue
function MobileNavigationBar_injectStyle (ssrContext) {
  __webpack_require__("WN8W")
}
var MobileNavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileNavigationBar___vue_template_functional__ = false
/* styles */
var MobileNavigationBar___vue_styles__ = MobileNavigationBar_injectStyle
/* scopeId */
var MobileNavigationBar___vue_scopeId__ = "data-v-772adcfe"
/* moduleIdentifier (server only) */
var MobileNavigationBar___vue_module_identifier__ = null
var MobileNavigationBar_Component = MobileNavigationBar_normalizeComponent(
  MobileNavigationBar,
  mobile_MobileNavigationBar,
  MobileNavigationBar___vue_template_functional__,
  MobileNavigationBar___vue_styles__,
  MobileNavigationBar___vue_scopeId__,
  MobileNavigationBar___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileNavigationBar = (MobileNavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileMenu.vue

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MobileMenu = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['mobilePages', 'mobilePageLink', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba2690a0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileMenu.vue
var MobileMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showContents)?_c('div',{attrs:{"id":"mobile-menu"}},[_c('ul',{attrs:{"id":"mobile-list"}},_vm._l((_vm.mobilePages),function(mobilePage,index){return (!mobilePage.hideInMenu)?_c('li',{key:index,on:{"click":_vm.toggleContents}},[_c('router-link',{attrs:{"to":_vm.mobilePageLink(mobilePage)}},[_vm._v(_vm._s(mobilePage.title))])],1):_vm._e()}))]):_vm._e()}
var MobileMenu_staticRenderFns = []
var MobileMenu_esExports = { render: MobileMenu_render, staticRenderFns: MobileMenu_staticRenderFns }
/* harmony default export */ var mobile_MobileMenu = (MobileMenu_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileMenu.vue
function MobileMenu_injectStyle (ssrContext) {
  __webpack_require__("NZMO")
}
var MobileMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileMenu___vue_template_functional__ = false
/* styles */
var MobileMenu___vue_styles__ = MobileMenu_injectStyle
/* scopeId */
var MobileMenu___vue_scopeId__ = "data-v-ba2690a0"
/* moduleIdentifier (server only) */
var MobileMenu___vue_module_identifier__ = null
var MobileMenu_Component = MobileMenu_normalizeComponent(
  MobileMenu,
  mobile_MobileMenu,
  MobileMenu___vue_template_functional__,
  MobileMenu___vue_styles__,
  MobileMenu___vue_scopeId__,
  MobileMenu___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileMenu = (MobileMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var MobileContainer = ({
  components: {
    MobilePage: components_mobile_MobilePage,
    MobileNavigationBar: components_mobile_MobileNavigationBar,
    MobileMenu: components_mobile_MobileMenu
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['nextMobilePage', 'previousMobilePage', 'currentMobilePage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a441386","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileContainer.vue
var MobileContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mobile-container"}},[_c('mobile-navigation-bar'),_vm._v(" "),(_vm.currentMobilePage)?_c('mobile-page'):_vm._e(),_vm._v(" "),_c('mobile-menu'),_vm._v(" "),_c('div',{staticClass:"nav-buttons",attrs:{"id":"navButtons"}},[(_vm.previousMobilePage)?_c('button',{staticClass:"advert-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnPrev","onclick":"Publish.goToPreviousMobilePage();"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('button',{staticClass:"aqua-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnNext","onclick":"Publish.goToNextMobilePage();"}}):_vm._e()])],1)}
var MobileContainer_staticRenderFns = []
var MobileContainer_esExports = { render: MobileContainer_render, staticRenderFns: MobileContainer_staticRenderFns }
/* harmony default export */ var mobile_MobileContainer = (MobileContainer_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileContainer.vue
function MobileContainer_injectStyle (ssrContext) {
  __webpack_require__("oPvi")
}
var MobileContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileContainer___vue_template_functional__ = false
/* styles */
var MobileContainer___vue_styles__ = MobileContainer_injectStyle
/* scopeId */
var MobileContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileContainer___vue_module_identifier__ = null
var MobileContainer_Component = MobileContainer_normalizeComponent(
  MobileContainer,
  mobile_MobileContainer,
  MobileContainer___vue_template_functional__,
  MobileContainer___vue_styles__,
  MobileContainer___vue_scopeId__,
  MobileContainer___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileContainer = (MobileContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LanguagesPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LanguagesPanel = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['languages']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c0d9e23","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguagesPanel.vue
var LanguagesPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"languages-fade"}},[_c('nav',{staticClass:"languages-panel"},[_c('ul',{staticClass:"languages-list"},_vm._l((_vm.languages),function(language,index){return _c('li',{key:index,staticClass:"languages-item"},[_c('a',{attrs:{"rel":"alternate","href":language.href,"target":"_blank"}},[_vm._v(_vm._s(language.code))])])}))])])}
var LanguagesPanel_staticRenderFns = []
var LanguagesPanel_esExports = { render: LanguagesPanel_render, staticRenderFns: LanguagesPanel_staticRenderFns }
/* harmony default export */ var components_LanguagesPanel = (LanguagesPanel_esExports);
// CONCATENATED MODULE: ./src/components/LanguagesPanel.vue
function LanguagesPanel_injectStyle (ssrContext) {
  __webpack_require__("i9d8")
}
var LanguagesPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var LanguagesPanel___vue_template_functional__ = false
/* styles */
var LanguagesPanel___vue_styles__ = LanguagesPanel_injectStyle
/* scopeId */
var LanguagesPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LanguagesPanel___vue_module_identifier__ = null
var LanguagesPanel_Component = LanguagesPanel_normalizeComponent(
  LanguagesPanel,
  components_LanguagesPanel,
  LanguagesPanel___vue_template_functional__,
  LanguagesPanel___vue_styles__,
  LanguagesPanel___vue_scopeId__,
  LanguagesPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_LanguagesPanel = (LanguagesPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/EditionsPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var EditionsPanel = ({
  // components: {
  //   EditionsJson
  // },
  computed: extends_default()({
    editions_data: function editions_data() {
      if (window.editions_data && window.editions_data.length) {
        return window.editions_data;
      } else {
        return editions;
      }
    }
  }, Object(vuex_esm["e" /* mapState */])({
    currentLanguage: function currentLanguage(state) {
      return state.document.currentLanguage;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['currentLanguage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dd022a4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditionsPanel.vue
var EditionsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"editions-fade"}},[_c('nav',{staticClass:"editions-panel"},[_c('ul',{staticClass:"editions-list"},_vm._l((_vm.editions_data),function(edition,index){return _c('li',{key:index,staticClass:"editions-item"},[_c('a',{attrs:{"rel":"alternate","href":edition.href + _vm.currentLanguage.toLowerCase(),"target":"_blank"}},[_vm._v(_vm._s(edition.code))])])}))])])}
var EditionsPanel_staticRenderFns = []
var EditionsPanel_esExports = { render: EditionsPanel_render, staticRenderFns: EditionsPanel_staticRenderFns }
/* harmony default export */ var components_EditionsPanel = (EditionsPanel_esExports);
// CONCATENATED MODULE: ./src/components/EditionsPanel.vue
function EditionsPanel_injectStyle (ssrContext) {
  __webpack_require__("uDJ7")
}
var EditionsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var EditionsPanel___vue_template_functional__ = false
/* styles */
var EditionsPanel___vue_styles__ = EditionsPanel_injectStyle
/* scopeId */
var EditionsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var EditionsPanel___vue_module_identifier__ = null
var EditionsPanel_Component = EditionsPanel_normalizeComponent(
  EditionsPanel,
  components_EditionsPanel,
  EditionsPanel___vue_template_functional__,
  EditionsPanel___vue_styles__,
  EditionsPanel___vue_scopeId__,
  EditionsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_EditionsPanel = (EditionsPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var NavigationBar = ({
  data: function data() {
    return {
      editions: []
    };
  },

  props: ["logoURL", "title", "page", "companyName", "width"],
  components: {
    FeatherIcon: src_components_FeatherIcon,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel
  },
  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "editionsEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "rightToLeft", "companyLogo", "downloadPath", "showContents", "showLanguages", "showEditions", "showSearch", "showGuide", "isZoomed", "isMobile", "mobileSwitch", "currentMobilePage"]), {
    divider: function divider() {
      if (this.rightToLeft) return "chevron-left";
      return "chevron-right";
    }
  }),
  mounted: function mounted() {
    this.loadEditionsScript();
  },

  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS",
    toggleLanguages: "TOGGLE_LANGUAGES",
    toggleEditions: "TOGGLE_EDITIONS",
    toggleZoom: "TOGGLE_ZOOM",
    toggleSearch: "TOGGLE_SEARCH",
    toggleGuide: "TOGGLE_GUIDE",
    toggleReader: "TOGGLE_READER"
  }), {
    loadEditionsScript: function loadEditionsScript() {
      var editionsJson = document.createElement('script');
      editionsJson.setAttribute('src', 'https://touchline-uefa.s3-eu-west-1.amazonaws.com/editions.js');
      document.head.appendChild(editionsJson);
      this.editions = editionsJson;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36923708","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationBar.vue
var NavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"nav-bar"},[_c('div',{staticClass:"nav-bar__container"},[_c('div',{staticClass:"nav-bar__logo"},[_c('img',{staticClass:"nav-bar__logo-image",attrs:{"src":_vm.companyLogo,"alt":_vm.companyName}})]),_vm._v(" "),_c('div',{staticClass:"nav-bar__text"},[_c('span',{staticClass:"nav-bar__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__divider"},[_c('feather-icon',{attrs:{"icon":_vm.divider}})],1):_vm._e(),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__page"},[_vm._v(_vm._s(_vm.page))]):_vm._e()]),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && !_vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Reader is available")]):_vm._e(),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && _vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Return to magazine")]):_vm._e(),_vm._v(" "),_c('nav',{staticClass:"nav-bar__links"},[_c('ul',[(!((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader))?[(_vm.guideEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showGuide},on:{"click":_vm.toggleGuide}},[_c('feather-icon',{attrs:{"icon":"help-circle"},on:{"click":_vm.toggleGuide}})],1):_vm._e(),_vm._v(" "),((_vm.zoomEnabled && (!_vm.isMobile)))?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.isZoomed},on:{"click":_vm.toggleZoom}},[_c('feather-icon',{attrs:{"icon":"zoom-in"},on:{"click":_vm.toggleZoom}})],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showSearch},on:{"click":_vm.toggleSearch}},[_c('feather-icon',{attrs:{"icon":"search"}})],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showLanguages},on:{"click":_vm.toggleLanguages}},[_c('feather-icon',{attrs:{"icon":"globe"}}),_vm._v(" "),_c('languages-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLanguages),expression:"showLanguages"}]})],1):_vm._e(),_vm._v(" "),(_vm.editionsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showEditions},on:{"click":_vm.toggleEditions}},[_c('feather-icon',{attrs:{"icon":"book"}}),_vm._v(" "),_c('editions-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showEditions),expression:"showEditions"}]})],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('a',{attrs:{"href":_vm.downloadPath,"target":"_blank","download":""}},[_c('feather-icon',{attrs:{"icon":"download"}})],1)]):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('feather-icon',{attrs:{"icon":"printer"}})],1):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"grid"}})],1):_vm._e()],2)])])])}
var NavigationBar_staticRenderFns = []
var NavigationBar_esExports = { render: NavigationBar_render, staticRenderFns: NavigationBar_staticRenderFns }
/* harmony default export */ var components_NavigationBar = (NavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/NavigationBar.vue
function NavigationBar_injectStyle (ssrContext) {
  __webpack_require__("eJtY")
}
var NavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationBar___vue_template_functional__ = false
/* styles */
var NavigationBar___vue_styles__ = NavigationBar_injectStyle
/* scopeId */
var NavigationBar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationBar___vue_module_identifier__ = null
var NavigationBar_Component = NavigationBar_normalizeComponent(
  NavigationBar,
  components_NavigationBar,
  NavigationBar___vue_template_functional__,
  NavigationBar___vue_styles__,
  NavigationBar___vue_scopeId__,
  NavigationBar___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationBar = (NavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationLink.vue
//
//
//
//
//
//



/* harmony default export */ var NavigationLink = ({
  props: ['to', 'rotation', 'color', 'classes'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74b6e97a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationLink.vue
var NavigationLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes},[_c('router-link',{attrs:{"to":_vm.to}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)],1)}
var NavigationLink_staticRenderFns = []
var NavigationLink_esExports = { render: NavigationLink_render, staticRenderFns: NavigationLink_staticRenderFns }
/* harmony default export */ var components_NavigationLink = (NavigationLink_esExports);
// CONCATENATED MODULE: ./src/components/NavigationLink.vue
function NavigationLink_injectStyle (ssrContext) {
  __webpack_require__("Pg37")
}
var NavigationLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationLink___vue_template_functional__ = false
/* styles */
var NavigationLink___vue_styles__ = NavigationLink_injectStyle
/* scopeId */
var NavigationLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationLink___vue_module_identifier__ = null
var NavigationLink_Component = NavigationLink_normalizeComponent(
  NavigationLink,
  components_NavigationLink,
  NavigationLink___vue_template_functional__,
  NavigationLink___vue_styles__,
  NavigationLink___vue_scopeId__,
  NavigationLink___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationLink = (NavigationLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MobileLink.vue
//
//
//
//
//
//



/* harmony default export */ var MobileLink = ({
  props: ['to', 'rotation', 'color', 'classes', 'click'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48277a17","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileLink.vue
var MobileLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes,on:{"click":_vm.click}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)}
var MobileLink_staticRenderFns = []
var MobileLink_esExports = { render: MobileLink_render, staticRenderFns: MobileLink_staticRenderFns }
/* harmony default export */ var components_MobileLink = (MobileLink_esExports);
// CONCATENATED MODULE: ./src/components/MobileLink.vue
function MobileLink_injectStyle (ssrContext) {
  __webpack_require__("EUPG")
}
var MobileLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileLink___vue_template_functional__ = false
/* styles */
var MobileLink___vue_styles__ = MobileLink_injectStyle
/* scopeId */
var MobileLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileLink___vue_module_identifier__ = null
var MobileLink_Component = MobileLink_normalizeComponent(
  MobileLink,
  components_MobileLink,
  MobileLink___vue_template_functional__,
  MobileLink___vue_styles__,
  MobileLink___vue_scopeId__,
  MobileLink___vue_module_identifier__
)

/* harmony default export */ var src_components_MobileLink = (MobileLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentItem.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ContentItem = ({
  props: ['page', 'index'],
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'basePath', 'currentPage'])),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['goToPage']), Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS"
  }), {

    getBackgroundURL: function getBackgroundURL(index, sectionIndex) {
      if (sectionIndex == 0) {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '.png)';
      } else {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '-' + (sectionIndex + 1) + '.png)';
      }
    },

    toggleExpanded: function toggleExpanded(index) {
      this.isExpanded = !this.isExpanded;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-883f7ca2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentItem.vue
var ContentItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"contents-item"},[_c('div',{staticClass:"contents-item__section",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == 0}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1))]),_vm._v(" "),_c('p',{staticClass:"contents-item__text--title"},[_vm._v(_vm._s(_vm.page[0].title))]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"content-item__chevrons"},[_c('div',{staticClass:"contents-item__expander",on:{"click":function($event){_vm.toggleExpanded(_vm.index)}}},[(_vm.isExpanded)?_c('feather-icon',{attrs:{"icon":"chevron-up"}}):_c('feather-icon',{attrs:{"icon":"chevron-down"}})],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}})]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"contents-item__sections",class:{'collapsed': !_vm.isExpanded}},_vm._l((_vm.page),function(section,sectionIndex){return (sectionIndex != 0)?_c('div',{key:(_vm.index+1) + '-' + (sectionIndex + 1),staticClass:"contents-item__subsection",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == sectionIndex}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]),_vm._v(" "),_c('div',{staticClass:"contents-section__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, sectionIndex)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}})]):_vm._e()})):_vm._e()])}
var ContentItem_staticRenderFns = []
var ContentItem_esExports = { render: ContentItem_render, staticRenderFns: ContentItem_staticRenderFns }
/* harmony default export */ var components_ContentItem = (ContentItem_esExports);
// CONCATENATED MODULE: ./src/components/ContentItem.vue
function ContentItem_injectStyle (ssrContext) {
  __webpack_require__("T53c")
}
var ContentItem_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentItem___vue_template_functional__ = false
/* styles */
var ContentItem___vue_styles__ = ContentItem_injectStyle
/* scopeId */
var ContentItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentItem___vue_module_identifier__ = null
var ContentItem_Component = ContentItem_normalizeComponent(
  ContentItem,
  components_ContentItem,
  ContentItem___vue_template_functional__,
  ContentItem___vue_styles__,
  ContentItem___vue_scopeId__,
  ContentItem___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentItem = (ContentItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentsPanel.vue

//
//
//
//
//
//
//
//
//





/* harmony default export */ var ContentsPanel = ({
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon,
    ContentItem: src_components_ContentItem
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'basePath', 'currentPage', 'showContents']))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14d3008a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentsPanel.vue
var ContentsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('nav',{staticClass:"contents-panel"},[_c('ul',{staticClass:"contents-list"},_vm._l((_vm.pages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})}))])])}
var ContentsPanel_staticRenderFns = []
var ContentsPanel_esExports = { render: ContentsPanel_render, staticRenderFns: ContentsPanel_staticRenderFns }
/* harmony default export */ var components_ContentsPanel = (ContentsPanel_esExports);
// CONCATENATED MODULE: ./src/components/ContentsPanel.vue
function ContentsPanel_injectStyle (ssrContext) {
  __webpack_require__("U2l4")
}
var ContentsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentsPanel___vue_template_functional__ = false
/* styles */
var ContentsPanel___vue_styles__ = ContentsPanel_injectStyle
/* scopeId */
var ContentsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentsPanel___vue_module_identifier__ = null
var ContentsPanel_Component = ContentsPanel_normalizeComponent(
  ContentsPanel,
  components_ContentsPanel,
  ContentsPanel___vue_template_functional__,
  ContentsPanel___vue_styles__,
  ContentsPanel___vue_scopeId__,
  ContentsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentsPanel = (ContentsPanel_Component.exports);

// CONCATENATED MODULE: ./src/helpers/modules/trackingHandler.js
/* harmony default export */ var trackingHandler = ({
  init: function init() {
    // Events

    //External Links clicked
    document.addEventListener('click', this.trackOutboundLinks, false);
    //Video Played
    //https://medium.com/@matt_west/track-html5-video-events-using-google-analytics-and-javascript-3be691b8bd45

  },
  trackOutboundLinks: function trackOutboundLinks(event) {
    if (event.target.tagName != 'A') return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Outbound Link',
        eventAction: 'Click',
        eventLabel: event.target.href,
        transport: 'beacon'
      });
    }
  },
  trackSearchTerms: function trackSearchTerms(searchTerm) {
    if (searchTerm == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Search',
        eventAction: 'Search',
        eventLabel: searchTerm
      });
    }
  },
  trackVideoPlay: function trackVideoPlay(filename) {
    if (filename == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Video',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  },
  trackAudioPlay: function trackAudioPlay(filename) {
    if (filename == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Audio',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SearchPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var SearchPanel = ({
  // TODO Highlight search text */

  data: function data() {
    return {
      searchText: '',
      searchResults: [],
      noResults: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'rightToLeft', 'basePath'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleSearch: 'TOGGLE_SEARCH'
  }), Object(vuex_esm["b" /* mapActions */])(['goToPage']), {
    // getBackgroundURL: (index) => "url(/static/_thumbs/"+(index)+"="+1+"-w140-h105.png)",
    // getBackgroundURL: (background) => 'url(/static/_content/'+ background +')',
    getBackgroundURL: function getBackgroundURL(background) {
      return this.basePath + '/static/_thumbs/' + background + '.png';
    },
    search: function search() {
      this.noResults = false;
      trackingHandler.trackSearchTerms(this.searchText);
      this.searchResults = window.search.search(this.searchText);
      if (this.searchResults.length == 0) {
        this.noResults = true;
      }
    },
    goToResultPage: function goToResultPage(pageIndex, sectionIndex) {
      this.goToPage({ pageIndex: pageIndex, sectionIndex: sectionIndex });
      this.toggleSearch();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05e5c2ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchPanel.vue
var SearchPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"search-fade"}},[_c('div',{staticClass:"search-container"},[_c('div',{staticClass:"search-panel"},[_c('div',{staticClass:"search-bar"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"search-input",attrs:{"type":"text","placeholder":"Search Publication"},domProps:{"value":(_vm.searchText)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"search-button",on:{"click":_vm.search}},[_c('feather-icon',{attrs:{"icon":"search"}})],1)]),_vm._v(" "),_c('transition-group',{staticClass:"search-results",attrs:{"name":"list","tag":"ul"}},_vm._l((_vm.searchResults),function(searchResult){return _c('li',{key:searchResult.id,staticClass:"search-result",on:{"click":function($event){_vm.goToResultPage(searchResult.pageIndex, searchResult.sectionIndex)}}},[_c('img',{staticClass:"search-result__image",attrs:{"src":_vm.getBackgroundURL(searchResult.thumb),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"search-result__text"},[_c('div',{staticClass:"search-result__title"},[_vm._v("\n            "+_vm._s(searchResult.id)+". "+_vm._s(searchResult.title)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"search-result__body"},[_vm._v("\n            "+_vm._s(searchResult.body)+"\n          ")])])])})),_vm._v(" "),(_vm.noResults)?_c('div',{attrs:{"id":"noResultsContainer"}},[_c('h2',[_vm._v("No results found. Please try again")])]):_vm._e()],1)])])}
var SearchPanel_staticRenderFns = []
var SearchPanel_esExports = { render: SearchPanel_render, staticRenderFns: SearchPanel_staticRenderFns }
/* harmony default export */ var components_SearchPanel = (SearchPanel_esExports);
// CONCATENATED MODULE: ./src/components/SearchPanel.vue
function SearchPanel_injectStyle (ssrContext) {
  __webpack_require__("V6ic")
}
var SearchPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SearchPanel___vue_template_functional__ = false
/* styles */
var SearchPanel___vue_styles__ = SearchPanel_injectStyle
/* scopeId */
var SearchPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SearchPanel___vue_module_identifier__ = null
var SearchPanel_Component = SearchPanel_normalizeComponent(
  SearchPanel,
  components_SearchPanel,
  SearchPanel___vue_template_functional__,
  SearchPanel___vue_styles__,
  SearchPanel___vue_scopeId__,
  SearchPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_SearchPanel = (SearchPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ExternalResource.vue
//
//
//
//

/* harmony default export */ var ExternalResource = ({
  props: ['source']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1f72b0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExternalResource.vue
var ExternalResource_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('script',{attrs:{"type":"application/javascript","src":_vm.source}})}
var ExternalResource_staticRenderFns = []
var ExternalResource_esExports = { render: ExternalResource_render, staticRenderFns: ExternalResource_staticRenderFns }
/* harmony default export */ var components_ExternalResource = (ExternalResource_esExports);
// CONCATENATED MODULE: ./src/components/ExternalResource.vue
var ExternalResource_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ExternalResource___vue_template_functional__ = false
/* styles */
var ExternalResource___vue_styles__ = null
/* scopeId */
var ExternalResource___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ExternalResource___vue_module_identifier__ = null
var ExternalResource_Component = ExternalResource_normalizeComponent(
  ExternalResource,
  components_ExternalResource,
  ExternalResource___vue_template_functional__,
  ExternalResource___vue_styles__,
  ExternalResource___vue_scopeId__,
  ExternalResource___vue_module_identifier__
)

/* harmony default export */ var src_components_ExternalResource = (ExternalResource_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PageDots.vue

//
//
//
//
//
//



/* harmony default export */ var PageDots = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentPages', 'width', 'height', 'zeroedPageIndex', 'zeroedSectionIndex', 'rightToLeft']), {
    styleObject: function styleObject() {
      var xTranslation = -(this.width / 2 + 20);
      var yTranslation = -(this.height / 2 - 5);
      if (this.rightToLeft) {
        xTranslation = this.width / 2;
      }
      return {
        transform: 'translate(' + xTranslation + 'px, ' + yTranslation + 'px)',
        width: '20px'
      };
    }
  }),
  methods: {
    activePage: function activePage(page) {
      if (this.zeroedPageIndex == page.pageIndex && this.zeroedSectionIndex == page.sectionIndex) return true;
      return false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-745923cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageDots.vue
var PageDots_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-dots",style:(_vm.styleObject)},_vm._l((_vm.currentPages),function(page,index){return _c('div',{key:index,staticClass:"page-dot",class:{'page-dot--active': _vm.activePage(page)}})}))}
var PageDots_staticRenderFns = []
var PageDots_esExports = { render: PageDots_render, staticRenderFns: PageDots_staticRenderFns }
/* harmony default export */ var components_PageDots = (PageDots_esExports);
// CONCATENATED MODULE: ./src/components/PageDots.vue
function PageDots_injectStyle (ssrContext) {
  __webpack_require__("pXbK")
}
var PageDots_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PageDots___vue_template_functional__ = false
/* styles */
var PageDots___vue_styles__ = PageDots_injectStyle
/* scopeId */
var PageDots___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageDots___vue_module_identifier__ = null
var PageDots_Component = PageDots_normalizeComponent(
  PageDots,
  components_PageDots,
  PageDots___vue_template_functional__,
  PageDots___vue_styles__,
  PageDots___vue_scopeId__,
  PageDots___vue_module_identifier__
)

/* harmony default export */ var src_components_PageDots = (PageDots_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/VideoContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var VideoContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['videoURL', 'isDoublePage']), {
    isYoutube: function isYoutube() {
      return this.videoURL.search('youtube') !== -1;
    },
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22bcc19e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoContainer.vue
var VideoContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[(_vm.isYoutube)?_c('div',{attrs:{"id":"video-container"}},[_c('div',{staticClass:"embed-container"},[_c('iframe',{attrs:{"id":"video","width":"854","height":"480","src":_vm.videoURL,"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2):_c('div',{attrs:{"id":"video-container"}},[_c('video',{attrs:{"id":"video","src":_vm.videoURL,"autoplay":"","controls":"controls","width":"967","height":"544"}},[_c('source',{attrs:{"src":_vm.videoURL,"type":"video/mp4"}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var VideoContainer_staticRenderFns = []
var VideoContainer_esExports = { render: VideoContainer_render, staticRenderFns: VideoContainer_staticRenderFns }
/* harmony default export */ var components_VideoContainer = (VideoContainer_esExports);
// CONCATENATED MODULE: ./src/components/VideoContainer.vue
function VideoContainer_injectStyle (ssrContext) {
  __webpack_require__("Zf2O")
}
var VideoContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var VideoContainer___vue_template_functional__ = false
/* styles */
var VideoContainer___vue_styles__ = VideoContainer_injectStyle
/* scopeId */
var VideoContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var VideoContainer___vue_module_identifier__ = null
var VideoContainer_Component = VideoContainer_normalizeComponent(
  VideoContainer,
  components_VideoContainer,
  VideoContainer___vue_template_functional__,
  VideoContainer___vue_styles__,
  VideoContainer___vue_scopeId__,
  VideoContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_VideoContainer = (VideoContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GalleryContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GalleryContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["galleryImages", "galleryCaptions", "basePath", "galleryIndex", "isDoublePage"]), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    nextOptions: function nextOptions() {
      return {
        width: 50,
        height: 50
      };
    },
    prevOptions: function prevOptions() {
      return {
        class: "r180",
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobileNextOptions: function mobileNextOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobilePrevOptions: function mobilePrevOptions() {
      return {
        class: "r180",
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10484467","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GalleryContainer.vue
var GalleryContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"gallery-container"}},[(_vm.isDoublePage)?[_c('feather-icon',{attrs:{"id":"gallery-next","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.nextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.prevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('feather-icon',{attrs:{"id":"gallery-next-mobile","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.mobileNextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous-mobile","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.mobilePrevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close-mobile","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)],_vm._v(" "),_vm._l((_vm.galleryImages),function(image,index){return _c('img',{class:{'active': index == _vm.galleryIndex, 'inactive': index != _vm.galleryIndex},attrs:{"src":_vm.basePath + '/static/_content/' + image,"alt":""}})}),_vm._v(" "),_c('div',{staticClass:"gallery-captions"},[(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])?_c('p',{staticClass:"gallery-caption"},[_vm._v("\n        "+_vm._s(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"gallery-dots"},_vm._l((_vm.galleryImages),function(image,index){return _c('div',{staticClass:"gallery-dot",class:{'gallery-dot--active': index == _vm.galleryIndex}})}))],2)])}
var GalleryContainer_staticRenderFns = []
var GalleryContainer_esExports = { render: GalleryContainer_render, staticRenderFns: GalleryContainer_staticRenderFns }
/* harmony default export */ var components_GalleryContainer = (GalleryContainer_esExports);
// CONCATENATED MODULE: ./src/components/GalleryContainer.vue
function GalleryContainer_injectStyle (ssrContext) {
  __webpack_require__("S4/L")
}
var GalleryContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GalleryContainer___vue_template_functional__ = false
/* styles */
var GalleryContainer___vue_styles__ = GalleryContainer_injectStyle
/* scopeId */
var GalleryContainer___vue_scopeId__ = "data-v-10484467"
/* moduleIdentifier (server only) */
var GalleryContainer___vue_module_identifier__ = null
var GalleryContainer_Component = GalleryContainer_normalizeComponent(
  GalleryContainer,
  components_GalleryContainer,
  GalleryContainer___vue_template_functional__,
  GalleryContainer___vue_styles__,
  GalleryContainer___vue_scopeId__,
  GalleryContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GalleryContainer = (GalleryContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GuideContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GuideContainer = ({
    name: 'guide',
    components: {
        FeatherIcon: src_components_FeatherIcon
    },
    computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
        sectionIndices: function sectionIndices(state) {
            return state.sectionIndices;
        }
    }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "isMobile"]))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c172f84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GuideContainer.vue
var GuideContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"guide-container"}},[_c('div',{attrs:{"id":"guide-page"}},[_c('div',{staticClass:"guide-title"},[_c('h4',[_vm._v("User Guide")])]),_vm._v(" "),_c('ul',{staticClass:"guide-items"},[_c('li',[_c('div',[_c('feather-icon',{staticClass:"guide-icons guide-navigation-prev",attrs:{"icon":"play"}}),_vm._v(" "),(_vm.isMobile && !(_vm.sectionIndices.length == 0))?_c('feather-icon',{staticClass:"guide-icons guide-navigation-down",attrs:{"icon":"play"}}):_vm._e(),_vm._v(" "),_c('feather-icon',{staticClass:"guide-icons guide-navigation-next",attrs:{"icon":"play"}})],1),_vm._v(" "),(_vm.isMobile)?_c('p',[_vm._v("Navigate using the arrows or by swiping")]):_c('p',[_vm._v("Navigate using arrows, your keyboard or by dragging the page")])]),_vm._v(" "),(_vm.zoomEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"zoom-in"}}),_vm._v(" "),_c('p',[_vm._v("Zoom in and out")])],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"search"}}),_vm._v(" "),_c('p',[_vm._v("Search for words or phrases")])],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"globe"}}),_vm._v(" "),_c('p',[_vm._v("Change language")])],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"download"}}),_vm._v(" "),_c('p',[_vm._v("Download PDF")])],1):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"printer"}}),_vm._v(" "),_c('p',[_vm._v("Print PDF")])],1):_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"grid"}}),_vm._v(" "),_c('p',[_vm._v("Content navigation")])],1):_vm._e(),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"viewBox":"0 0 160.62 157.733","enable-background":"new 0 0 160.62 157.733"}},[_c('g',[_c('path',{attrs:{"fill":"#000","d":"M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477\n                            c-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218\n                            c-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945\n                            h85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2\n                            c-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z\n                            M123.685,63.134h-20.209v-5.966h20.209V63.134z"}})]),_vm._v(" "),_c('g',[_c('path',{attrs:{"fill":"#000","d":"M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633\n                            c-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29\n                            c-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026\n                            c0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471\n                            c6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404\n                            c3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7\n                            c-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0\n                            C70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648\n                            c-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694\n                            c6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2\n                            c14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856\n                            L154.856,78.867z"}})])]),_vm._v(" "),_c('p',[_vm._v("Image gallery")])]),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"675px","height":"675px","viewBox":"0 0 675 675","enable-background":"new 0 0 675 675","xml:space":"preserve"}},[_c('circle',{attrs:{"fill":"none","stroke":"#000","stroke-width":"30","stroke-miterlimit":"10","cx":"339.195","cy":"340","r":"321"}}),_vm._v(" "),_c('polyline',{attrs:{"fill":"#000","points":"558,356 207,563 207,117 "}})]),_vm._v(" "),_c('p',[_vm._v("Video")])]),_vm._v(" "),(_vm.guideEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"help-circle"}}),_vm._v(" "),_c('p',[_vm._v("User guide")])],1):_vm._e()])])])])}
var GuideContainer_staticRenderFns = []
var GuideContainer_esExports = { render: GuideContainer_render, staticRenderFns: GuideContainer_staticRenderFns }
/* harmony default export */ var components_GuideContainer = (GuideContainer_esExports);
// CONCATENATED MODULE: ./src/components/GuideContainer.vue
function GuideContainer_injectStyle (ssrContext) {
  __webpack_require__("GT0P")
}
var GuideContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GuideContainer___vue_template_functional__ = false
/* styles */
var GuideContainer___vue_styles__ = GuideContainer_injectStyle
/* scopeId */
var GuideContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var GuideContainer___vue_module_identifier__ = null
var GuideContainer_Component = GuideContainer_normalizeComponent(
  GuideContainer,
  components_GuideContainer,
  GuideContainer___vue_template_functional__,
  GuideContainer___vue_styles__,
  GuideContainer___vue_scopeId__,
  GuideContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GuideContainer = (GuideContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AudioContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var AudioContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['audioURL', 'isDoublePage']), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94cb9f4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AudioContainer.vue
var AudioContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"audio-container"}},[_c('audio',{staticStyle:{"width":"300px","height":"36px"},attrs:{"controls":"","controlsList":"nodownload","autoplay":"","preload":"metadata"}},[_c('source',{attrs:{"src":_vm.audioURL,"type":"audio/mp3"}}),_vm._v("\n      Your browser does not support the audio element.\n    ")]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"audio-close","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"audio-close-mobile","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var AudioContainer_staticRenderFns = []
var AudioContainer_esExports = { render: AudioContainer_render, staticRenderFns: AudioContainer_staticRenderFns }
/* harmony default export */ var components_AudioContainer = (AudioContainer_esExports);
// CONCATENATED MODULE: ./src/components/AudioContainer.vue
function AudioContainer_injectStyle (ssrContext) {
  __webpack_require__("BpBR")
}
var AudioContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var AudioContainer___vue_template_functional__ = false
/* styles */
var AudioContainer___vue_styles__ = AudioContainer_injectStyle
/* scopeId */
var AudioContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AudioContainer___vue_module_identifier__ = null
var AudioContainer_Component = AudioContainer_normalizeComponent(
  AudioContainer,
  components_AudioContainer,
  AudioContainer___vue_template_functional__,
  AudioContainer___vue_styles__,
  AudioContainer___vue_scopeId__,
  AudioContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_AudioContainer = (AudioContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















/* harmony default export */ var App = ({
  name: 'app',
  components: {
    PublishPage: src_components_PublishPage,
    NavigationBar: src_components_NavigationBar,
    NavigationLink: src_components_NavigationLink,
    ExternalResource: src_components_ExternalResource,
    ContentsPanel: src_components_ContentsPanel,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel,
    SearchPanel: src_components_SearchPanel,
    PageDots: src_components_PageDots,
    GalleryContainer: src_components_GalleryContainer,
    MobileContainer: components_mobile_MobileContainer,
    VideoContainer: src_components_VideoContainer,
    GuideContainer: src_components_GuideContainer,
    MobileLink: src_components_MobileLink,
    AudioContainer: src_components_AudioContainer
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['title', 'description', 'width', 'height', 'visiblePages', 'currentPage', 'previousPage', 'nextPage', 'nextNextPage', 'previousPreviousPage', 'previousPageURI', 'nextPageURI', 'previousSection', 'nextSection', 'previousSectionURI', 'nextSectionURI', 'previousMobilePage', 'nextMobilePage', 'previousMobilePageURI', 'nextMobilePageURI', 'externalResources', 'searchObject', 'pageScripts', 'documentScript', 'zoomLevel', 'pageContainerStyle', 'rightToLeft', 'isMobile', 'mobileSwitch', 'videoURL', 'showContents', 'showLanguages', 'showSearch', 'showGuide', 'showEditions', 'isZoomed', 'isIE11', 'isPhantom', 'companyLogo', 'publishURL', 'galleryImages', 'galleryCaptions', 'isDoublePage', 'audioURL'])),
  mounted: function mounted() {
    var _this = this;

    // console.log('mounted app component')
    this.setTitle();
    this.setDescription();
    if (this.publishURL != '') this.setOGImage();
    if (!(this.isMobile && this.mobileSwitch || this.isPhantom)) {
      this.loadScripts();
      window.addEventListener("load", function (event) {
        var p = parseInt(Publish.currentPage.pageIndex);
        var s = parseInt(Publish.currentPage.sectionIndex);
        if (window["p" + p + "s" + s + "onPageEnter"]) {
          window["p" + p + "s" + s + "onPageEnter"]();
        }
      });
      this.buildSearchIndex();
      this.resetSectionIndices();
    }
    if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
      this.setInitialWindowSize({
        width: screen.height,
        height: screen.width - 60
      });
      this.changeWindowSize({
        width: screen.height,
        height: screen.width - 60
      });
    } else if (document.documentElement.dataset.mobile == "android") {
      this.setInitialWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
      this.changeWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
    } else {
      this.changeWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener("orientationchange", function () {
      if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
        _this.setInitialWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
        _this.changeWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
      } else {
        _this.setInitialWindowSize({
          width: screen.width,
          height: screen.height
        });
        _this.changeWindowSize({
          width: screen.width,
          height: screen.height
        });
      }
    });
  },

  watch: {
    currentPage: function currentPage(oldPage, newPage) {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
    }
  },
  methods: extends_default()({
    setTitle: function setTitle() {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
      var meta = document.createElement('meta');
      meta.name = "og:title";
      meta.content = newTitle;
      meta.setAttribute('property', 'og:title');
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    setDescription: function setDescription() {
      var newDescription = this.description;
      if (this.currentPage.searchText && this.currentPage.searchText.length > 0) {
        newDescription = this.currentPage.searchText.substr(0, 250);
      }
      var meta = document.createElement('meta');
      meta.name = "description";
      meta.content = newDescription;
      document.getElementsByTagName('head')[0].appendChild(meta);
      var og = document.createElement('meta');
      og.name = "og:description";
      og.content = newDescription;
      og.setAttribute('property', 'og:description');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    setOGImage: function setOGImage() {
      var og = document.createElement('meta');
      og.name = "og:image";
      og.content = this.publishURL + (this.currentPage.index + 1) + '.png';
      og.setAttribute('property', 'og:image');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    buildSearchIndex: function buildSearchIndex() {
      window.search = new commonjs["Search"]('id');
      window.search.searchIndex = new commonjs["UnorderedSearchIndex"]();
      window.search.addIndex('title');
      window.search.addIndex('body');
      window.search.addDocuments(this.searchObject);
    },
    loadScripts: function loadScripts() {
      this.loadDocumentScript();
      this.loadPageScript();
      this.loadAddThis();
    },
    loadDocumentScript: function loadDocumentScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.documentScript);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadPageScript: function loadPageScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.pageScripts);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadAddThis: function loadAddThis() {
      if (!this.isMobile) {
        var addthisScript = document.createElement('script');
        addthisScript.setAttribute('src', 'https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5a2eb48d8548953f');
        document.body.appendChild(addthisScript);
      }
    }
  }, Object(vuex_esm["b" /* mapActions */])(['goToPage', 'goToNextPage', 'goToPreviousPage', 'goToNextSection', 'goToPreviousSection', 'resetSectionIndices', 'checkMobileLanding', 'goToPreviousMobilePage', 'goToNextMobilePage', 'changeWindowSize', 'setInitialWindowSize']), {
    onLeave: function onLeave(el) {
      el.style.opacity = 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f2b54d16","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{class:{'right-to-left': _vm.rightToLeft, 'mobile': _vm.isMobile, 'zoomed': _vm.isZoomed, 'mobile-switch': _vm.mobileSwitch, 'ie11': _vm.isIE11, 'reader': _vm.isReader, 'doublePage': _vm.isDoublePage},attrs:{"id":"app"}},[(_vm.isPhantom)?[_c('img',{staticClass:"logo-loading centre",attrs:{"src":_vm.companyLogo,"alt":""}})]:[_c('navigation-bar',{attrs:{"title":_vm.title,"page":_vm.currentPage.title}}),_vm._v(" "),((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader)?[_c('mobile-container'),_vm._v(" "),(_vm.isReader)?[(_vm.previousMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToPreviousMobilePage,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToNextMobilePage,"classes":"navigation-link--next"}}):_vm._e()]:_vm._e()]:[_c('transition-group',{style:(_vm.pageContainerStyle),attrs:{"name":"pages","tag":"div","id":"page-container"},on:{"leave":_vm.onLeave}},[_c('page-dots',{key:"page-dots"}),_vm._v(" "),_vm._l((_vm.visiblePages),function(page,key){return (page)?_c('publish-page',{key:page.pageIndex + 'a' + page.sectionIndex,attrs:{"classes":key,"page":page,"width":_vm.width,"height":_vm.height}}):_vm._e()})],2),_vm._v(" "),((_vm.isMobile && !_vm.isDoublePage))?void 0:[(_vm.previousPageURI)?_c('navigation-link',{attrs:{"to":_vm.previousPageURI,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.previousSectionURI)?_c('navigation-link',{attrs:{"to":_vm.previousSectionURI,"rotation":"270","classes":"navigation-link--up"}}):_vm._e(),_vm._v(" "),(_vm.nextPageURI)?_c('navigation-link',{attrs:{"to":_vm.nextPageURI,"classes":"navigation-link--next"}}):_vm._e(),_vm._v(" "),(_vm.nextSectionURI)?_c('navigation-link',{attrs:{"to":_vm.nextSectionURI,"rotation":"90","classes":"navigation-link--down"}}):_vm._e()],_vm._v(" "),_c('contents-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}]}),_vm._v(" "),_c('search-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearch),expression:"showSearch"}]}),_vm._v(" "),_c('guide-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGuide),expression:"showGuide"}]}),_vm._v(" "),_vm._l((_vm.externalResources),function(resource){return (_vm.externalResources.length > 0)?_c('external-resource',{key:resource,attrs:{"source":resource}}):_vm._e()})]],_vm._v(" "),(_vm.videoURL != '')?_c('video-container'):_vm._e(),_vm._v(" "),(_vm.galleryImages.length)?_c('gallery-container'):_vm._e(),_vm._v(" "),(_vm.audioURL !=  '')?_c('audio-container'):_vm._e()],2)])}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("tGyY")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/store/mutation-types.js
// Toggles for panels/overlays/zoom
var TOGGLE_CONTENTS = 'TOGGLE_CONTENTS';
var TOGGLE_LANGUAGES = 'TOGGLE_LANGUAGES';
var TOGGLE_GUIDE = 'TOGGLE_GUIDE';
var TOGGLE_EDITIONS = 'TOGGLE_EDITIONS';

var TOGGLE_ZOOM = 'TOGGLE_ZOOM';
var UPDATE_ZOOM = 'UPDATE_ZOOM';

var TOGGLE_SEARCH = 'TOGGLE_SEARCH';
var TOGGLE_READER = 'TOGGLE_READER';

var RESET_SECTION_INDICES = 'RESET_SECTION_INDICES';
var CHANGE_SECTION_INDEX = 'CHANGE_SECTION_INDEX';
var UPDATE_INITIAL_WINDOW_SIZE = 'UPDATE_INITIAL_WINDOW_SIZE';
var UPDATE_PAGE_SCALE = 'UPDATE_PAGE_SCALE';
var UPDATE_VIDEO_URL = 'UPDATE_VIDEO_URL';
var UPDATE_AUDIO_URL = 'UPDATE_AUDIO_URL';
var UPDATE_IS_DOUBLE_PAGE = 'UPDATE_IS_DOUBLE_PAGE';
var UPDATE_GALLERY = 'UPDATE_GALLERY';
var UPDATE_GALLERY_INDEX = 'UPDATE_GALLERY_INDEX';
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/document.js
/* harmony default export */ var src_document = ({
  "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
  "title": "Olympic Review - Issue 87",
  "shortTitle": "",
  "description": "",
  "width": 800,
  "height": 900,
  "currentLanguage": "EN",
  "languages": [{
    code: "EN",
    text: "English",
    href: "https://olympicreview.touchlines.com/87"
  }, {
    code: "FR",
    text: "French",
    href: "https://revueolympique.touchlines.com/87"
  }],
  "basePath": "/87",
  // "basePath": "",
  "companyLogo": "logo.png",
  "publishURL": "https://olympicreview.touchlines.com/87/static/_thumbs/",
  "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
  "options": {
    "doublePage": true,
    "rightToLeft": false,
    "searchEnabled": true,
    "downloadEnabled": true,
    "downloadPath": 'https://olympicreview.touchlines.com/87/static/_content/olympic-review-87.pdf',
    "printEnabled": false,
    "zoomEnabled": true,
    "contentsEnabled": true,
    "languagesEnabled": true,
    "editionsEnabled": false,
    "mobileSwitch": false,
    "guideEnabled": false,
    "galleryCaptions": {}
  },
  "pages": [[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 0,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg1.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:807px;left:660px;width:131px;height:82px;\">\n        <a href=\"https://www.olympic.org/\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n      function onPageEnter() {\n        setTimeout(function(){\n          addContentLinks();\n        }, 1000);\n      }\n\n      function onPageLeave() {\n        removeContentLinks();\n      }\n      ",
    "searchText": "OLYMPIC OFFICIAL PUBLICATION OF THE OLYMPIC MOVEMENT APRIL-MAY-JUNE 2013 NUMBER 87  THE BIG PICTURE WE TRACE THE EVOLUTION OF OLYMPIC BROADCASTING THROUGH TO THE INNOVATIVE COVERAGE OF THE LONDON 2012 GAMES, WATCHED BY 3.7 BILLION PEOPLE AROUND THE WORLD  WWW.OLYMPIC.ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 1,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg2.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 2,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg3.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 3,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg4.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLYMPIC REVIEW  CONTENTS OFFICIAL PUBLICATION OF THE OLYMPIC MOVEMENT APRIL-MAY-JUNE 2013  07 FOREWORD By IOC President Jacques Rogge.  09 SNAPSHOT Stunning sporting images from the past quarter.  13 NEWS The latest news and events from around the Olympic Movement.  24 A LIFE DEDICATED TO SPORT With the election of a new IOC President set for the 125th IOC Session in Buenos Aires in September, Olympic Review looks at how Jacques Rogge has shaped the Olympic Movement and invites the organisation’s eighth President to reflect on his time in office.  36 CLASSIC OLYMPIC IMAGES Striking images from past Olympic Games. Also on pages 38 and 48.  40 THE BROADCAST REVOLUTION We look at the remarkable growth of Olympic broadcasting through to the innovative coverage of London 2012, which was watched by a global audience of 3.7 billion people.  50 SOCHI STARS Continuing our regular series in the countdown to Sochi 2014, reigning Olympic champions Kevin Martin (curling) and Tora Berger (biathlon) reveal what helps them succeed in their sports.  54 OLYMPIC RESEARCH CORNER Anthropologist Dr. Athanase Nsengiyumva, a lecturer at the University of Burundi, looks at the difference sport can make in the social integration of children from different socio-economic backgrounds.  58 TORCH RELAY Olympic Review takes a journey down memory lane with a picture gallery showcasing some of the Olympic Torch Relays since their advent in 1936.  70 OLYMPIC SOLIDARITY We continue our focus on the IOC’s Olympic Solidarity programme and speak to two athletes who are benefiting from Olympic Scholarships.  74 MY GAMES Ethiopia’s Tirunesh Dibaba reflects on a remarkable Olympic career, which includes 5,000m and 10,000m track gold in Beijing in 2008.  78 OBITUARIES Figures from the Olympic Movement who have sadly passed away.  80 BOOK REVIEWS Our bookworms run the rule over the latest Olympic-related publications.  82 THE OLYMPIC SPIRIT Celebrating the sportsmanship of Canada’s Lawrence Lemieux.  4 OLYMPIC REVIEW"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 4,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg5.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLYMPIC REVIEW  BIZUAYEHU WAGAW EXECUTIVE BOARD President Jacques Rogge Vice-Presidents Ser Miang Ng, Thomas Bach, Nawal El Moutawakel, Craig Reedie Members John Coates, Sam Ramsamy, Gunilla Lindberg, Ching-Kuo Wu, René Fasel, Patrick Joseph Hickey, Claudia Bokel, Juan Antonio Samaranch Jr, Sergey Bubka, Willi Kaltschmitt Luján OLYMPIC REVIEW Communications Director Mark Adams Editor-in-Chief Kathleen Di Giacomo French Edition Aurélie Eichler Spanish Edition Dolores Vázquez Production Agency Touchline Production Glyn Wilmshurst, Michael Stoneman, Tom Pountney Design John Paul Yetton, Liam Yeoh Image retouching Jason Dutch Sub Editor Laura Adcock Translation Denis Echard, Laura Nadal Obrador, Ros Schwartz Proofreading Libero Language Lab ISSN: 0377-192X Printed in the UK IMAGES Cover Image Getty Images Inside IOC; IOC/ Arnaud Meylan; IOC/ Richard Juilliart; IOC/ Giulio Locatell; IOC/ Greg Martin; IOC/ Rübelt Lothar; IOC/ Jean-Jacques Strahm; IOPP/ Andrew Wong; IOPP/ Santiago Lyon; Xinhua News Agency/Wu Wei; Sochi 2014; FotoConstantini; TekhneSa; Getty Images; Canadian Olympic Committee; Comitê Olímpico Brasileiro; AFP; Jan Sukup; Vladimir Markovic  Bizuayehu Wagaw is editor-in-chief of the Ethiopian weekly national sport newspaper Inter Sport. Based in Addis Ababa, he has been following the progress of Tirunesh Dibaba since her breakthrough 5,000m victory in the IAAF World Championships in Paris in 2003. On page 74, he interviews her about a glittering Olympic career that includes three gold medals.  JOHN GOODBODY Formerly the sports news correspondent of The Times, John Goodbody has reported from 12 Summer Olympic Games. John interviewed Jacques Rogge shortly after he took the helm of the IOC and, as he nears the end of his presidency, they spoke again for Olympic Review (page 32). Among the topics discussed was the remarkable rise in sporting standards at the Games.  CONTACTS Please send your letters to: Olympic Review, IOC Department of Communications, Château de Vidy, 1007 Lausanne, Switzerland. website: www.olympic.org, email: olympicreview@olympic.org tel +41 (0)21 621 6111 fax +41 (0)21 621 6356 Olympic Review uses PEFC-certified paper stock sourced from sustainable managed forests. Olympic Review is published by the International Olympic Committee. The articles published in Olympic Review do not necessarily reflect the opinion of the International Olympic Committee. No articles may be reproduced without the permission of the IOC Department of Communications.  DETLEV SEYB German photographer Detlev Seyb has covered international rowing events since the 1990 World Rowing Championships in Tasmania, taking photographs for the International Rowing Federation (FISA), and national federations. He returned to the Sydney 2000 rowing venue to capture the image on page 10.  OLYMPIC REVIEW 5"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 5,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg6.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 6,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg7.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "PRESIDENT ROGGE FOREWORD  FOREWORD BY JACQUES ROGGE PRESIDENT, INTERNATIONAL OLYMPIC COMMITTEE  Top right Herb Elliott of Australia wins the 1,500m final at the 1960 Olympic Games in Rome in a world record time of 3:35.6  L  ike many people, my passion for the Olympic Games started as a child. Having read about this magical event as a young boy, it truly came to life for me in 1960 thanks to television coverage from Rome. I was fortunate to be living in Belgium, which was one of 18 European countries that edition of the Games was broadcast to live. Watching the screen, I was transfixed, and drew tremendous inspiration from the performances of the athletes. I clearly remember Herb Elliott, who won the 1,500m race that year by such a convincing margin that it seemed quite simply incredible. I recall him accelerating during the final stretch and, seconds later, it appeared there was no one left in the race but him. Such broadcasts of the Games had a profound effect on me and I eventually went on to represent my country three times as an Olympic sailor. I am by no means special in this regard: I cannot begin to count how many other Olympians, past and present, have told me over the years  how their own futures were shaped early on by viewing the action as I did back in 1960. The 2012 Olympic Games in London were a milestone in the history of Olympic broadcasting with more coverage available on more platforms than ever before. With 3.7 billion people watching the Games in London and an ever-increasing reach on digital platforms, broadcasting of the Olympic Games has grown to become the most significant factor in the promotion of Olympic ideals and the growth of the Games worldwide. Now we are able not only to reach billions of people around the globe, but to engage and converse with them in ways that would have seemed unimaginable a few decades ago. Indeed, Olympic broadcasting is the bedrock on which the Olympic Movement now operates. The revenue generated from global television rights has helped secure the long-term financial future of the Olympic Movement and the Games. Over 90 per cent of revenue generated by the International Olympic Committee (IOC) through its broadcast and other  partnerships is distributed throughout the Olympic Movement. Organisations receiving funding include the 204 National Olympic Committees (NOCs), which use it to support their Olympic teams and athletes, the Olympic Games Organising Committees, which use the funds to help support the staging of the Games, and the International Federations (IFs), which receive funding to promote the development of sport around the world. The Olympic Charter stipulates that the IOC must ensure the fullest coverage of the Games through different media, enabling the widest possible audience to experience the Games. It is our hope that through these channels, more people around the world will be introduced to the Olympic values and will embrace a philosophy of life that combines sport, culture and education. On a personal level, it is my hope that Olympic broadcasting will continue to inspire young people to participate in sport, and live by the Olympic ideals, just as it inspired me in 1960. ■  OLYMPIC REVIEW 7"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 7,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg8.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 8,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg9.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SNAPSHOT  24/03/2013 CURLING  Maria Wennerström of Sweden slides a stone as Christina Bertrup and Maria Prytz (far left) get ready to sweep during the gold medal match between Scotland and Sweden at the World Women’s Curling Championship in Riga, Latvia. With the scores level and one end remaining, Scotland won their second title 6-5, to add to their triumph in 2002. Photo: Getty Images"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 9,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg10.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 10,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg11.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SNAPSHOT  20/03/2013 ROWING  Rowing crews head out for an early morning training session at the Sydney International Regatta Centre in Penrith ahead of the 2013 Samsung Rowing World Cup. The course also played host to the Olympic rowing and sprint canoe events at the Olympic Games in 2000. Photo: Detlev Seyb/ myrowingphoto.com"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 11,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg12.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 12,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg13.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "THE FLOATING OLYMPIC MUSEUM REOPENS ITS DOORS FOR SUMMER  The Olympic Museum’s temporary exhibition, on board L’Helvétie, opened its doors to visitors on 27 March this year, with free admission until 20 October. Meanwhile, the brand new Olympic Museum in Lausanne, Switzerland, is scheduled to reopen to the public on 8 November 2013. The official reopening ceremony – including the handing over of the keys to the new President of the IOC and a press tour of the new Museum – will take place on 25 October. The attractive venue, open during the Museum’s 20-month renovation, displays torches, medals, mascots, models of Olympic stadiums, costumes worn during the ceremonies and archive film footage, with the “Best of” exhibition offering a retrospective of previous Olympic Games. Between April and October 2012, around 160,000 people visited the exhibition on board L’Helvétie, which is moored on the shores of Lake Geneva. Below L’Helvétie is moored in front of the Olympic Museum  COCA-COLA RECEIVES SOCHI 2014 SUSTAINABILITY AWARD Worldwide Olympic Partner Coca-Cola has been honoured with a Sochi 2014 Sustainability Award in recognition of the environmental initiatives it supported as part of International Black Sea Day. The “Clean Sea for Clean City” project, which has been running for the last four years during the build-up to next year’s Olympic Winter Games, encourages schoolchildren, students and Sochi 2014 volunteers to participate in a clean-up of the strip of beach alongside the River Sochi as part of the annual International Black Sea Day celebrations, which are held in October each year. The event, which is organised by Coca-Cola, the Sochi 2014 Organising Committee and the City of Sochi Administration, also features an educational ECO-village in the city’s main square and a roundtable  discussion, dedicated to raising environmental awareness. In 2012, the event programme also included a three-day environmental film festival, “H20-Sochi”, which was organised as part of the “Every Drop Matters” project – a joint international initiative by the UN  Development Programme and the Coca-Cola Company. The “Harmony with Nature” award was presented to CocaCola at a ceremony in Sochi on 13 March. Above Coca-Cola’s “Clean Sea for Clean City” project in Sochi  IOC LAUNCHES THIRD EDITION OF SPORT AND ENVIRONMENT AWARDS The IOC marked World Water Day (WWD) on 22 March by launching the third edition of the Sport and Environment Awards in the UN International Year of Water Cooperation. First introduced by the IOC Sport and Environment Commission in 2009, the awards recognise and celebrate the achievements of individuals, groups and organisations that have shown initiative and taken  action to drive environmental efforts and projects within their community. The award has proved to be an important stimulus for encouraging environmental awareness at local, national and global level. Nominated projects must: regard the environment as the third pillar of Olympism alongside sport, culture and education; create awareness by means of education through sport,  especially with regard to young people; harness the catalytic power of sport to engage a global audience in accepting responsibility for safeguarding the fragile ecosystems of the earth. The 2013 Awards will be presented during the 10th edition of the IOC World Conference on Sport and the Environment, which will take place in Sochi, Russia, from 30 October to 1 November 2013.  OLYMPIC REVIEW 13"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 13,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg14.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC AND FC BARCELONA JOIN FORCES  IOC President Jacques Rogge and Sandro Rosell, President of FC Barcelona, have signed a Memorandum of Understanding to mark the beginning of an official partnership between the IOC and the Foundation of one of the most successful football clubs in Europe,  supporting the setting up of joint projects that promote development through sport. Both the IOC and the FC Barcelona Foundation (FFCB) use sport as a vector for social and human development as well as a tool for educating and promoting the Olympic values of excellence, respect and friendship. By joining forces, the two organisations aim to benefit from each others’ experiences and to maximise the reach of their activities. Above IOC President Rogge with Sandro Rosell (left) and Ramón Pont (right)  2014-2016 BROADCAST RIGHTS AWARDED IN LATIN AMERICA América Móvil has acquired broadcast rights for the XXII Olympic Winter Games in Sochi, Russia, in 2014 and the Games of the XXXI Olympiad in Rio de Janeiro, Brazil, in 2016 on all media platforms across Latin America. Following the announcement of the new agreement, IOC President Jacques Rogge said: “In 2016 the Olympic Games in Rio will be a significant moment in Olympic history, and we are very pleased to have reached this important agreement to ensure fans across the continent are able to have the best broadcast experience of the Games.” IOC Finance Commission  14 OLYMPIC REVIEW  Chairman Richard Carrión, who led negotiations, said: “We are delighted to have reached this agreement with América Móvil which is a new partner for the IOC. It demonstrated a clear passion for the Olympic values and is excited about the Games coming to Latin America in 2016. The IOC negotiates broadcast rights on behalf of the Olympic Movement, and we believe this is a great deal for our stakeholders. The agreement ensures there will continue to be free Olympic Games television coverage across Latin America, but also allows viewers the choice of following the action on other media platforms as well.”  IOC COORDINATION COMMISSIONS VISIT SOCHI AND RIO The Coordination Commission for the Games in 2014 paid its ninth and penultimate visit to Sochi in March. The Commission, chaired by IOC member Jean-Claude Killy, was joined by representatives of each of the Olympic Winter Sports International Federations. During their visit, the Commission members were updated on the progress made by the Organising  Committee and its local partners, with less than one year to go until the Games. The Commission for the Rio 2016 Games paid its fourth visit to the Brazilian host city in February. Led by Nawal El Moutawakel, the Commission examined the progress made in Rio and received updates from the organisers and their partners. The Commission also visited several Olympic venues.  JEAN-CLAUDE KILLY DONATES GRENOBLE TORCH Triple Olympic gold medallist Jean-Claude Killy (pictured second from right with Francis Gabet, far left, IOC President Rogge and Christophe De Kepper, far right) has donated a torch from the Grenoble 1968 Winter Games to The Olympic Museum in Lausanne. This torch was the only one missing from The Olympic Museum’s collection.  ROGGE OPENS SAMARANCH MEMORIAL MUSEUM IN CHINA A new museum in honour of the IOC’s former President, Juan Antonio Samaranch, has opened in the People’s Republic of China. The official inauguration took place on 21 April in Tianjin in the presence of IOC President Jacques Rogge, Juan Antonio Samaranch Jr, and his sister María Teresa Samaranch, as well as many IOC members who came to pay tribute to the late IOC President, on the third anniversary of his death. The memorial will display more than 16,000 items from Samaranch’s personal collection – books, stamps, souvenirs, paintings, letters, photographs and personal items,  as well as a precious collection of texts on Olympic-related themes. “We all know what we owe to Juan Antonio Samaranch”, said President Rogge in his speech at the inauguration. “If our Movement is today strong and united, it is thanks to his visionary qualities and extraordinary talent. His knowledge of the world of sport and his deep attachment to the Olympic Movement and values were unquestionable. Juan Antonio Samaranch left us a great legacy that we must conserve and perpetuate. And this memorial is the greatest homage that we can pay to him.”"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 14,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg15.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "LIMA CONFERENCE CALLS FOR WORLD OF SPORT TO “GET MOVING”  IOC CELEBRATES INTERNATIONAL WOMEN’S DAY  The IOC Sport for All grants were also awarded at the start of the Conference to support three outstanding programmes engaged in promoting Sport for All. The three grants correspond to the three themes of the Conference. The grant on the theme of “Social benefits” was awarded to the Escuela Socio Deportiva “Martin Luther King” in Peru. This programme uses football and volleyball as a tool for social reintegration of young gang members in El Agustino, an area of Lima where most of the population lives in poverty. Started in 2003, it promotes ethical values such as team spirit respect for others and non-discrimination. Spaces for sports sites in Gansbaai, South Africa, was awarded the grant in the category of “Sports facilities and public spaces”. This is a multi-purpose sports facility situated in a multiracial area that serves as a  To celebrate International Women’s Day on 8 March, the IOC pulled together some of the greatest moments in Olympic history, featuring the most inspirational female athletes – past, present and future – in an action-packed video visible on YouTube/olympic. From the early days of the Olympic Games right through to London 2012, the amazing sporting talent women have demonstrated over the years was on show, including some familiar YOG athletes from Singapore 2010 and Innsbruck 2012. With the inclusion of women’s boxing in London 2012, women participated in every sport on the Olympic programme. In London, a record 44 per cent of the athletes were women. Another milestone was achieved when three NOCs – Saudi Arabia, Qatar and Brunei Darussalam – included women in their teams for the first time, meaning every NOC has now sent female athletes to the Games. Since 2000, the IOC has sought to recognise exceptional sports figures, decision-makers or organisations from every continent who contribute significantly to furthering the development, participation and involvement of women and girls in sport across the world. The 2013 IOC Women and Sports Awards – including five continental trophies and one world trophy – will be presented on 1 July at the IOC headquarters in Lausanne.  The 15th IOC World Conference on Sport for All came to a close with a call to action to the Olympic Movement and the world of sport to “Get Moving”. The conference, which ran from 24 to 27 April in Lima, Peru, brought together over 500 leading experts in the field of Sport for All from almost 90 countries for three days of plenary sessions, meetings and practical sessions designed to promote health, fitness and well-being by encouraging people of all ages and abilities to participate in physical activity.  catalyst for social and racial integration. The centre offers eight different sports and aims to bring about social change by inspiring and encouraging young people to make positive choices. In the category of “Partnerships”, the grant went to The Fight for Peace Global Alumni Programme in Brazil. FFP, which was initially launched in the favelas of Rio, uses boxing and martial arts to support young people affected by crime, gangs and violence. In 2007 a programme was also put in place in London. Its alumni programme was launched in 2010 as a way to transfer its methodology to cities beyond Rio and London and it is now training partner organisations present around the world. Above left IOC President Rogge and IOC member Sam Ramsamy with the Sport for All grant winners  NEW MANUAL OF SPORTS INJURIES PUBLISHED BY IOC The IOC’s Medical Commission, in conjunction with experts, has created a tool for those involved in assessing and treating athletes with injuries sustained in sport. The new publication, entitled “The IOC Manual of Sports Injuries: An Illustrated Guide to the Management of Injuries in Physical Activity”, is targeted at primary care and accident and emergency (A&E)  physicians, general physical therapists, coaches, nurses and physicians’ assistants. The book embraces a problem-oriented approach to lead the reader through the assessment and management of injuries in sport and physical activity. Covering the various parts of the body and distinguishing between common and rarer injuries, the manual follows a trajectory from history-taking  and physical examination to diagnosis and treatment, providing clear and actionable guidance on managing the most common injuries and disorders. Arne Ljungqvist, Chairman of the IOC’s Medical Commission and an IOC honorary member, said: “The level of illustrations is unique and enables an easier understanding of the different injury types, treatments and latest insights.”  Above Women’s boxing made its Olympic debut in London in 2012  OLYMPIC REVIEW 15"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 15,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg16.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLYMPIC FANS SIGN UP TO RUSSIA’S LEADING SOCIAL NETWORK  The IOC has launched an official Olympic page on Russia’s most successful social network, Vk, one year ahead of the 2014 Olympic Winter Games in Sochi. More than 200,000 sports fans signed up to the Russian and Englishlanguage page within two months of the 7 February launch and the total number of users is expected to run into millions by the start of the Games next year. The new page – vk.com/olympics – enables the IOC to connect with greater numbers of young Olympic fans beyond traditional social media platforms such as Facebook and Twitter. The page will share some content from the IOC’s other social media channels, which have attracted more than 22 million followers worldwide and have proved highly successful in connecting and engaging fans and athletes with the IOC both during and after Games years. Activations include live chats with Olympians, the latest news on the preparations of the Games and iconic images from the past, present and future Games. More than 70 per cent of all online users in Russia use Vk, which has more than 200 million users in total.  OLYMPIC BRAND MAINTAINS GLOBAL STRENGTH AND RECOGNITION  The Olympic brand has maintained its very positive perception among the public, following the successful staging of the London 2012 Olympic Games.  This was the conclusion of a major global study conducted across 16 geographic markets, as well as research among 12,000 individual respondents. When asked, 95 per cent of  respondents correctly identified the Olympic rings, which outperformed other key global brands across a range of values, including: “Inspirational”, “Heritage & Tradition”, “Diversity”, “Optimistic”, “Excellence”, “Global” and “Inclusive”. The results of the survey showed that, in comparison to many other global cultural, entertainment or sporting events, the Olympic Games had the highest appeal and awareness ratings among the respondents as a whole, and specifically among young people aged eight to 19. The Games’ global stature was also underlined by the increase in global TV coverage. Coverage increased from 61,700 hours for Beijing in 2008 to 100,000 hours for London, with 3.7 billion people watching the Games last year. Consumer perceptions of the IOC itself were also highly positive, with the governing body considered to be more “modern”, “transparent” and “dynamic” than two years ago. Its strongest attributes were seen as the fact that it is “strict on doping”, “global” and “a leader”. Above London 2012 helped strengthen the Olympic brand  NEW E-LEARNING PROGRAMME A new Sport Sustainability E-Learning programme has been launched. The programme has been developed by the International Academy of Sport  16 OLYMPIC REVIEW  Science and Technology (AISTS) with the IOC and SportAccord as Principal Supporting Partners. The programme consists of four modules covering the key aspects  of sustainability for sports events, namely: the business case for sustainability, the ISO 20121 Management System, Reporting and Impact Assessment."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 16,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg17.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOCHI 2014 RECEIVES 200,000 VOLUNTEER APPLICATIONS  SOCHI 2014 TICKETS NOW ON SALE  Applications have closed for those hoping to volunteer at the 2014 Olympic Winter Games in Sochi, with over 200,000 people registering their interest. An estimated 25,000 volunteers will be involved during next year’s Winter Games, working across a variety of different Games-time operations, ranging from welcoming delegations at the airport to helping to organise the Closing Ceremony. Approximately 3,000 volunteers will also be deployed  Tickets for the Olympic Winter Games in Sochi in 2014 went on sale in Russia on 7 February, one year before the Opening Ceremony. Russian residents are able to buy tickets on the official Sochi 2014 website – www.sochi2014.com – while fans in other countries and territories can purchase them from their local NOC or authorised ticket reseller (ATR). A full list of ATRs and their contact details is available on the Sochi 2014 ticketing website.  around Sochi during the Games to provide a warm welcome to visitors and help them find their way between the Olympic venues. In total, volunteers will account for more than 30% of Games-time staff. Many of the Sochi 2014 volunteers have already been recruited, with approximately 5,000 gaining experience at the recent World Cup events that have been held at Sochi’s Olympic venues. The recruitment process is taking place at 26 volunteer centres within Russia, while the  programme has also helped re-establish the concept of volunteering across the country. “When Sochi began the bidding process in 2005, the concept of volunteering simply did not exist in Russia,” said Sochi 2014 CEO and President Dmitry Chernyshenko. “Now, the volunteer movement is thriving, with a quarter of a million Russians regularly participating in volunteer activity.” Below Sochi 2014 launched a large-scale project to train 25,000 volunteers for the Games  RIO 2016 MOVES TO NEW HEADQUARTERS The Organising Committee for the Rio 2016 Olympic Games has moved to new premises in Rio de Janeiro’s Cidade Nova neighbourhood. The modern building has been designed to be as sustainable and accessible as possible, and will house both the Rio 2016 organisers and the Municipal Olympic Company until after the Games.  OLYMPIC REVIEW 17"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 17,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg18.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "BLUE SKIES FOR THE ROAD AHEAD  NANJING 2014 MARKS 500 DAYS TO GO  This winter season, the YOG on the Road team has been busy supporting some of the athletes from the Innsbruck 2012 Winter Youth Olympic Games, as they continue to make their mark on the sporting world, bringing with them the lessons they learnt as Young Olympians. Among those that the team caught up with were ski jumper Sara Takanashi (JPN), who took this year’s overall senior World Cup title; curlers Tom Howell and Korey Dropkin (USA), who tested out the Olympic venue in Sochi for the Junior World Championships; biathlete Aita Gasparin (SUI), who revealed a day in the  On 3 April, Nanjing, China celebrated 500 days to go until the opening of the second Summer Youth Olympic Games (YOG) in 2014. In celebration of this countdown date, the Chinese city was buzzing with activity, as hundreds of school pupils marked the occasion by donning their trainers for a longdistance race. A colourful new official Nanjing 2014 website was also re-launched (www.nanjing2014.org), allowing fans from around the world to join in the  life of a biathlete after winning the U19 sprint at the Swiss Championships; and US snowboarder Arielle Gold (pictured below), who took gold in the halfpipe at the FIS World Championships. Read their stories and many more on www.olympic.org/yog  HOST CITY FOR 2018 YOG TO BE ANNOUNCED IN JULY The IOC will elect the host city for the 3rd Summer Youth Olympic Games in 2018 in Lausanne, Switzerland, on 4 July 2013. The announcement, which will be broadcast live online, will see Buenos Aires (ARG), Glasgow (GBR) or Medellín (COL) officially elected by the IOC members. The vote follows a thorough assessment carried out by the Evaluation Commission, headed by Claudia Bokel. The three shortlisted cities were chosen from among five Candidate Cities vying to host the YOG at a meeting of the  18 OLYMPIC REVIEW  IOC Executive Board in February. Guadalajara (MEX) and Rotterdam (NED) did not make the final shortlist. “Following the successful first summer and winter editions of the Youth Olympic Games (Singapore 2010 and Innsbruck 2012), we are delighted to see such interest in hosting the 3rd Summer Youth Olympic Games in 2018,” said IOC President Jacques Rogge. “This demonstrates the growing interest from cities around the world, not only for staging the event, but also for developing youth sport.”  celebrations as Games preparations continue in China. Earlier this year, as part of Nanjing’s ongoing promotional activities, volunteers and young journalists also took part in a treeplanting day held at Laoshan Forest Park, while the “Dream Bicycle Team” of Nanjing 2014 completed a tour of Chinese Taipei, spreading the YOG message. Below Schoolchildren mark 500 days to go until Nanjing 2014"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 18,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg19.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SINGAPORE HOSTS SECOND YOUTH OLYMPIC FESTIVAL  BAHRAIN DELIVERS LEVEL 2 NATIONAL COACHING PROGRAMME  More than 1,200 young athletes competed in six sports in the second edition of the multi-sport Singapore Youth Olympic Festival in March. Organised by the Singapore Olympic Foundation (SOF), the SYOF serves as a platform for young athletes below the age of 18  The Bahrain NOC’s Sports Training and Development Section organised its second level 2 national coaching course in April. Organised in cooperation with the World Academy of Sports, this course is part of the National Federation Managers Programme and addresses, among other things, sports associations’ strategies, long-term planning and activities and operations.  to showcase their sporting talents. The first edition was held in 2011 as a legacy of the inaugural Youth Olympic Games (YOG), held in Singapore in 2010, and aims to promote the Olympic values through sports. It is also a platform to create awareness of the second YOG, which will be  held in Nanjing, China, in 2014. The SYOF also hopes to inspire more Singaporeans to take up sports and bring young people together to foster stronger friendships through sports. Below The event saw more than 1,200 athletes take part  BRAZILIAN COACH ACADEMY HOLDS SECOND SESSION  GABORONE TO HOST 2ND AFRICAN YOUTH GAMES The Association of National Olympic Committees of Africa (ANOCA), represented by its President and IOC honorary member Lassana Palenfo, and the government of Botswana, represented by the Minister of  Youth, Sports and Culture, Shaw Kgathi, have signed an agreement to award the right to host the 2nd edition of the African Youth Games in 2014 to the city of Gaborone, Botswana. Created by ANOCA for  Through its education department, the Brazilian Olympic Institute, the Brazilian NOC has held the second module of the Brazilian Coach Academy. For four days at the Maria Lenk Aquatic Centre in Rio de Janeiro, athletics, gymnastics and swimming professionals looked at various aspects of the training and qualification of sports professionals. The experts present included Rosicleia Campos (below), coach of the Brazilian women’s judo team, who talked about her career as both athlete and coach, as well as the challenges she overcame to lead women’s judo to the top of the Olympic podium.  participants under 18, the Games are organised every four years and also serve as a qualifying event for the Youth Olympic Games. The first edition was held from 13-18 July 2010 in Rabat, Morocco.  OLYMPIC REVIEW 19"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 19,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg20.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "REGO TO CHAIR BRAZILIAN ATHLETES’ COMMISSION Olympic beach volleyball champion Emanuel Rego has been elected Chairman of the Brazilian NOC’s Athletes’ Commission (COB) for the 2013-2016 period by his fellow commission members. The election took place during the first working meeting of the Commission, held on 26 February at the NOC headquarters in Rio de Janeiro. Hortência Marcari, basketball world champion and Olympic medallist at the 1996 Atlanta Games, was elected as Vice-Chairperson.  ISSF CELEBRATES OLDEST LIVING OLYMPIAN  The USA’s Walter Walsh, who turned 106 on 4 May, has become the oldest ever Olympian. The 1952 25m pistol Olympic gold medallist has eclipsed another American Olympian, Rudolf Schrader, who died aged 105. According to Olympic historian Paul Tchir, the next oldest Olympian is Swiss Hans Erni, who also competed in London in 1948. Currently, there are just six Olympians aged 100 or over.  Right Chairman and ViceChairperson, Emanuel Rego and Hortência Marcari  SLOVAK OLYMPIC COMMITTEE HOSTS OLYMPISM CONFERENCE The Slovak Olympic Committee (SOC) and the Slovak Olympic Academy held an international conference entitled “Olympism in Practice” on 11 March in Bratislava, Slovakia. The  conference celebrated the “Life and Work of Pierre de Coubertin” as part of the 150th anniversary of the birth of the founder of the modern Olympic Movement. It was also the 20th anniversary  of the Slovak Olympic Committee. Below The Olympism conference was held in Bratislava, Slovakia, on 11 March  NEW DELHI TO HOST FIH WORLD LEAGUE FINALS New Delhi has been named as the host of two of the International Hockey Federation’s (FIH) major upcoming events, with the men’s tournaments of both the Hero World League Finals and Hero Junior World Cup set to take place in the Indian capital. The inaugural Hero Hockey World League Finals are scheduled for 10-18 January 2014, with the participating teams to be named after the semi-final tournaments which took place in the Netherlands and Malaysia in June.  20 OLYMPIC REVIEW"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 20,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg21.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 21,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg22.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "RUGBY SEVENS REACHES NEW HEIGHTS AHEAD OF RIO  FIVB NAMES HOST CITY FOR 2013 VOLLEYBALL WORLD LEAGUE FINALS The International Volleyball Federation (FIVB) has confirmed that Argentina will host the Finals of the 2013 World League in Mar del Plata from 17-21 July. Argentina, and the city of Mar del Plata in particular, has an extensive history of hosting volleyball events, having staged the FIVB World League Finals in 1999, the 2002 FIVB Men’s World Championship and three FIVB World Tour Opens from 1998 to 2000. In 2010, the city of Cordoba, Argentina, played host to the World League Finals.  ITF HOLDS INAUGURAL WORLD TENNIS DAY  Above Is this the first rugby sevens match in space? Russian cosmonauts at the International Space Station play a weightless match to promote Rugby World Cup Sevens 2013 in Russia. All three cosmonauts play rugby and will return to Earth in time for the showcase event featuring 24 men’s and 16 women’s teams from 28 nations at the Luzhniki Stadium, Moscow, on 28-30 June. Rugby sevens will make its Olympic Games debut in Rio de Janeiro in 2016.  EDMONTON TO HOST 2014 ITU WORLD CHAMPIONSHIPS The International Triathlon Union (ITU) has named Edmonton as the host city for the 26th edition of the ITU World Championships Grand Final in 2014. The event will mark the fourth time Canada has hosted  22 OLYMPIC REVIEW  the Grand Final, with Edmonton having organised the race in 2001. Edmonton has also staged nine World Cup events in the last 10 years and has held PATCO Junior Triathlon Pan American races on four occasions.  The International Tennis Federation (ITF) celebrated its 50th anniversary with the inaugural World Tennis Day on 4 March. The focus of the event was to encourage children to take up the game, with more than 50 National Associations organising a  variety of events aimed at increasing participation among children aged 10 and under. Professional players – both past and present – also took to the court as part of the events that took place in Hong Kong and New York.  WHO’S READING OLYMPIC REVIEW?  Who: Olympic long jump silver medallist Mitchell Watt takes a break from training in the heat to read about cooler climates ahead of the 2014 Olympic Winter Games in Sochi, Russia. Where: Brisbane, Australia"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 22,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg23.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 23,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg24.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "24 OLYMPIC REVIEW"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 24,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg25.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC PRESIDENT ROGGE  S  Left President Rogge passes the Olympic flag to Rio de Janeiro Mayor, Eduardo Paes, during the London 2012 Closing Ceremony  ince becoming the eighth President of the International Olympic Committee (IOC), Jacques Rogge has overseen some of the most important milestones in the Olympic Movement’s history. From the first Olympic Games to be held in China and the establishment of the Youth Olympic Games, to the creation of more opportunities for women in sport and the advancement of the fight against doping, the 71-year-old Belgian leaves behind a significant legacy of achievements as he prepares to step down from the IOC Presidency after 12 years in the role. “I think I will be regarded as a President who has done his work. My goal was always to transfer to my successor a solid and effective IOC,” he says. From his athletic career as a sailor, to his work as an administrator and leader, Rogge has always displayed an unwavering dedication to sport. As he looks ahead to his retirement, Rogge is sure to find his time now filled by his two young grandchildren who are already displaying a love of sports that would rightly make their grandfather proud.  A SAILOR AND A SURGEON  Sport played a prominent role in Rogge’s life from an early age. His grandfather, Jules, had been a professional cyclist at the turn of the century, while his father, Charles, was a Belgian champion in athletics and rowing. Born in Ghent, Belgium, on 2 May 1942, Rogge was soon encouraged by his father to lead an active life and began sailing dinghies on the River Lys from a young age, while each weekend his parents would take the entire family – including his brother and two sisters – on sailing trips to the North Sea resorts of Nieuport and Zeebrugge. From those early experiences, Rogge developed a keen love of sailing and was soon honing his skills on the water, before joining the Belgian national team and becoming a junior world champion at the age of 17 by winning the Yachting World Cadet Trophy. Rogge continued to sail while studying to become an orthopaedic surgeon at the University of Ghent and was crowned Belgian national champion on 16 occasions, as well as finishing as the runner-up in the ¾ Ton Cup. The crowning ➤  A LIFE DEDICATED TO SPORT AS IOC PRESIDENT JACQUES ROGGE PREPARES TO STEP DOWN AFTER 12 YEARS AT THE HELM OF THE OLYMPIC MOVEMENT, OLYMPIC REVIEW LOOKS AT HOW SPORT HAS SHAPED HIS LIFE AND HIGHLIGHTS SOME OF THE MAJOR ACHIEVEMENTS DURING HIS PRESIDENCY  OLYMPIC REVIEW 25"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 25,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg26.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC PRESIDENT ROGGE  achievements of his sailing career came, however, when he was chosen to represent Belgium in the Finn class at three editions of the Olympic Games. In 1960, an 18-year-old Rogge had watched the Games in Rome on television and been captivated by the performances of athletes such as the Australian Herb Elliott, who won gold in the 1,500m after a stunning sprint finish, and Denmark’s Paul Elvstrøm, who won his fourth consecutive sailing gold medal. “Paul Elvstrøm was arguably the best sailor ever,” says Rogge. “He won four consecutive gold medals in the Olympic Games from 1948 to 1960 and he was also a 15-time world champion. I had the privilege to sail against him at the beginning of my career and he left me with a lasting impression of an outstanding athlete with a great personality. “My other hero was the Australian Herb Elliott, who won the 1,500 metres in track and field during the Rome 1960 Games. During the last 500 metres, before the  Right At his first Olympic Games, in Mexico in 1968 Far right Rogge also represented his country at rugby Below As a young sailor in 1953  finish line, he accelerated with a majestic pace and finished with a huge lead.” When attending his first Games as an athlete in Mexico City in 1968, the Olympic experience made an even greater impression on Rogge, and would go on to shape his life for the next 45 years. Rogge finished 25th overall in the Finn class in Mexico, but the ceremonies, traditions and values of the Games had left an indelible mark on his psyche. “I remember entering the stadium during the Opening Ceremony and being completely overwhelmed by 100,000 people who were dancing and chanting,” recalls Rogge. “I will never forget that. It was my first experience of being in front of a crowd and an atmosphere like that.” Rogge returned to the Games in Munich in 1972, finishing 14th in the Finn class, before competing in his final Games in Montreal four years later, where he finished 22nd. During this time, Rogge had also expanded his sporting horizons by taking up rugby, initially as a way of  keeping fit during the winter. Playing as a flanker, Rogge discovered a natural talent for the game and was soon selected for the Belgian national team, winning 10 international caps, as well as founding the Ghent Rugby Club, which still exists today. “I was hooked immediately,” says Rogge of his rugby career. “To my mind, it is one of the greatest team sports. It is a sport requiring both contact and control. It exalts the sense of sacrifice and abnegation. And there is a real strategy behind every play.” A SPORTING DIPLOMAT  Rogge took his first steps into sports administration while he was still competing in sailing, after being approached by Raoul Mollet, the President of the Belgian Olympic Committee. “After the 1972 Games in Munich, Raoul Mollet came to see me,” explains Rogge. “He told me: ‘We need young people like you’, and convinced me to join his board as an athlete representative.” “I REMEMBER ENTERING THE STADIUM DURING THE OPENING CEREMONY AND BEING OVERWHELMED BY 100,000 PEOPLE WHO WERE DANCING AND CHANTING”  Rogge embraced his new role within the Belgian Olympic Committee and was soon named Chef de Mission of the Belgian Olympic team, leading the country’s athletes to the Olympic Winter Games in 1976 and 1988, as well as the Olympic Games of 1980, 1984 and 1988. It was during this time that Rogge’s dedication to the Olympic Movement became clear when, in 1980, he was faced with the prospect of his country withdrawing its athletes from the Moscow Games, following the American-led boycott. As a NATO ally of the USA, Belgium had intended to comply with American President Jimmy Carter’s wishes and withdraw its team from the upcoming Games. Rogge, however, was determined to demonstrate his belief that politics should be kept separate from sport. In a meeting with then Belgian Prime Minister Wilfried Martens and his government, Rogge refused to follow the boycott and insisted that the country’s athletes should still be able to compete in Russia. Despite the removal of public funding, Rogge led the  26 OLYMPIC REVIEW"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 26,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg27.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC PRESIDENT ROGGE  “WE THOUGHT IT WAS OUR DUTY TO PARTICIPATE IN THE OLYMPIC GAMES. I STILL FEEL SORRY FOR THOSE ATHLETES WHO WERE DENIED THE GAMES THEY DESERVED”  team to Moscow. “This was a milestone in my life,” says Rogge. “We thought it was our duty to participate in the Olympic Games. I still feel sorry for those athletes who were denied the Games they deserved. It gave me the resolve that, while we have to work closely with governments to develop sport, we have to preserve our independence.” By 1987, Rogge had ascended to VicePresident of the Belgian Olympic Committee and, two years later, was chosen to succeed Mollet as President. At the same time, Rogge was also elected President of the European Olympic Committees (EOC). “Things can happen unexpectedly,” recalls Rogge. “When [Mollet] stepped down, I was asked to replace him. Then the European Olympic Committees asked me to take their chair.” It was under Rogge’s initiative that the EOC launched the European Youth Olympic Days – a multi-sport event for young European athletes. The inaugural edition, held in Brussels in 1991, attracted more ➤  OLYMPIC REVIEW 27"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 27,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg28.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC PRESIDENT ROGGE  Left Pictured in 1968, the year of Rogge’s first participation in the Olympic Games  than 2,000 young athletes, aged between 14 and 18, from all 33 of the EOC’s member nations at that time. Two years later, the first winter edition was held in Aosta, Italy, with more than 700 participants. Since then, the event – now known as the European Youth Olympic Festival – has gone from strength to strength, with 3,300 athletes taking part in the summer edition and 1,300 participating in the winter edition. “When I was head of the European Olympic Committees we established the European Youth Olympic Festival,” explains Rogge. “I have always held a strong belief in the importance of sports events for younger generations.” In recognition of his work with the Belgian Olympic Committee and the EOC, Rogge was elected as a member of the IOC in 1991, following the 97th IOC Session in Birmingham. He soon became an active member of the organisation, joining the Olympic Movement Commission, the Olympic Programme Commission and the Medical Commission. Rogge stepped  66 OLYMPIC REVIEW 28  down as President of the Belgian Olympic Committee in 1992, but continued in his role as President of the EOC. By 1998, he had also been elected to the IOC Executive Board. When Sydney was named as the host city for the 2000 Olympic Games in 1993, Rogge was chosen to Chair the IOC Coordination Commission for the Games, helping to deliver what then IOC President Juan Antonio Samaranch described as the “greatest” Games ever. “A friend of mine said that Sydney raised the bar from a high jump to a pole vault,’’ recalled Rogge, shortly after the Games. “It was a unique atmosphere. The Australian people love sport. They cheered all the athletes. They stayed for the medal ceremonies even if no Australian athletes were involved. The atmosphere of the city itself was incredible. There were no transportation problems, no technology problems, no over-commercialisation. And the home team did splendidly.” Following the success of Sydney 2000, Rogge emerged as one of the leading ➤  Right With his wife, Anne, in Sydney in 2000, when Chair of the IOC Coordination Commission Far right Jacques Rogge was elected IOC President in Moscow in 2001"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 28,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg29.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC PRESIDENT ROGGE  JACQUES ROGGE: AT A GLANCE • BORN IN GHENT, BELGIUM, IN 1942 • WORKED AS ORTHOPAEDIC SURGEON IN GHENT HOSPITAL • MARRIED TO ANNE, WITH WHOM HE HAS TWO CHILDREN • 16-TIME NATIONAL SAILING CHAMPION • COMPETED AT THE 1968, 1972 AND 1976 OLYMPIC GAMES • PLAYED 10 TIMES FOR BELGIAN RUGBY UNION TEAM • CHEF DE MISSION FOR BELGIAN OLYMPIC TEAM FROM 1976-1988 • PRESIDENT OF THE BELGIAN NOC FROM 1989-1992 • PRESIDENT OF THE EUROPEAN OLYMPIC COMMITTEES FROM 1989-2001 • BECAME AN IOC MEMBER IN 1991 • BECAME A MEMBER OF THE IOC EXECUTIVE BOARD IN 1998 • CHAIRMAN OF COORDINATION COMMISSIONS FOR SYDNEY 2000 AND ATHENS 2004 • ELECTED AS PRESIDENT OF THE IOC ON 16 JULY 2001  OLYMPIC REVIEW 29"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 29,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg30.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC PRESIDENT ROGGE  contenders to succeed Samaranch as IOC President, with the Spaniard due to step down the following year. IOC PRESIDENCY  Rogge announced his candidacy for the IOC Presidency in March 2001, saying: “I will be a candidate because I have a vision of the future of the IOC and a passion for sports. I believe I also have all the necessary experience and skills.” He based his election campaign on defending the “essential values of sport” and promised to address issues such as doping, corruption and the increasing size of the Olympic Games, but the decision to put his name forward for the Presidency was not an easy one. “It was after careful consideration, particularly with my family, that I decided to submit my candidature,” says Rogge. “This represented a major change in my life: I had to give up my work as a surgeon, become a volunteer, leave my house in Deinze and move to Lausanne, and agree to become a semi-public figure.” On 16 July 2001, at the 112th IOC Session in Moscow, IOC members voted to elect Rogge as the eighth President “SPORT HAS AN EDUCATIONAL VALUE, IT HELPS SOCIAL INTEGRATION AND IT CONTRIBUTES TO GOOD HEALTH. IT IS A GREAT SOCIAL MOVEMENT MADE UP OF GREAT PEOPLE”  in the IOC’s history. “It is an important moment in my life and it is a great responsibility, not only to lead the IOC but to succeed Juan Antonio Samaranch, who has led the Olympic Movement to a position of strength,” Rogge said after the election. “I will dedicate the next eight years to the promotion of the Olympic Movement and the IOC. It is not to be an easy task, but I believe there is such strength that the IOC and the Olympic Movement will remain strong in the future.” Less than seven months into his Presidency, Rogge took to the stage in Salt Lake City to open the 2002 Olympic Winter Games – the first Games of his Presidency. It was during these Games that Rogge made headlines by deciding to stay in the Olympic Village, rather than a local hotel. “I think it’s the best place to be in the  30 OLYMPIC REVIEW  Olympic Games; I’ve always loved the atmosphere of the Village,” he says. “I stayed eight times in the Village, three times as a competitor and five times as a chef de mission. It’s a wonderful atmosphere and I wanted to go back.” Staying in the Olympic Village became a tradition for Rogge at each of the Games during his Presidency, enabling him to interact with the athletes on a more informal level and discover what issues were most important to them. “They always speak openly,” says Rogge. “They come and sit next to me and they are not backward in their advice. They tell me what I should be doing. What I hear mostly… is a plea to protect us from doping.” The fight against doping would become a key issue throughout Rogge’s Presidency and, with the number of positive tests at each Games decreasing and the London 2012 Games featuring the most extensive testing programme in Olympic history, the efforts appear to be working. One of the most significant factors in the fight against doping was the creation of the World AntiDoping Agency (WADA) in 1999, which Rogge was heavily involved in. “The idea of the creation of WADA came from my predecessor Juan Antonio Samaranch; I was on the delivery and operations side,” explains Rogge. “The vast majority of athletes do not use doping,” he adds. “It comes down to convincing those who do that high performance is possible without cheating. But informing people is not enough; I also believe in prevention. We have to test in and out of competition and sanction athletes if they test positive. Finally, we need the help of scientific research to detect and track down new drugs quickly. “The tests are definitely becoming more efficient and the scientific method is better.” In addition to doping, Rogge has also led the fight against other issues, such as illegal betting on sports and the growing problem of childhood obesity. “Illegal betting is, along with doping, the major scourge of sport,” he says. “But I am hopeful because the sports world and governments are joining together to address this. I am also concerned about the rise of obesity, especially among young people. It is a combination of poor diet and lack of exercise. To do something about it,  you need the support of parents, schools, sports clubs and governments. Ultimately, it calls for a total change of mindset on the part of young people themselves.” As part of his plans to address apathy among young people and engage them with sport from an early age, Rogge presented plans for the establishment of the Youth Olympic Games, for athletes aged between 15 and 18, which would combine high-level sport with cultural and educational initiatives. “The Youth Olympic Games [was] a project I had at the back of my mind since being elected IOC President in 2001,” explains Rogge. “I saw an opportunity to develop an international event coupling sport with education that could act as a catalyst to engage young people around the world.”  Above Carrying the Olympic torch in the lead-up to the Games in Athens in 2004"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 30,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg31.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC PRESIDENT ROGGE  In 2007, at the 119th IOC Session in Guatemala City, the IOC members approved the creation of the Youth Olympic Games (YOG), and the inaugural edition was held in Singapore three years later. “I feel like an expectant father waiting in the delivery room,” said Rogge, on the eve of the Games. Twelve days later, it was clear that the YOG had already become a significant part of the Olympic Movement, with Rogge declaring: “The Youth Olympic Games vastly exceeded my highest expectations. It was a huge success; greater than anything we had imagined.” Under Rogge’s Presidency, the IOC also focused on its commitment to the promotion of sport as a tool for development, working closely with the United Nations and its agencies. The status of Permanent Observer to the United Nations, granted to the IOC in 2009, provided a broader framework for the Olympic Movement’s own human development objectives. Rogge has also overseen the modernisation of the Olympic programme, with events such as BMX cycling and ski slopestyle ensuring that the Games remain relevant to young people. “The programme cannot be standard and conservative forever,” says Rogge. “We need an injection of new blood.” More opportunities have also been created for women, with new events – such as women’s boxing and ski jumping – helping to increase the gender equality at the Games. And for the first time in London, women competed in all sports on the Olympic programme. “We were delighted to have reached that milestone,” explains Rogge. “Gender equality is a human right.” “The Youth Olympic Games have been another effective tool for promoting gender equality. We are breaking down traditional barriers by pairing boys and girls as teammates in mixed gender events.” As he prepares to step down from the IOC Presidency, Rogge is able to look back on a series of impressive achievements. “I believe I will leave behind some notable successes,” he says. “The quality of the Olympic Games under my presidency have been very well organised, the Youth Olympic Games have been a very great success. I have fought against doping and illegal betting and I will leave with the financial revenue in a very strong state.”  As Rogge ascertains, among the most notable successes under his Presidency are the six Olympic Games that were held, including Winter editions in Salt Lake City, Torino and Vancouver and Summer Games in Athens, Beijing and London. “To be able to say that the Games were truly magnificent and unforgettable is very rewarding,” he says. “This is proof to me that the IOC has done a very good job. “All the Olympic Games I have overseen, from Salt Lake City to London, have been of the highest quality but that is down to a team effort,” says Rogge. “I could close the Games and reflect on a very successful Games. A job well done.” There is little doubt that Rogge’s Presidency could also be described as “a job well done”, while the man himself regards leading the Olympic Movement as one of the greatest honours in sport.  Above President Rogge meets a young tennis player on a visit to the National Tennis Training Centre in Burundi  “It is a privilege when you love sport like I do. It gives you the means to fulfil the dreams and aspirations of sports,” he says. “I’ve always been passionate about sport and I believe in its healing power. Sport has an educational value, it helps social integration – of minorities, for example – and contributes to good health. It is a great social movement made up of great people.” Those great people include Rogge himself, whose dedication to sport has guided him throughout his life. “I love sport for what it represents, especially among young people,” he says. “There are certainly much more important things in life, but it is a solid, educational and fascinating value, which has always inspired me to dream. And dreams are very important in life.” ■  OLYMPIC REVIEW 31"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 31,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg32.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "RAISING THE BAR THE CONSTANT RISE IN ATHLETIC STANDARDS AND THE QUALITY OF SPORT FROM ONE OLYMPIC GAMES TO THE NEXT HAS BEEN A STRIKING FEATURE OF HIS TIME AS IOC PRESIDENT, SAYS JACQUES ROGGE, AS HE REFLECTS ON HIS MAJOR ACHIEVEMENTS AND THE DEMANDS OF THE ROLE"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 32,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg33.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC PRESIDENT ROGGE  Looking back at your presidency of the IOC, what are you most proud of? I think the most important thing under my watch has been the quality of the Games. This is a core mission for the IOC, and something that along with the Organising Committees (OCOGs), the IOC has worked very hard at. The success of the Games and the well-being of the athletes is the most important thing. Also, I am very proud of the creation of the Youth Olympic Games (YOG), the fight for Olympic values against doping and illegal betting, and finally, the current strong financial situation of the Olympic Movement. How demanding have you found your role over the last 12 years? This is a job where you have to be reachable night and day every week. We have special links with 204 National Olympic Committees (NOCs), with 35 International Federations (IFs) and we have to interface with broadcasters and the media. We have to work closely with the 10 sponsors of the IOC and with roughly 130 television rights holders. So this is a huge group of stakeholders and you always  have to be ready to work on the most unexpected things. There is also a lot of travelling – around 150 flights a year – and a lot of meetings. It is definitely a 24/7 job. You’ve overseen three Summer Games and three Winter Games. Apart from the well-documented achievements of certain athletes, what has best symbolised the Olympic spirit over the last 12 years? On the one side you are attracted to the extraordinary achievements of the likes of Usain Bolt, Michael Phelps, Ben Ainslee and Valentina Vezzali who have won three, four or five consecutive gold medals in as many Games. This is something you cannot forget. But what has struck me most is the constant rise in quality of the participants over the years. This has been translated into the number of records and the number of medals being won by more and more nations. You can see the evolution of sport and that sport is making great strides in quality, Games after Games. And the increasing numbers of countries winning Olympic medals means the positive effect of the Olympic values being experienced more widely? ➤  Right Meeting with a young Olympic fan in Vancouver in 2010  OLYMPIC REVIEW 33"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 33,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg34.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IOC PRESIDENT ROGGE  Yes, exactly. This provides a fantastic boost, not only for the country, but also for the region. Every medal in the Caribbean, for example, is considered a Caribbean medal – much more than a national medal. The medals for developing countries are very, very important. They boost the development of sport in that region.  sailing late one afternoon, we witnessed Bob Beamon’s extraordinary jump on a small black and white television in the Olympic Village restaurant in Acapulco. I remember going to my room after dinner and pacing out 8.90m in the corridor. You have to measure it out to realise how astounding it was.  What have you found the most challenging aspect of running the Olympic Movement?  How do you see the Youth Olympic Games developing in the future?  To manage the expectations of the stakeholders. We can give great support to our stakeholders technically, through the transfer of our knowledge, and financially. But if I may say so, they can be quite demanding and of course you try and give the best possible services to them because we are a service organisation. But sometimes, their wishes and appetites are bigger than our capacity. Essentially it is not a bad thing because this means that the IOC is considered a great source of services.  I see them developing not in terms of size, but in quality. We don’t want them to be too big, too expensive or too sophisticated. We don’t want them to become a mini-Olympic Games, we want them to retain their own defining identity. If we can keep the YOG values that are present today and develop within their limited size, I would be very happy.  Which particular memories stand out from your career as an Olympic competitor?  Nothing fundamental. What disappointed me was the turmoil around the Torch Relay ahead of the Games in Beijing in 2008. We were sucked into a political issue and it became a challenge. It was a difficult time  There is one striking memory from my first Games in 1968 in Mexico. Returning from  Is there anything that you wish you had done differently now you look back over the 12 years?  for the Olympic Movement. Fortunately, calm was restored by the time the Games began and Beijing 2008 was a great success. “WHAT HAS STRUCK ME MOST IS THE RISE IN QUALITY OF THE PARTICIPANTS… SPORT IS MAKING GREAT STRIDES IN QUALITY, GAMES AFTER GAMES”  How do you think the Olympic Movement in 2013 compares to when you first took over in 2001? I think the Movement and the IOC is on a safe financial footing. We have a good number of high quality candidate cities and the organisation of the six Games on my watch has been impeccable. This is definitely going to continue thanks to the strong partnership being developed between our Olympic Games team and the OCOGs. You see the quality increasing Games after Games because of this unique partnership, where we can help the OCOGs, not only technically and financially, but also by highlighting any errors to avoid. We are saving them money and energy. What are you looking forward to most about retiring? There have been many personal interests that I have not been able to pursue because of my mandate. First of all, to travel less and spend more time with my family. I look forward to helping my grandchildren with their sports development (without being too pushy!). I have a keen interest in modern art and a big pile of DVDs to watch and books to read. I also look forward to being able to undertake more sporting activities with more time. And which sports in particular? I will keep myself fit by riding my bike and running on the treadmill, and on a good day I will get out sailing! How do you think you will be remembered as IOC President? And how would you like to be remembered? Well, I would be happy to be remembered as someone who did a good job, and someone who solidified the foundations of the Olympic Movement. ■  34 OLYMPIC REVIEW  Left With UN SecretaryGeneral Ban Ki-moon. Under Rogge’s presidency, the IOC was granted the status of UN Permanent Observer"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 34,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg35.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 35,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg36.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 36,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg37.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 37,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg38.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 38,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg39.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 39,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg40.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "THE BROADCAST REVOLUTION WITH LONDON 2012 UNDERLINING THE HUGE GROWTH IN DIGITAL COVERAGE OF THE GAMES, OLYMPIC REVIEW LOOKS AT HOW OLYMPIC BROADCASTING HAS EVOLVED THROUGH THE YEARS  40 OLYMPIC REVIEW"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 40,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg41.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "T Left The live feed of the men’s singles tennis match between Andy Murray and Stanislas Wawrinka during London 2012  elevision coverage of the Olympic Games has come a long way since 1936, when just 138 hours of footage was shown on a closed circuit system in a handful of venues around Berlin’s main stadium. Back then, only one of the three cameras used was capable of live coverage – and even then only when the sun was shining. In contrast, broadcast coverage of last year’s London 2012 Olympic Games utilised over 1,000 cameras to produce more than 5,600 hours of high definition coverage – all in wideranging weather conditions, typical of the traditionally unpredictable British summer. When London last hosted the Games, ➤  OLYMPIC REVIEW 41"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 41,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg42.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLYMPIC BROADCASTING  1948, it was the first time that Olympic coverage had ever been broadcast live into people’s homes, with approximately 500,000 viewers, mostly residing within an 80km radius of London, watching the 64 hours of coverage available. Sixty-four years on, as Olympic broadcasting returned to its roots, it was evident just how far things had progressed. The London 2012 Olympic Games was watched by 3.7 billion people in more than 200 countries and territories around the world. “I think London 2012 heralded a new era in Olympic broadcasting,” explains Timo Lumme, Managing Director of the IOC Television and Marketing Services. “The London Games became the biggest Olympic Games in terms of the amount of broadcast coverage made available to fans around the world. If you take all of our broadcast partners, all the channels, and you add up all the TV hours that they put out, it is about 100,000 hours. For Beijing [in 2008] it was 61,700 hours.” This huge growth in coverage in just four years highlights the broadcast revolution that is currently taking place, while the THE LONDON 2012 OLYMPIC GAMES WAS WATCHED BY A RECORD 3.7 BILLION PEOPLE IN MORE THAN 200 COUNTRIES AND TERRITORIES AROUND THE WORLD  advancements in digital technology are also allowing Olympic fans to enjoy more Games coverage than ever before. The growth also highlights how the Games has been a key driver and testing ground for new broadcast technologies, ever since the initial live Olympic coverage in London in 1948. In Rome in 1960, for instance, live coverage was available on a continental basis for the first time, as the Games were broadcast live to 18 European countries. In addition, the use of videotape recorders enabled pictures produced by television cameras to be recorded, providing instant picture playback. Four years later, in Tokyo in 1964, there were further technological advances in the television industry, meaning that satellite broadcasts were available for the first time. Other innovations used at the Games included the close-up talking microphone, slow motion and the use of helicopters for aerial coverage. By 1968, when the Games  42 OLYMPIC REVIEW  Below TV crews inside the 1948 Olympic Stadium Right At the Games in Innsbruck in 1964; lenses home in on a boxing bout at Seoul 1988; Slovenia’s Tina Maze celebrates in front of the cameras in Vancouver in 2010  were held in Mexico City, technological innovations continued to enhance global coverage, with colour broadcasts being used extensively for the first time. Other new technologies that emerged during these Games included handheld wireless colour cameras and backpack recorders that allowed for very close-up action shots. With audience levels growing – and an estimated 900 million people tuning in – the Munich Games in 1972 marked the first time that Olympic broadcasting reached all five continents, with 75% of the broadcasts being live while the rest were recorded on videotape. After digital recording had revolutionised Olympic coverage at the 1984 Games in Los Angeles – eliminating the need for film laboratories at the International Broadcasting Centre – the 1988 Olympic Games in Seoul provided a glimpse of further innovations, with broadcasters experimenting with high-definition coverage for the first time. Ten years later, at the 1998 Olympic Winter Games in Nagano, experiments were also conducted using video-on-demand services and highdefinition 3D broadcasts.  The Winter Games in Turin in 2006 saw broadcasters take advantage of new media technology, providing viewers with wider choices through the internet and multiple television channels, as well as offering mobile coverage of the Games for the first time. By Beijing 2008, full digital television coverage of the Games was available around the world, with the host broadcaster, BOB, providing over 5,000 hours of live HD content for hundreds of millions of viewers. The digitalisation of Olympic Games coverage saw Rights-Holding Broadcasters (RHBs) offer both live and video-on-demand internet coverage, as well as highlights clips on mobile phones. Two years later, at the 2010 Olympic Winter Games in Vancouver, a total of 6,000 hours of coverage was broadcast worldwide on mobile phone platforms, while London 2012 saw digital coverage explode across all digital platforms. In total, more than 150 official websites, tablet/mobile applications and other digital platforms from Rights-Holding Broadcasters showed London 2012 coverage, with approximately 2.4 billion people able to access digital coverage of the Games."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 42,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg43.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLYMPIC BROADCASTING  LONDON 2012 HIGHLIGHTED A NEW MULTI-PLATFORM APPROACH TO CONSUMING THE GAMES, WITH AUDIENCES WATCHING CONTENT ON COMPUTERS, MOBILES AND TABLETS, AS WELL AS TV  “In terms of the type of broadcast partners we have, obviously we are still underpinned by the traditional freeto-air broadcaster, which delivers to a mass audience,” explains Lumme. “But nowadays we also complement that with various partners in the multichannel area – both free and pay – which delivers to the dedicated sports fan, as well as the online and mobile coverage for the anytime, anywhere immersive kind of experience.” London 2012 highlighted this new multiplatform approach to watching extended coverage of the Games, with audiences consuming content across computers, mobiles and tablets, as well as TVs. In the host country, the London 2012 Olympic Games were the biggest national television event since current measuring systems began more than a decade ago, with 51.9 million people – approximately 90% of the British population – watching at least 15 minutes of Games coverage. ➤  OLYMPIC REVIEW 43"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 43,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg44.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLYMPIC BROADCASTING  LONDON 2012 BROADCASTING HIGHLIGHTS • MORE COVERAGE AVAILABLE ON MORE PLATFORMS THAN EVER BEFORE • LIVE 3D COVERAGE OFFERED FOR THE FIRST TIME • GLOBAL AUDIENCE OF 3.7 BILLION PEOPLE IN MORE THAN 200 COUNTRIES AND TERRITORIES • APPROXIMATELY 100,000 HOURS OF OLYMPIC COVERAGE SHOWN ON TV AROUND THE WORLD – FAR EXCEEDING THE 61,700 HOURS THAT WERE BROADCAST DURING BEIJING 2008  44 OLYMPIC REVIEW"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 44,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg45.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLYMPIC BROADCASTING  But the Games also enjoyed huge success on digital platforms, with the BBC broadcasting every minute of every event via online streams and 24 interactive digital TV channels. By the end of the Games, more than 24 million people – approximately 42% of the British population – had watched at least 15 minutes of interactive digital TV coverage, while there were over 106 million requests for video streams across all BBC online platforms, which far exceeded the previous highs of 32 million for the Beijing Games and 38 million for the 2010 FIFA World Cup. There were also 12 million requests for video streams on mobile devices, underlining the public’s appetite for comprehensive Games coverage. “Big sporting events have traditionally been the catalyst for change in broadcasting – from the advent of colour AT THE OLYMPIC GAMES IN LONDON IN 2012 THERE WERE ABOUT 1.4 BILLION SMARTPHONE USERS WORLDWIDE. THIS IS FORECAST TO INCREASE TO 3.2 BILLION BY THE YEAR 2017  Left Cameras capture the ‘Lightning Bolt’ after the men’s 100m in London in 2012 Right Mobile technology has offered Olympic fans new ways to watch their favourite events  TV to the introduction of HD,” explains Ben Gallop, Head of BBC Sport Interactive. “I’d like to think that what we have seen during London 2012 will have a bearing on how sport is covered in the future.” This switch towards digital content has been evident for the last 10 years according to Peter Kepreotes, a broadcast technology expert who worked on Games coverage in Sydney, Athens, Beijing and Vancouver. “Over the past decade in particular, television broadcasting has experienced a fast-track evolution with developments in digital technology,” he says. “Improvements in content acquisition, production and delivery technologies have enabled television networks to provide an unprecedented volume of premium-quality content that ensures the viewer is kept right in amongst the action. “Sports fans now have the luxury of viewing sport in high-definition widescreen and surround sound, with multiple camera angles and super-slow-motion replays – all on multiple viewing platforms. The recent broadcasting history of the Olympic Games provides a valuable insight into just how much the provision and delivery of sports content has changed over the past decade.”  Kepreotes believes the future of Olympic broadcasting could be in the palms of viewers’ hands, as mobile coverage increasingly complements the home television Olympic broadcast experience and offers new opportunities to watch the Games. “Mobile TV looks set to be one of the primary drivers of further developments in terrestrial broadcasting in the near future,” he says. “While there are many sports fans happy enough to view sport on their home television, an increasing number of consumers are embracing the option of viewing their favourite sports programmes on their handheld device. It is expected that mobile TV will reflect the fast-track uptake of mobile telephony.” Lumme also believes that mobile Games coverage could be an increasingly significant part of Olympic broadcasts in the future, as more and more smartphone and tablet users emerge. “I am not sure there is anyone in the world who will know the absolute answer,” he says, “But the trends are that there is a technological conversion going on which means that your mobile phone is going to be the same as your television set  effectively, or have the same functionalities, so we expect that there will be more digital consumption.” For London 2012, there were approximately 1.4 billion smartphone users in the world, but by 2017 this is forecast to increase to more than 3.2 billion, while tablet users are expected to grow from 150 million to 760 million over the same period. “People are consuming media very differently than 10 years ago,” says Richard Carrión, chairman of the IOC’s Finance Commission. “There are more and more devices. People watching on broadband end up consuming even more of the broadcasts than those who don’t use alternative media.” Like the BBC, US broadcaster NBC also enjoyed great success with its digital coverage of London 2012, serving a record 159.3 million video streams – more than double the figure it served during Beijing 2008. NBC also launched two apps to allow viewers to watch the Games on smartphones and tablets, which were downloaded more than eight million times and accounted for 37% of all NBC’s live video streams. While NBC’s digital coverage flourished, its traditional TV broadcast of ➤  OLYMPIC REVIEW 45"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 45,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg46.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLYMPIC BROADCASTING  the London 2012 Games also became the most-watched television event in American history, with more than 219 million viewers, and NBC Olympics Executive Producer Jim Bell believes it will take time for digital coverage to replace TV broadcasts entirely. “I think we’re going to get there at some point,” he says. “I don’t know if it’ll be 2016 or 2020. For all the talk about the second screen, digital and the live stream – and those are hugely important advances and priorities for us – primetime is still also very important to us. And I don’t think that’s going to change any time soon.” Mark Lazarus, Chairman of the NBC Sports Group, also believes that viewer  demand for digital coverage will continue to grow, as fans seek more and more Olympic content. “As times have changed, there is a sense to satisfy all people with technology,” he says. “And the ability to provide live streams of every event is one that we now have. It’s an evolving technology. It’s an evolving business. It’s evolving consumer habits. Invariably, what we do in Sochi [in 2014] will be different [from what we did in London]. We will evolve our coverage. Nothing should stay the same from Games to Games.” In the fast-moving world of Olympic broadcasting, it’s unlikely it ever will. ■  BROADCAST PREPARATIONS FOR SOCHI 2014 VASILY KIKNADZE, CEO OF ANO SPORTS BROADCASTING, REVEALS THE TV COVERAGE PLANS FOR SOCHI  Following the huge success of the broadcast coverage of London 2012, attention is swiftly switching towards Sochi, Russia, which will host next year’s 2014 Olympic Winter Games. Coverage within the host country will be provided by ANO Sports Broadcasting – which was founded in 2009 by Russia’s Channel One, VGTRK and NTV-PLUS. According to Vasily Kiknadze, the CEO of ANO Sports Broadcasting, one of the first challenges in preparing for the Games was to recruit the skilled staff required to deliver a superb broadcast experience to Olympic viewers in Russia. “Here we faced a crucial issue: where to find the people and how to use them,” he explains. “We discussed the option of doing everything based solely on Moscow specialists. However, this was not practical.” Instead, ANO Sports Broadcasting decided to initiate a training programme, which began in May 2011, to find more than 1,000 budding television professionals from nine Russian regions to handle the various production and engineering functions at the Winter Games. “Applications came in from all areas of Russia,” says Kiknadze. “We were able to select between 50 and 60 people from  46 OLYMPIC REVIEW  each region to come to Moscow for initial training.” In addition to theory work and hands-on demonstrations using outside broadcast equipment, the programme also gave trainees the chance to produce TV coverage at events such as the Moscow Beach Football Championship, the Moscow Formula One exhibition and the FIFA U-17 Women’s World Cup in Azerbaijan. “These were all tremendous training experiences,” explains Kiknadze. The trainees have since worked alongside experienced broadcast crews at several major events that have been held at Sochi’s Olympic venues, as organisers continue their preparations for the Games. These included the first Alpine Skiing World Cup event to be held in Russia, in February 2012. “Never before had we broadcast from Olympic facilities, and never before – neither in the Soviet Union, nor in Russia – had we broadcast live from Alpine ski competitions,” explains Kiknadze. “We went into unknown territory, and that’s what is most difficult and most interesting.” Innovations included an overhead cablecam, which was used at an Alpine skiing venue for the first time, providing unique coverage of the closing stages of each run. ANO Sports Broadcasting has also been producing coverage from recent events in  Sochi, including World Cup competitions in biathlon, luge and short-track speed skating. Each event has enabled the organisation to hone its techniques ahead of next year’s Winter Games, providing valuable learning exercises. “I think there are several areas that are important,” says Kiknadze. “First, the planning of such big events takes a great deal of time. Deadlines come and go far more quickly than you expect. On the technical level, we will continue our training programme to include the new technology that we are going to employ in Sochi. And finally, producing a national signal on the scale that we anticipate for Sochi requires considerable thought and coordination with Olympic Broadcasting Services (OBS).” Once the Sochi 2014 Winter Games are over, the new broadcast technology and professional training that has taken place will provide a lasting legacy for the Russian television industry, according to Kiknadze. “The Olympic Games and the test events, for which we have purchased equipment and trained over a thousand television professionals, will help us make a great leap in the development of Russian sports broadcasting, and open the way to the HD-format,” he says. ■  Left Russia’s Yuliya Zaripova blows kisses at the camera after winning 3,000m steeplechase gold"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 46,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg47.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 47,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg48.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 48,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg49.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 49,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg50.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOCHI STARS  ,, ,,  The social soc media stuff is new for me, but I’ve got more than 3,800 Twitter followers, a Facebook page and a team website. We also have a separate Kevin Martin curling website and a Kevin Martin curling app. We started it as an instructional tool for my academies, covering rills. everything from delivery to drills.  ,,  The ski skills you need in curling totally depe depend on which position you play. While a skip has to be in shape, he also must be mentally strong, as you get extremely fatigued mentally. With all the sweeping that they do, the front end – the lead and second player – have to be really in top shape. For them, strength and cardio are very important. In the third position, you have to have everything; you’ve got to think about the game tactically, but also be able to sweep for many games over an event. As a skip, what I worry about is being lean – no big muscles needed for a skip because it’s a game of touch. But overall fitness is y important. That way, after a ten-day event you’ve still got energy.  ,, ,,  ,,  There’s a ton of work being done on the abrasiveness of brushes b and control of heat caused by brushing. The weight of the brush matters, and the abrasiveness of the head is important. Water absorption makes a difference too. I would say the brushes, heads and handles are changing faster than any other part of our game.  ,,  Curling is like chess; it’s strategic. You’ You’ve got to make moves three or four places in advance and look ahead, more than a day ahead sometimes, depending on your next opponent. You have to come into an event with a positive mind-frame. As a skip, you’re the leader of the team and you need to have that positive air about you. If you know you’ve worked harder than everybody else then you’ll make more shots. If on you’re not sure, then your opposition end. will smell that – you can’t pretend.  ,,  KEVIN MARTIN AS WE CONTINUE OUR COUNTDOWN TO SOCHI 2014, CANADA’S GOLD MEDALWINNING SKIP FROM VANCOUVER 2010, KEVIN MARTIN, REVEALS THE ESSENTIAL COMPONENTS FOR CURLING SUCCESS  50 OLYMPIC REVIEW"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 50,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg51.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOCHI STARS  ,,  I don’t k keep any special objects or photos in my kitba kitbag. I’m just not like that. I do always have two pairs of shoes in my bag – a second pair that have been broken in, completely ready to go. And I’ve got a second uniform, just in case. Now and then I will keep a letter in my bag that I’ve received ink, from a little girl or a grandma that makes me think, “That’s nice.”  ,,  ,,  ,,  I make sure I don’t watch any local new news and don’t read any of the media during a tournament. I try to keep my mind completely out of that. I would read an article and get a negative thought or read another and bad; get a positive thought. Both are bad; vent. I want to be level during an event.  ,,  ,,  ,,  ,,  ,,  I’m a we western Ca Canadian guy, so I unwind by listening to country music – it’s pretty much all country music for me, or old soft rock. Also, I coach my all daughter’s fastball team.  Being tthat bit older, I’m from the school of hard knocks. I prepare by training hard on ice. And I want the thought in my head to be that I can compete stronger than everybody else. Before big games I will just get my thoughts clear – going through the ice conditions, going though the rocks we’re going to use – so I can be clear in what we’re attempting to accomplish. If I can visualise the ice surface and exactly how the rocks are going to nt in run, then I’m completely confident what’s going to happen next.  The ma main thing with curling is that the av average age of curling champions used to be about 37. It’s not like that now; the average age is 28 or 29. Obviously physical fitness is a huge part of that. The athletes are getting more and more fit. They’re getting better and quicker because our junior programmes are strong. The sport is becoming youthful. Guys used to say, ving “Curling? That’s for old guys having nymore. a beer”. But it’s not like that anymore.  ,,  OLYMPIC REVIEW 51"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 51,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg52.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOCHI STARS  ,,  I alway always have a race plan for every co competition. Before a race I will go on the shooting range and then I try to find my own time and space to clear my mind. Most of my focus is on the shooting and my plan remains mostly the same, regardless of the distance I am racing.  ,  Winning Winnin n a gold medal in Vancouver was th the highlight of my career. It brough brought me lots of joy as it’s the best thing y you can win in biathlon and it was even more special because I became the first Norwegian woman to win biathlon gold. With that medal, Norway became the first nation to win 100 gold medals at the Olympic Winter Games. It was an amazing day.  ,,  ,,  My training trai time is split between physical activity and target practice. The best way for me to train is to replicate race situations so I spend a lot of time on the roller skis in the summer and actual skis in the winter. It’s good to cross-train too so, when I can, I get out on the bicycle and also run.  TORA BERGER NORWAY’S FIRST FEMALE OLYMPIC GOLD MEDALLIST IN BIATHLON HAS FOLLOWED UP HER SUCCESS IN VANCOUVER IN 2010 WITH A STELLAR 2012/13 SEASON, INCLUDING FOUR GOLD MEDALS AND TWO SILVER MEDALS AT FEBRUARY’S WORLD CHAMPIONSHIPS  52 OLYMPIC REVIEW  ,,  ,,"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 52,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg53.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOCHI STARS  ,,  Growin up in the mountains was Growing gr great. I was training without even knowing I was doing it as I have always loved walking, fishing and hunting. I still do this but I also like to read and g. knit jumpers when I am resting.  ,,  ,,  ,,  ,,  I try to get to the gym for strength training two times a week during the winter although the competition schedule makes that difficult – it is important to stay fresh. In the summer, I can spend more time working with weights.  ,,  I don’t get to train with my brother [L [Lars, biathlon 4 x 10km relay Olympic silver medalist in 2010] any more but I looked up to him when I was young. I never had any chance of beating him on skis but I always tried and maybe that helped me build strong legs.  ,,  ,,  ,,  Someti Sometimes if I ha have a long training session ahead on skis I will listen to music but I don’t use my it for most of my training.  I found the track difficult at the Wo ld Cup in Sochi in March but it World does suit me well so I am happy. I enjoyed competing there and won three bronze medals. I hope I will be there again next year! I am confident that if I can rediscover my form and my shape next winter, I can be in contention to do really well in Sochi. y However, I will have to work very hard this summer to do so.  ,,  ,,  ,,  ,,  ,,  ,, I eat mo mostly whatever I like, I don’t think too much about it. My biggest concern is not eating enough. My diet naturally consists of foods high in carbohydrates; I at train so much that I need the energy.  When I am feeling ve very strong and I am in a good position, it is easier to focus on the shooting target. But if I am not at my best and I am trying to make up time, it becomes very difficult to reduce my heart rate and steady my breathing for an hot. accurate shot.  I use Fa Facebook to stay in touch with m f my friends and family and we have a team page to keep our fans updated on our training camps and competition. I hope this helps to inspire younger athletes who might want to become biathletes. It is important that they see we have fun though – there is life outside of biathlon too!  ,, OLYMPIC REVIEW 53"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 53,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg54.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLYMPIC RESEARCH CORNER  54 OLYMPIC REVIEW"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 54,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg55.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLYMPIC RESEARCH CORNER  T  his study looked at two groups of children in Burundi: high school students from the Lycée de l’Amitié in the Ngagara neighbourhood of the capital Bujumbura, and street children in the same city. The high school students were aged 15 on average. As for the others, since we do not know their exact age, we will use the generic term “street children”, which is in common use, even if it does not necessarily relate to the reality of their situation. This also differentiates them from the high school students. The street children come together in ligalas, spaces that function as shelters and meeting places, where meaningful social groups are formed. For want of a better housing solution, these children had no other choice but to choose to live on the streets, in what is effectively a home without walls. They must fend for themselves for food, shelter and healthcare. The high school students are boys who live quietly at home with their parents, and regularly go to school under the supervision  of the school authorities. They have health insurance, and their parents are completely responsible for them. By bringing the two groups of children face to face, despite the social gap and sense of inequality that characterised their initial encounters, the football games gradually transformed the way they saw each other. STAGE 1: MISTRUST AND SENSE OF INEQUALITY ATMOSPHERE OF MISTRUST The first encounter was characterised by reserved behaviour. Each player stayed in his group, with “his people”. The initial reaction of the high school students was one of surprise mixed with fear: they were afraid of being attacked. The street children were perceived as wild, dirty and uneducated. Neither team had sports jerseys therefore the members of one of the teams had to play bare-chested so ➤  MAKING A DIFFERENCE IN BURUNDI, DR ATHANASE NSENGIYUMVA ORGANISED A SERIES OF FOOTBALL GAMES BETWEEN CHILDREN WITH PROFOUNDLY DIVERGENT BACKGROUNDS AND OUTLOOKS ON LIFE FOR A STUDY THAT REVEALED THAT THE CORE VALUES OF TEAM SPORTS CAN FOSTER SOCIAL INTEGRATION. IS SPORT REALLY A SOCIAL MELTING POT? CAN PLAYING SPORT TOGETHER CHANGE CHILDREN’S VIEWPOINTS AND BEHAVIOUR, GOING BEYOND SOCIAL FACTORS AND PREJUDICE?  OLYMPIC REVIEW 55"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 55,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg56.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLYMPIC RESEARCH CORNER  that they could be identified. The street children spontaneously took off their shirts. The high school students visibly did not want to. They felt that this was something the “poor” street children should do. The street children removed their shirts quickly and without complaining. Was this a way of protecting their clothing, so that it wouldn’t get ripped during the game, given how difficult it would be to replace it? The feeling of mistrust and inequality was present too when it came to choosing the referee; the street children were concerned that they might be unfairly treated. “He could be biased if he’s not one of ours”, said one of them. SHOW OF STRENGTH During the game, the street children wanted to show that they were physically stronger. Watching them play, it was obvious that their physiques were much more developed than their opponents. They were faster, stronger, and had more stamina. The feeling of being different led some of them to refuse to make first contact, even acting violently towards their own team-mates. But this aggression seems to have been somewhat strategic: they created chaos with the sole purpose of attacking the high-school students. Each player stuck closely to his team. The street children considered their team members as brothers. Initially, winning counted above all else, for both sides: the object was to beat the opposing team. STAGE 2: GRADUAL CHANGE IN BEHAVIOUR WINNING MEANS SHARING Gradually, the more games they played, the more crucial the games became. At one point, the street children decided to reorganise their team to even up the game and allow the other team to score a goal, to the delight of the crowd, which was mostly made up of street children. The main reason for this behaviour was to give the others a chance, to share and make everybody happy. In this way, little by little, the games changed the children’s viewpoints and behaviour, going beyond social factors and prejudice. The two groups of children gradually adapted to the values of each team,  56 OLYMPIC REVIEW  displaying a level of tolerance that had not existed at the start of the games. This adaptation improves cohabitation and social interactions. While the previous sessions had been marked by the street children’s rough behaviour, the games gradually started to change the way the children saw each other. Children of both groups asked to play more games. SELF-CONFIDENCE Giving the street children the chance to escape their social isolation and play with city children enabled them to compare themselves with each other and, in doing so, to find out what they were capable of. These children felt abandoned, but they realised that they were just like the others. Moreover, they were afraid that the “wealthy” children would be technically and tactically superior. But the field results show that a street child is even capable of asserting himself against a city child. STAGE 3: GROUP COHESION Fair play was gradually observed as the numbers of games increased: the players spontaneously held out their hand to help their opponent get up. When they sat down to share a friendly drink, the children formed little groups to swap stories about their daily lives; they spontaneously had the idea of merging the two groups to form a single team. SPORT TO PROMOTE SOCIAL COHESION By learning to appreciate each other’s qualities, observing fair play during their games, and developing their competitive spirit through football, the two groups of children were motivated to form a single team, thus breaking down the existing social barriers. This social integration is only the first step, however, because the street children go back to their ligalas and the high school children return to their parents’ homes. Other mechanisms must be put in place to integrate street children into society. It should be done in successive, complementary stages which allow sport not only to bring street children closer to other children, but to act as a springboard between the world of the street and the world of shelters. ■  Right The initial reaction of the high school students was one of surprise mixed with fear, but eventually the social barriers between them and the street children were broken down"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 56,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg57.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLYMPIC RESEARCH CORNER  ATHANASE NSENGIYUMVA  BACKGROUND INFORMATION  Born in Muramvya in the Republic of Burundi, Athanase Nsengiyumva, (pictured right) has a PhD in social and political sciences (specialising in anthropology), and teaches full-time at the University of Burundi. After obtaining a degree in sport and exercise, he continued his studies and now holds an international diploma in football coaching from the University of Leipzig (Germany), a specialist diploma in motor science from the Catholic University of Leuven (KU) in Belgium, and a diploma in anthropology from the same university. His doctoral thesis was on survival in the urban public space in Bujumbura. A member of KU’s Center of Prospective Anthropology (LAAP), he is the author of a number of ethnographic studies. In the field of the anthropology of sport and of the Olympic Movement, his research focus is street children.  The material used in this article comes from a field study carried out over a four-month period by six researchers who regularly observed two groups of children with different outlooks on life, putting them through the same sports programme, which served as the basis for them to develop a new perspective. Eight games were organised, and the observations made by the researchers provided data that enabled them to describe the evolution of the children’s behaviour in progressive phases, thus establishing a preand post-testing comparison. The study was conducted with the support of the NOC of Burundi, Olympic Solidarity and the IOC Centre for Olympic Studies. To read the complete study (in French only), entitled Intégration sociale des enfants de la rue : quand le sport fait la difference, please visit http://doc.rero.ch/record/30466  OLYMPIC REVIEW 57"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 57,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg58.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLYMPIC TORCH RELAY  ETERNAL FLAME AS THE COUNTDOWN COMMENCES TO THE START OF THE SOCHI 2014 TORCH RELAY, SET TO EMBARK ON ITS JOURNEY FROM MOSCOW ON 7 OCTOBER, WE TRACE THE HISTORY OF THIS LONG-STANDING OLYMPIC TRADITION THROUGH A SERIES OF PHOTOS FROM THE ARCHIVES  58 OLYMPIC REVIEW"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 58,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg59.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLYMPIC TORCH RELAY  OLYMPIA Prior to the Games the Olympic flame is lit in Olympia, Greece, the spiritual home of the Olympic Games. A priestess ignites a torch by placing it inside a parabolic mirror that focuses the sun’s rays. In a ceremony that reflects ancient Greek rituals, she then lights the torch of the first torchbearer, initiating the start of the flame’s epic journey to the host city’s Olympic stadium.  BERLIN 1936 Following the introduction of the Olympic flame at the Olympic Games in Amsterdam in 1928, the Berlin Games in 1936 saw the inaugural Olympic Torch Relay, pioneering the concept of transferring the flame from Olympia via a relay system to the Olympic venue. In total, the torch travelled 3,187 kilometres and was carried by 3,331 runners over the course of 12 days on its journey from Greece to Berlin.  I  t only requires a look back last year to the Games in London to appreciate the significance of the Olympic Torch Relay. Millions of people lined the route to cheer the 8,000 people who helped carry the torch on its 8,000-mile journey. It was also a chance to mark the achievements of inspirational people in local communities across the length and breadth of Great Britain. The Olympic Torch Relay has come a long way since its first incarnation at the 1936 Games in Berlin. The torch has travelled via some highly inventive methods down the years, including by camel, by bicycle and even underwater by scuba diver. In 1994, for the Games in Lillehammer,  two parachute jumpers exchanged the torch in mid-air, and during the Calgary 1988 Torch Relay the flame travelled through the Arctic Circle, with stages carried out on snow-bike and skidoo. For each edition of the Games a new model of torch is designed, and while the journey the relay takes is similarly everchanging, the symbolic significance of the relay has always remained the same. Uniting the host nation in the very best ideals of Olympism, the Torch Relay represents a continuation of the spirit of the ancient Olympic Games, and in October this year it will re-commence when the flame begins its epic journey to light the cauldron for Sochi 2014.  OLYMPIC REVIEW 59"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 59,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg60.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLYMPIC TORCH RELAY  LONDON 1948 The second time a Torch Relay was held for the Olympic Games, this relay was dubbed the “relay of peace” following the end of the Second World War. In a symbolic gesture, the first runner, Corporal Dimitrelis of the Greek Army, laid down his arms and removed his military uniform before carrying the torch. Pictured is British Olympic athlete, John Mark, carrying the flame on the final leg of its journey into Wembley Stadium, where he lit the Olympic cauldron.  CORTINA D’AMPEZZO 1956 The flame used for the Torch Relay in 1956 was a symbolic one, having been lit at the Temple of Jupiter in Rome. Pictured is Alpine ski racer Zeno Colo, who won downhill gold at the 1952 Winter Games in Oslo, receiving the Olympic flame. Speed skater Guido Caroli went on to light the cauldron.  60 OLYMPIC REVIEW"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 60,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg61.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLYMPIC TORCH RELAY  MELBOURNE 1956 After Greek runners carried the flame to Athens, it was transferred to a miner’s lamp and flown to Australia. The Torch Relay commenced in Cairns, Queensland, with the local mayor, Alderman W.J. Fulton, lighting the first torch. At the time, the relay’s 3,000-mile road journey across Australia was the longest in Olympic history. The final torchbearer was Australian middle distance runner Ron Clarke, who lit the cauldron inside the Melbourne Cricket Ground.  OLYMPIC REVIEW 61"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 61,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg62.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLYMPIC TORCH RELAY  62 OLYMPIC REVIEW"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 62,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg63.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLYMPIC TORCH RELAY  ROME 1960 The participation of ancient cities in the Olympic Games was renewed during the 1960 Torch Relay, which followed the same course as that taken by the ancient Greeks when they founded their colonies in Italy, passing through famous locations with Greek heritage such as Sicily and Magna Graecia. Pictured left is the final torchbearer, Italian athlete Giancarlo Peris, as he ascends the steps to the Olympic cauldron.  MEXICO 1968 This relay was designed to replicate the route taken by Christopher Columbus in his first visit to the New World, and celebrate the link between Latin American and Mediterranean civilisations, as the torch covered a distance of 13,620 kilometres. This was the first time the Olympic cauldron was lit by a female athlete, Mexican sprint hurdler Norma Enriqueta Basilio, pictured here climbing the stairs with the Olympic torch. It was also the first time runners from different nations took part in the relay.  OLYMPIC REVIEW 63"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 63,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg64.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLYMPIC TORCH RELAY  MONTREAL 1976  SEOUL 1988  In a break from tradition, the 1976 Torch Relay saw the flame travel from Greece to Canada via satellite, the arrival of the signal from Athens activating a laser that recreated the Olympic flame in Ottawa in a 90cm urn. Pictured above are the two final torchbearers, Canadian teenagers Stephane Prefontaine and Sandra Henderson, who became the first Torch Relay runners to co-light the cauldron.  Starting at South Korea’s most southerly point, Cheju Island, the 1988 Torch Relay took a 4,168-kilometre route through 21 major cities before arriving at the Olympic Stadium in Seoul, pictured during the Opening Ceremony. During its 22-day journey the torch was relayed in various ingenious ways including on horseback, and aboard ships, cars and bicycles. A total of 3,300 torches were used.  64 OLYMPIC REVIEW"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 64,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg65.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLYMPIC TORCH RELAY  ALBERTVILLE 1992 Renowned French designer, Philippe Starck, was responsible for the 1992 torch design, which was made from stainless steel. Crossing Greece and France, the relay involved 5,500 torchbearers. The final leg of the relay saw the cauldron, pictured here, co-lit by French footballer Michel Platini and FrancoisCyrille Grange who, aged nine at the time, became the youngest cauldron lighter in history, and who went on to become an Alpine skier.  OLYMPIC REVIEW 65"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 65,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg66.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLYMPIC TORCH RELAY  LILLEHAMMER 1994 Lillehammer’s Torch Relay was remarkable for this spectacular ski jump made by Stein Gruben, who carried the flame on this dramatic descent as part of the Opening Ceremony of the Olympic Winter Games in 1994. Gruben only received the honour after the athlete originally tasked with the jump, Ole Gunnar Fidjestol, a bronze medallist at Calgary 1988, was injured during a practice jump.  66 OLYMPIC REVIEW"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 66,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg67.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLYMPIC TORCH RELAY  SYDNEY 2000 This relay witnessed the flame taken underwater for the first time. Pictured is marine biologist Wendy Craig-Duncan carrying the specially designed flare-like torch on a dive at Agincourt Reef, part of the Great Barrier Reef. The design of the torch reflected three key areas of Australian culture: the boomerang, the Sydney Opera House and the waters of the Pacific Ocean, Aboriginal athlete Cathy Freeman took the torch on the final steps of its journey, lighting the cauldron to mark the start of the Games.  ATHENS 2004 Greek windsurfer and Olympic gold medallist Nikolaos Kaklamanakis is pictured moments before lighting the cauldron during the Opening Ceremony in Athens in 2004. In Greece, the torch, made from olive wood and magnesium, covered 6,600 kilometres and stopped at 24 archaelogical and historical sites.  OLYMPIC REVIEW 67"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 67,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg68.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLYMPIC TORCH RELAY  VANCOUVER 2010 In honour of his son Jesse, who was originally intended to carry the torch but who had passed away the previous month, John Davidson is pictured in London, Ontario, on Christmas Eve 2009, during the Vancouver 2010 Olympic Torch Relay. This relay was notable for ice hockey great Wayne Gretzky becoming the first torchbearer to light two official cauldrons during the climax of the relay, helping light the indoor cauldron at BC Place Stadium before travelling on to Coal Harbour to light the outdoor cauldron.  LONDON 2012  SOCHI 2014  Here, Amelia HemplemanAdams, who at the age of 16 was the youngest person to ski to the South Pole, poses with the Olympic torch atop the iconic London Eye on Day 65 of the 70-day Torch Relay. The London 2012 relay involved 8,000 torchbearers and covered 8,000 miles, beginning at Land’s End in Cornwall and encompassing national heritage sites and major landmarks throughout the UK.  Commencing in Moscow on 7 October 2013 and ending in Sochi on 7 February 2014, this will be the longest relay in Olympic history in terms of both time – 123 days – and distance, covering more than 40,000 kilometres. The torch, which will travel through all 83 constituent regions of the Russian Federation, features the traditional colour of Russian sport, red, and reflects a feather of the Firebird, or Phoenix, prominent in Russian folklore as a symbol of good fortune and happiness.  68 OLYMPIC REVIEW"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 68,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg69.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 69,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg70.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLYMPIC SOLIDARITY  RIGHT ON TRACK OLYMPIC REVIEW CATCHES UP WITH TWO ATHLETES WHO HAVE RECEIVED A SCHOLARSHIP AS PART OF THE CURRENT OLYMPIC SOLIDARITY PROGRAMME  OLYMPIC SOLIDARITY Olympic Solidarity is the body that ensures that talented athletes, regardless of their financial status, have an equal chance of reaching the Olympic Games and succeeding in the Olympic arena. It is responsible for administering and managing the National Olympic Committees’ (NOCs’) share of the revenue from the sale of broadcasting rights to the Olympic Games. Working in particular with disadvantaged NOCs and their Continental Associations, Olympic Solidarity uses this money to develop a range of assistance programmes. The current quadrennial plan, which runs from 2013 to 2016, has a development and assistance budget of USD 435 million – an increase of nearly 40% on the 20092012 budget. This is the second time that Winter Games athletes have received Individual Olympic Scholarships following the successful debut of the programme in the build-up to Vancouver in 2010, when 325 athletes (193 men and 132 women) from 60 NOCs benefited from Solidarity funding. Of these, 227 athletes successfully qualified for the Games, winning 13 medals between them.  70 OLYMPIC REVIEW  Pictured Ivana Bulatovic on Mount Zlatibor in Serbia competing in a FIS women’s slalom race in 2013"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 70,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg71.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLYMPIC SOLIDARITY  INTERVIEW  IVANA BULATOVIC THE 18-YEAR-OLD ALPINE SKIER FROM MONTENEGRO RECEIVED A HUGE BOOST WHEN SHE WAS CHOSEN TO RECEIVE AN OLYMPIC SOLIDARITY SCHOLARSHIP, WHICH SHE HOPES WILL PROPEL HER THROUGH QUALIFICATION FOR THE 2014 OLYMPIC WINTER GAMES IN SOCHI  How did you get started in skiing? I skied for the first time aged six, and from the beginning I showed potential. The coach of a local club asked me to start competing, which I did, and I started to win medals. How much did you enjoy competing at the World Championships for the first time? My participation in the World Championships in Schladming this year is something that I will remember for a long time. It’s a special feeling to participate in an event like that and compete with the best skiers in the world. I felt the excitement especially at the finish line in front of so many spectators. For someone like me from a small country, it can be really motivating for the future. Have you had a chance to train with compatriots Milena Radojicic or Bojan Kosic? I’ve trained with Bojan Kosic almost my entire ski career and, to a slightly lesser extent, with Milena. Bojan was the only Montenegrin athlete to compete in Vancouver in 2010 and I have spoken  to him about it a lot. We are both very motivated to participate in the next Olympic Winter Games and give it our best. What would it mean to you to compete in Sochi in 2014? The dream of every athlete is to participate in an Olympic Winter Games, so I cannot describe how much that would mean to me. I think that it would be the greatest achievement of my life so far. What are your targets for the future? Beyond participation at Sochi, I want to get into good shape during my summer training so I can improve my skiing and continue competing as long as I am able to. How has your Olympic Solidarity Scholarship helped you? It has helped a lot because skiing involves a lot of travelling which can be expensive. The costs are high and we are not always able to afford things that help provide the best preparations, or to race in all the competitions we would like to. The scholarship has given me the opportunity to prepare in the best possible way.  What is a typical training week like for you? Whether in the gym or on the snow, I train every day. My summer training programme requires a two or three-hour session daily, so that when the season starts I can be fully prepared. Then we have ski training in the morning and fitness in the afternoon. What do you like to do in your spare time? Besides training and school, I hardly have time for other activities, but during the summer I do hiking, climbing and a few other extreme sports. I also really like reading books and spending time with friends. Who are your sporting heroes and why? I like Ivica Kostelic, from Croatia, because he reached the top of world skiing and yet he came from a small country. He proved that hard work pays off. I also like Marcel Hirscher (Austria) and Tina Maze (Slovenia). Do you use social networks to keep in touch with people? I spend a lot of time on Facebook. It helps me to keep in touch with people I have met abroad, and it’s a great way to stay in touch with my friends and family when I travel.  OLYMPIC REVIEW 71"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 71,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg72.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLYMPIC SOLIDARITY  Right Te-An Lien had his first Olympic experience at the inaugural Winter Youth Olympic Games in Innsbruck in 2012 Bottom right Pictured with Bulgarian athlete Aleksandar Poibrenski  72 OLYMPIC REVIEW"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 72,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg73.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLYMPIC SOLIDARITY  INTERVIEW  TE-AN LIEN TE-AN LIEN FROM CHINESE TAIPEI GOT HIS FIRST TASTE OF THE OLYMPIC STAGE AT THE INAUGURAL YOUTH OLYMPIC WINTER GAMES IN INNSBRUCK IN 2012. NOW HE IS HOPING TO QUALIFY FOR SOCHI 2014  How did you get started in luge?  What is a typical training week like for you?  I first took up the luge during the summer holiday of my second year of junior high school, when I was 14.  Physical training and weight training are an essential part of my regime at the moment. I do weight training twice a week and spend four hours each day doing physical training. When we’re not in competition, it’s less intensive. My training will get tougher and more concentrated during competition periods.  What has been your greatest sporting achievement so far? Competing in the Innsbruck 2012 Winter Youth Olympic Games, where I finished 20th. We stayed there for 14 days and it was really cold! It was so exciting and I was thrilled to compete with the world’s best young athletes. There were many interesting memories; I remember there was a guy from Bulgaria who didn’t have his right outfit, so I lent him one of mine. He was wearing my clothes when competing out there!  What do you like to do in your spare time? I really enjoy reading. I like learning about different topics, not just sports, as there are many more things in the world. Apart from that, I often go to the cinema or the shopping mall, or just hang out with my friends. Who are your sporting heroes and why?  What would it mean to you to compete in Sochi 2014?  At the moment my hero is Tommy Chen [ultra marathon runner]. He always has  a super positive attitude whenever he’s facing challenges. He is tough yet modest. Around two years ago, when I was trying to qualify for the 2012 Winter Youth Olympic Games, I was nervous. I asked Tommy on Facebook what I should do to ease my fears. He told me, “Treat fears as part of your life, then you won’t feel the fear anymore”. Because of this motto, I worked hard and qualified for the YOG as the only Asian luger. That’s why I appreciate and admire him so much. Do you use social networks, such as Twitter and Facebook, to keep in touch with people? Yes, I use Facebook a lot. I have a fan page and personal page. It’s good because I can use it to connect with my friends wherever they are. I enjoy keeping in touch with people on Facebook.  I am doing my best to qualify. It would mean a lot to be in Sochi in 2014 and of course I very much want to be part of it. I am still young and it would feel so different to participate in the Olympic Winter Games. It would enable me to see different things and broaden my horizons – an opportunity that many of my peers will never have. What are your targets for the future? First of all, I want to improve my world ranking in the luge. Then, in the future, I would like to be a sports director or a coach, or to serve on a sports committee. How has your Olympic Solidarity Scholarship helped you? Most of my training is done in Europe or America, so it can be very expensive. Any support, no matter how small, can be very useful, so the scholarship has definitely helped me in terms of financial support.  OLYMPIC REVIEW 73"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 73,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg74.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "MY GAMES  INTERVIEW: BIZUAYEHU WAGAW  MY GAMES TIRUNESH DIBABA ETHIOPIA’S TIRUNESH DIBABA LOOKS BACK AT A REMARKABLE OLYMPIC CAREER THAT FEATURES FIVE OLYMPIC MEDALS, INCLUDING DOUBLE GOLD IN THE 5,000M AND 10,000M IN BEIJING IN 2008  I  don’t remember that much immediately prior to the 2004 Games in Athens. At the time, I wasn’t fully aware of the importance of the Olympic Games, or National Competitions or World Championships. Even when I won a bronze medal in Athens, I didn’t fully appreciate what I had achieved. I was only 19 and I had become the youngest Ethiopian to win an Olympic medal. After that, when people started to talk about the Olympic Games, I began to understand the significance and integrity of the Games and that winning an Olympic medal meant that your name would go down in history. My elder sister Ejegayehu won an Olympic silver medal in 2004 so I guess it runs in the family genes. My cousin Derartu Tulu was a double Olympic 10,000m champion. Sentayehu Eshetu, who also coached Kenenisa Bekele, knew my cousin and my sister and encouraged me to start running. From a young age he used to tell me I would be a great runner.  74 OLYMPIC REVIEW  Before Beijing, I was further inspired by my fiancé, Sileshi [Sihine], whom I was to marry after the Games. He was twice a silver medal winner in the 10,000m, at the 2004 and 2008 Olympic Games, and he wanted me to go one better. I will never forget the Beijing Olympic Games. Winning double Olympic gold was the highlight of my sporting career. The 10,000m was a tough race and I had to break the Olympic record to win it. A week later I won the 5,000m as well. I was ecstatic. I came to London with the aim of repeating the feat. But I couldn’t train for nine days because of illness and I began to doubt not only if I could win in London, but whether I could compete at all. I did not even have the energy to go upstairs to bed so I slept in the living room. But I made the start line and ran very well in the 10,000m and won a second Olympic gold medal at that distance, my third in total. The fact that I was battling with illness made it all the more special.  Each of the three Games has had its own special touches. At London 2012 the fans surprised me and created a special atmosphere; it was amazing to compete in front of such a packed stadium. And Beijing was unforgettable because I was able to realise my goals. I still have ambitions to do something really special, something historic and unforgettable, especially in the Olympic marathon – I believe that is what is left for me to achieve. ■ Right Dibaba on her way to gold in Beijing ATHENS 2004 Bronze: 5,000m BEIJING 2008 Gold: 10,000m, 5,000m LONDON 2012 Gold: 10,000m Bronze: 5,000m"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 74,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg75.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 75,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg76.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "With the host city of the 2020 Olympic Games due to be announced at the 125th IOC Session in Buenos Aires in September, Olympic Review profiles each of the Candidate Cities – Istanbul (Turkey), Tokyo (Japan) and Madrid (Spain) – ahead of the vote.  Olympic Review has a cover price of 10 Swiss Francs per issue (not including postage). To subscribe to the magazine, please tick your preferred language version below (French/English/Spanish) and choose one of the three payment methods.  ■ FRENCH ■ ENGLISH ■ SPANISH  I would like to subscribe to Olympic Review for one year. Please tick one of the boxes below to indicate your mailing address. Subscription for one year is:  ■ 50 CHF - Mailing address in EUROPE ■ 70 CHF - Mailing address in REST OF WORLD The subscription fee will be sent by (please tick one box):  Please send the subscription form below to: Olympic Review Subscriptions, Château de Vidy, c. p. 356, 1007 Lausanne, Switzerland; Fax + 41 21 621 6356  FIRST NAME LAST NAME ORGANISATION ADDRESS  ■ Bank transfer to the IOC account 243-312883.03Q, to UBS SA, 1002 Lausanne (BIC: UBSWCHZH80A IBAN CH41 0024 3243 3128 8303 Q); ■ International postal order in Swiss Francs addressed to the Olympic Museum Lausanne, Publications service, P.O. Box 1121, 1001 Lausanne, Switzerland. ■ Visa credit card only (please indicate the card holder, card number and expiry date below and post to the address above).  CARD HOLDER VISA CARD NO  POST/ZIP CODE  EXPIRY DATE  COUNTRY  SIGNATURE  E-MAIL  76 OLYMPIC REVIEW"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 76,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg77.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 77,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg78.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OBITUARIES  PEDRO RAMÍREZ VÁZQUEZ IOC HONORARY MEMBER AND FORMER PRESIDENT OF THE MEXICAN NOC  IOC honorary member Pedro Ramírez Vázquez has passed away at the age of 94. An IOC member from 1972 to 1995, Vázquez was chairman of the Cultural Commission (19801994) and a member of several IOC commissions. He became an IOC honorary member in 2005. Vázquez was a Vice-President then President of the Organising Committee for the Games of the XIX Olympiad in Mexico City in 1968 and President of the Mexican National Olympic Committee from 1972 to 1974. An architecture graduate from the National Autonomous University of Mexico City, Vázquez enjoyed a successful career as an architect and was the author of numerous books that have been distributed worldwide. Considered the founder of modern Mexican architecture, Vázquez was also the architect of the IOC headquarters in Lausanne (1986), the IOC Pavilion at the Seville EXPO (1992) and The Olympic Museum in Lausanne (1993). He was Rector of the University of Mexico City, Rector and Founder of the Metropolitan Autonomous University, and Minister of Human Settlements and Public Works (19761982). He was awarded the Olympiart Prize in 1996. A lover of sport and long-time supporter of the Olympic Movement, Vázquez also played football at university.  78 OLYMPIC REVIEW  BARON FRANÇOIS NARMON FORMER BELGIAN NOC PRESIDENT AND IOC MEMBER FROM 2002-2004  Former Belgian NOC President Baron François Narmon died at the age of 79. He served as NOC President from 1998 to 2004, and was made an IOC member by the Session in Salt Lake City in 2002, a position he held until 2004. Later that year in Athens, he was awarded the Olympic Order in recognition of his important contribution to the development of sport and the Olympic Movement both nationally and internationally.  JEAN PICKERING RELAY BRONZE MEDALLIST AT THE 1952 OLYMPIC GAMES IN HELSINKI  Olympic bronze medallist Jean Pickering has died, aged 83. The British track and field athlete was nicknamed the “fairy godmother” of British athletics for her fundraising efforts over 22 years, following her international career. When her husband Ron, a national coach and commentator, died in 1991, she founded the Ron Pickering Memorial Fund to help finance young athletes. After winning 4x100m bronze in the Olympic Games in Helsinki in 1952, she added a European long jump gold medal two years later."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 78,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg79.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OBITUARIES  HJALMAR ANDERSEN MIRJA HIETAMIES  Norwegian speed skater Hjalmar Andersen, who became the first man to win three speed skating gold medals at one edition of an Olympic Winter Games, died on 27 March, aged 90. Andersen won the 1,500m, 5,000m and 10,000m races in front of his home crowd in Oslo in 1952. His grandson, Fredrik van der Horst, represented Norway in speed skating at the Olympic Winter Games in 2010.  Finnish cross-country Olympic champion Mirja Hietamies has passed away, aged 82. Having won Olympic silver medal in the 10km in Oslo in 1952, Hietamies went one better four years later by winning the Olympic 3x5km race in Cortina d’Ampezzo, Italy.  ANDREW SIMPSON British yachtsman and Olympic gold medallist Andrew Simpson has died in a training accident, aged 36. Simpson, known to fellow sailors as “Bart”, won a gold medal in the Star class with his long-term sailing partner, Iain Percy, at the 2008 Olympic Games in Beijing. The two campaigned again in the Star class in Weymouth, at the 2012 Olympic Games, where they won a silver medal. Simpson was part of the Artemis Racing team, a challenger for the forthcoming America’s Cup, when the accident occurred in May in the San Francisco Bay, USA.  PIETRO MENNEA FORMER 200M OLYMPIC CHAMPION AND WORLD RECORD HOLDER  ANGELA VOIGT  Italian sprinter Pietro Mennea passed away on 21 March, aged 60. He won gold in the 200m and bronze in the 4x400m relay at the Olympic Games in Moscow in 1980, as well as a bronze in the 200m eight years earlier in Munich. Mennea set the 200m world record record of 19.72 seconds on 12 September 1979, at the World University Games at high altitude in Mexico City, breaking Tommie Smith’s record of 19.83, which had been set on the same track at the 1968 Olympic Games. The record stood for almost 17 years, until Michael Johnson ran 19.66 in 1996. Mennea also won four gold medals at European championships – three outdoor and one indoor – as well as 4x100m silver and 200m bronze at the 1983 World Championships. He still holds the European and Italian records in the 200m.  Olympic long jump gold medallist Angela Voigt has died, aged 61. Voigt won gold for East Germany in Montreal in 1976 with a jump of 6.72m. She also held the long jump world record for 10 days in May 1976, after jumping 6.92m, and won silver at the 1978 European Championships.  OLYMPIC REVIEW 79"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 79,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg80.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "LONDON 2012 OLYMPIC AND PARALYMPIC GAMES: THE OFFICIAL COMMEMORATIVE BOOK  With a foreword by Lord Sebastian Coe, this official keepsake covers all the highlights of the London 2012 Olympic and Paralympic Games. It traces the whole incredible story from the initial preparations to the events themselves, including the construction of the Olympic Park, the Olympic Torch Relay and the Cultural Olympiad. Through its pages, filled with stunning photographs and inspiring quotations, readers will be able to relive the highs and lows of the Olympic athletes. Each event is explored in detail, from the sweetest victories and outstanding performances to the spectators and the role of the volunteers. The final chapter is packed full of statistics, with a table of medal winners for each event. Beautifully illustrated throughout, the book visually captures the spirit of London 2012: the perfect souvenir from an unforgettable summer.  TOM KNIGHT AND SYBIL RUSCOE. WILEY, 2012. ISBN: 9781119973140, 312 PAGES.  Right The Olympic cauldron burns during London 2012  THE MAKING OF THE QUEEN ELIZABETH OLYMPIC PARK  BEARING LIGHT: FLAME RELAYS AND THE STRUGGLE FOR THE OLYMPIC MOVEMENT  John C. Hopkins and Peter Neal. Wiley, 2013. ISBN: 9781119940692, 287 pages.  John MacAloon. Routledge, 2013. ISBN: 9780415448321, 208 pages.  This is the story of the making of the Olympic Park in London’s neglected, post-industrial East End. The aim was to regenerate and modernise East London, which has always lagged behind the rest of the capital in its development. Over a period of five years more than 40,000 people were involved in the project, writing a new chapter in the history of modern urbanisation. Written by two architects central to the project, this beautifully illustrated book provides an in-depth account of the planning, design and construction of the Olympic Park, drawing largely on the contributions of experts and interviews with the project’s key stakeholders. Looking beyond the London 2012 Olympic Games, the authors demonstrate how sustainable development is at the heart of their contemporary urban park project.  The relay that brings the Olympic torch to the host country’s Olympic Stadium is one of the more symbolic events associated with the Games, celebrating the universality of the Olympic spirit. This book is the first anthropological study of the ritual, examining its transformation over the past few decades since the Los Angeles Games of 1984. Supported by previously unpublished archive materials and interviews with key players, MacAloon offers a behind-the-scenes analysis that draws the reader into the negotiations between the Olympic Games organising committees, national governments, the Greek Olympic movement, the International Olympic Committee and sponsors.  80 OLYMPIC REVIEW  SPORTING TIMES Kate Woodward. Palgrave Macmillan, 2013. ISBN: 9781137275356, 104 pages. Time is everywhere in sport: time pressure, timing, time trials, time out, extra time. In every sporting event athletes compete not only against other competitors, but against the clock. Around the concept of time, Kate Woodward explores various themes in Sporting Times, such as movement, the body, memory, disability, gender, sports reporting, technology and the role of the past and the future in sport, as well as more obvious aspects such as determining the length of a match and measuring records. This unique, captivating book provides definitive proof of the fundamental link between sport and time.  Selection proposed by the IOC Library, Olympic Studies Centre, 1, Quai d’Ouchy, P.O. Box 1001 Lausanne, Switzerland. Tel. +41 (0)21 621 66 11. Fax +41(0)21 621 67 18. Visit www.olympic.org/library to learn more about our services."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 80,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg81.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "OLYMPIC REVIEW 81"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 81,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg82.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "LAWRENCE LEMIEUX THE OLYMPIC SPIRIT  The Canadian sailor was awarded the Pierre de Coubertin Medal for Sportsmanship after sacrificing his chances of winning a medal in the Finn class at the Olympic Games in Seoul in 1988 to come to the aid of two sailors who had capsized. Singapore’s Joseph Chan and Siew Shaw had been thrown into the water in windy conditions in a different event, the 470 class, and were unable to right their damaged boat. After Lemieux had sailed to the rescue, he waited for them to be transferred onto an official patrol boat before completing his race in 22nd place."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 82,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg83.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 83,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg84.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }]],
  "script": "\n      function idOf(id) {\n        return document.getElementById(id)\n      }\n  \n      function cOf(klass) {\n        return document.getElementsByClassName(klass)\n      }\n      \n      function removeContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) { \n          return e.className = 'addContentLink'\n        })\n      }\n  \n      function addContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) {\n          return e.className = 'contentLink addContentLink'\n        })\n      }\n  \n      function showOverlay(idx) {\n        idOf(idx).className = 'contentOverlay visible'\n      }\n  \n      function hideOverlay(idx) {\n        idOf(idx).className = 'contentOverlay hidden noclick'\n      }\n\n      function animateNumber(element){\n        if(element.getAttribute(\"data-number\")){\n          var args = JSON.parse(element.getAttribute(\"data-number\"));\n          var from = 0;\n          var to = 100;\n          var append = \"\";\n          var preppend = \"\";\n          var decimals = 0;\n          var duration = 1;\n          var ease = \"Linear.easeNone\";\n          var comma = false;\n          var separator = \",\";\n          var decChar = \".\";\n          for(obj in args){\n            if(obj == \"from\") from = args[obj];\n            if(obj == \"to\") to = args[obj];\n            if(obj == \"append\") append = args[obj];\n            if(obj == \"preppend\") preppend = args[obj];\n            if(obj == \"decimals\") decimals = args[obj];\n            if(obj == \"duration\") duration = args[obj];\n            if(obj == \"ease\") ease = args[obj];\n            if(obj == \"comma\") comma = args[obj];\n            if(obj == \"separator\") separator = args[obj];\n            if(obj == \"decChar\") decChar = args[obj];\n          }\n          var obj = {number: from}\n          TweenMax.to(obj, duration, {number: to, onUpdate: function(){\n            if(comma){\n              console.log(obj.number)\n              var str = obj.number.toFixed(decimals).toString();\n              var predec = str.split(/^d*/)[0];\n              console.log(\"PREDEC\", predec, typeof(predec));\n              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')\n              var comp = newstr.replace(/^,/, '')\n              console.log(\"NEWSTR\", newstr, typeof(newstr));\n              // console.log({newstr})\n              // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : \"\";\n              // if(dp[0]) dp = dp[0].replace(\".\", decChar);\n              var dp = \"\";\n              element.innerHTML = preppend+comp+dp+append;\n            }else{\n              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(\".\", decChar)+append;\n            }\n          }, ease: eval(ease)});\n        }else{\n          return;\n        }\n      }\n\n      function resetNumbers(ele){\n        var numbers = cOf(ele)\n        for(var i=0; i<numbers.length; i++) {\n          numbers[i].innerText= \"\"\n        }\n      }\n    ",
  "mobilePages": null,
  "mobileTemplate": null
});
// CONCATENATED MODULE: ./src/router/index.js





vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);
/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  base: src_document.basePath,
  routes: [{
    path: '/',
    name: 'Home',
    component: src_components_PublishPage,
    redirect: '/1-1'
  }, {
    path: '/:page-:section',
    name: 'PublishPage',
    component: src_components_PublishPage
  }]
}));
// CONCATENATED MODULE: ./src/store/actions.js





/* harmony default export */ var actions = ({
  goToPage: function goToPage(context, payload) {
    if (payload === null) {
      // console.log('Page does not exist')
      return;
    }
    if (typeof payload == "number") {
      if (context.getters.pageInRange(payload, 1)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          console.log('TEST 1');
          router.push(context.getters.routeFromIndex(payload - 1, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        }
      }
    } else {
      if (context.getters.pageInRange(payload.pageIndex, payload.sectionIndex)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          router.push(context.getters.routeFromIndex(payload.pageIndex - 1, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload.pageIndex, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        }
      }
    }
  },

  goToPreviousPage: function goToPreviousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  goToNextPage: function goToNextPage(context) {
    if (context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  previousPage: function previousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  nextPage: function nextPage(context) {
    if (context.getters.nextNextPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  goToPreviousMobilePage: function goToPreviousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  goToNextMobilePage: function goToNextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  goToPreviousSection: function goToPreviousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  goToNextSection: function goToNextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },
  previousMobilePage: function previousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  nextMobilePage: function nextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  previousSection: function previousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  nextSection: function nextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },

  resetSectionIndices: function resetSectionIndices(context) {
    var sectionIndices = context.getters.pages.map(function (page, index) {
      if (index == context.getters.zeroedPageIndex) return context.getters.sectionIndex - 1;
      return page.startIndex || 0;
    });
    context.commit('RESET_SECTION_INDICES', sectionIndices);
  },

  updateVideoURL: function updateVideoURL(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  openVideo: function openVideo(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  setInitialWindowSize: function setInitialWindowSize(context, payload) {
    context.commit('UPDATE_INITIAL_WINDOW_SIZE', extends_default()({}, payload));
  },
  changeWindowSize: function changeWindowSize(context, payload) {
    var pageWidth = context.getters.width;
    var pageHeight = context.getters.height;
    var windowWidth = payload.width;
    var windowHeight = payload.height - 48;
    var widthRatio = windowWidth / pageWidth;
    var heightRatio = windowHeight / pageHeight;
    if (context.getters.doublePage) {
      if (windowWidth / (pageWidth * 2) < heightRatio) {
        context.commit('UPDATE_IS_DOUBLE_PAGE', false);
      } else {
        context.commit('UPDATE_IS_DOUBLE_PAGE', true);
      }
    }

    if (pageWidth <= windowWidth && pageHeight <= windowHeight) {
      var newScale = Math.min(widthRatio, heightRatio);
      // console.log('widthratio', widthRatio)
      // console.log('heightratio', heightRatio)
      context.commit('UPDATE_PAGE_SCALE', { pageScale: newScale });
    } else {
      var _newScale = Math.min(widthRatio, heightRatio);
      context.commit('UPDATE_PAGE_SCALE', { pageScale: _newScale });
    }
  },

  checkMobileLanding: function checkMobileLanding(context, payload) {
    var isMobile = context.getters.isMobile;
    var landingPage = context.getters.currentMobilePage;
    var mobileSwitch = context.getters.mobileSwitch;
    if (!mobileSwitch || !isMobile) return;
    if (landingPage) {
      return;
    } else {
      router.replace('/1-1');
    }
  },

  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    // if(newX < -context.getters.width  ) newX = (-context.getters.width -  100) / newZ
    // if(newY < -context.getters.height ) newY = (-context.getters.height - 100) / newZ
    // if(newX > context.getters.width ) newX = (context.getters.width + 100) / newZ
    // if(newY > context.getters.height) newY = (context.getters.height + 100) / newZ
    console.log("Update Zoom: " + newZ + ", " + newX + ", " + newY + ", " + context.state.pageScale);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  pinchZoom: function pinchZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY / newZ;
    // if(newX < -context.getters.width  ) newX = -context.getters.width -  100
    // if(newY < -context.getters.height ) newY = -context.getters.height - 100
    // if(newX > context.getters.width ) newX = context.getters.width + 100
    // if(newY > context.getters.height) newY = context.getters.height + 100
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  panZoom: function panZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - payload.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY - payload.zoomOriginY / newZ;
    console.log("Pan Zoom: " + newZ + ", " + newX + ", " + newY);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: context.state.zoomLevel });
  },
  openGallery: function openGallery(context, payload) {
    context.commit('UPDATE_GALLERY', payload);
  },
  openGalleryTwo: function openGalleryTwo(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload[1]);
    context.commit('UPDATE_GALLERY', payload[0]);
  },
  closeGallery: function closeGallery(context, payload) {
    context.commit('UPDATE_GALLERY', []);
  },
  goToGallerySlide: function goToGallerySlide(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload);
  },
  nextGallerySlide: function nextGallerySlide(context, payload) {
    if (context.state.galleryIndex < context.state.galleryImages.length - 1) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex + 1);else context.commit('UPDATE_GALLERY_INDEX', 0);
  },
  previousGallerySlide: function previousGallerySlide(context, payload) {
    if (context.state.galleryIndex > 0) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex - 1);else context.commit('UPDATE_GALLERY_INDEX', context.state.galleryImages.length - 1);
  },


  updateAudioURL: function updateAudioURL(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  },

  openAudio: function openAudio(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  }
});
// EXTERNAL MODULE: ./node_modules/util/util.js
var util = __webpack_require__("OMJi");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// CONCATENATED MODULE: ./src/store/getters.js


/* harmony default export */ var getters = ({
  title: function title(state) {
    return state.document.title;
  },
  description: function description(state) {
    return state.document.description;
  },
  basePath: function basePath(state) {
    return state.document.basePath;
  },
  pages: function pages(state) {
    return state.document.pages.map(function (page, pageIndex) {
      return page.map(function (section, sectionIndex) {
        section.pageIndex = pageIndex;
        section.sectionIndex = sectionIndex;
        return section;
      });
    });
  },
  videoURL: function videoURL(state) {
    return state.videoURL;
  },
  audioURL: function audioURL(state) {
    return state.audioURL;
  },
  showContents: function showContents(state) {
    return state.activePanel == "Contents";
  },
  showLanguages: function showLanguages(state) {
    return state.activePanel == "Languages";
  },
  showSearch: function showSearch(state) {
    return state.activePanel == "Search";
  },
  showGuide: function showGuide(state) {
    return state.activePanel == "Guide";
  },
  showEditions: function showEditions(state) {
    return state.activePanel == "Editions";
  },
  isZoomed: function isZoomed(state) {
    return state.zoomLevel != 1;
  },
  zoomLevel: function zoomLevel(state) {
    return state.zoomLevel;
  },
  companyLogo: function companyLogo(state, getters) {
    if (state.document.companyLogo != "") {
      return getters.basePath + "/static/_content/" + state.document.companyLogo;
    } else return getters.basePath + "/static/kp-logo-white.svg";
  },
  galleryImages: function galleryImages(state) {
    return state.galleryImages;
  },
  galleryCaptions: function galleryCaptions(state) {
    return state.document.options.galleryCaptions;
  },
  galleryIndex: function galleryIndex(state) {
    return state.galleryIndex;
  },
  isGalleryOpen: function isGalleryOpen(state) {
    return state.galleryImages.length > 0;
  },
  isMobile: function isMobile(state, getters) {
    return function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|)|g1 u|g560|gene|gf-5|g-mo|go(.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) return true;
    }(navigator.userAgent || navigator.vendor || window.opera) ? true : false;
  },
  isIE11: function isIE11(state, getters) {
    return !!navigator.userAgent.match(/Trident\/7\./);
  },
  isPhantom: function isPhantom(state, getters) {
    return !!(navigator.userAgent.match("PhantomJS") != null);
  },
  initialWindowWidth: function initialWindowWidth(state) {
    return state.initialWindowWidth;
  },
  initialWindowHeight: function initialWindowHeight(state) {
    return state.initialWindowHeight;
  },
  publishURL: function publishURL(state) {
    return state.document.publishURL;
  },
  doublePage: function doublePage(state) {
    return state.document.options.doublePage;
  },
  contentsEnabled: function contentsEnabled(state) {
    return state.document.options.contentsEnabled;
  },
  downloadEnabled: function downloadEnabled(state) {
    return state.document.options.downloadEnabled;
  },
  languagesEnabled: function languagesEnabled(state) {
    return state.document.options.languagesEnabled;
  },
  readerEnabled: function readerEnabled(state) {
    return state.document.options.readerEnabled;
  },
  printEnabled: function printEnabled(state) {
    return state.document.options.printEnabled;
  },
  searchEnabled: function searchEnabled(state) {
    return state.document.options.searchEnabled;
  },
  guideEnabled: function guideEnabled(state) {
    return state.document.options.guideEnabled;
  },
  editionsEnabled: function editionsEnabled(state) {
    return state.document.options.editionsEnabled;
  },
  zoomEnabled: function zoomEnabled(state) {
    return state.document.options.zoomEnabled;
  },
  mobileSwitch: function mobileSwitch(state) {
    return state.document.options.mobileSwitch;
  },
  rightToLeft: function rightToLeft(state, getters) {
    return state.document.options.rightToLeft;
  },
  pagesVisible: function pagesVisible(state, getters) {
    return !getters.showSearch;
  },
  downloadPath: function downloadPath(state, getters) {
    return state.document.options.downloadPath;
  },
  width: function width(state) {
    return state.document.width;
  },
  height: function height(state) {
    return state.document.height;
  },
  languages: function languages(state) {
    return state.document.languages;
  },
  currentLanguage: function currentLanguage(state) {
    return state.document.currentLanguage;
  },
  editions: function editions(state) {
    return state.document.editions;
  },
  zeroedPageIndex: function zeroedPageIndex(state, getters) {
    return getters.pageIndex - 1;
  },
  zeroedSectionIndex: function zeroedSectionIndex(state, getters) {
    return getters.sectionIndex - 1;
  },
  currentPages: function currentPages(state, getters) {
    return getters.pages[getters.zeroedPageIndex];
  },
  currentPage: function currentPage(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  currentSection: function currentSection(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  routeFromIndex: function routeFromIndex(state, getters) {
    return function (pageIndex, sectionIndex) {
      return "/" + pageIndex + "-" + sectionIndex;
    };
  },
  externalResources: function externalResources(state) {
    return state.document.externalResources;
  },
  pageInRange: function pageInRange(state, getters) {
    return function (pageIndex, sectionIndex) {
      return (getters.pages[pageIndex - 1] || [])[sectionIndex - 1] !== undefined;
    };
  },
  isDoublePage: function isDoublePage(state, getters) {
    return state.isDoublePage;
  },
  visiblePages: function visiblePages(state, getters) {
    if (state.isDoublePage && getters.doublePage) {
      if (getters.zeroedPageIndex == 0) {
        return {
          previousLeftPage: null,
          previousRightPage: null,
          leftPage: null,
          previousSection: getters.previousSection,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else if (getters.nextPage == null && getters.nextNextPage == null) {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: null,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: null,
          nextRightPage: null
        };
      } else if (getters.zeroedPageIndex % 2 != 1) {
        return {
          previousLeftPage: getters.previousPreviousPreviousPage,
          previousRightPage: getters.previousPreviousPage,
          previousSection: getters.previousSection,
          leftPage: getters.previousPage,
          rightPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: getters.currentPage,
          rightPage: getters.nextPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextNextPage,
          nextRightPage: getters.nextNextNextPage
        };
      }
    } else {
      return {
        previousPreviousPage: getters.previousPreviousPage,
        previousPage: getters.previousPage,
        previousSection: getters.previousSection,
        currentPage: getters.currentPage,
        nextSection: getters.nextSection,
        nextPage: getters.nextPage,
        nextNextPage: getters.nextNextPage
      };
    }
  },
  previousPreviousPreviousPage: function previousPreviousPreviousPage(state, getters) {
    if (getters.pageIndex <= 3) return null;
    return getters.pages[getters.pageIndex - 4][state.sectionIndices[0]];
  },

  previousPreviousPage: function previousPreviousPage(state, getters) {
    if (getters.pageIndex <= 2) return null;
    return getters.pages[getters.pageIndex - 3][state.sectionIndices[0]];
  },

  previousPage: function previousPage(state, getters) {
    if (getters.pageIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 2][state.sectionIndices[0]];
  },

  nextPage: function nextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length) return null;
    return getters.pages[getters.pageIndex][state.sectionIndices[0]];
  },

  nextNextPage: function nextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 1) return null;
    return getters.pages[getters.pageIndex + 1][state.sectionIndices[0]];
  },

  nextNextNextPage: function nextNextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 2) return null;
    return getters.pages[getters.pageIndex + 2][state.sectionIndices[0]];
  },

  previousSection: function previousSection(state, getters) {
    if (getters.sectionIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex - 2];
  },

  nextSection: function nextSection(state, getters) {
    if (getters.sectionIndex >= getters.pages[getters.pageIndex - 1].length) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex];
  },

  previousPageURI: function previousPageURI(state, getters) {
    if (getters.previousPage == null) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.previousPreviousPage == null) {
        return getters.routeFromIndex(1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex - 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex - 1, state.sectionIndices[getters.pageIndex - 2] + 1);
  },

  nextPageURI: function nextPageURI(state, getters) {
    if (getters.nextPage == null || getters.nextPage.index == Publish.$store.state.document.pages.length) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.nextNextPage == null) {
        return getters.routeFromIndex(Publish.$store.state.document.pages.length - 1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex + 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex + 1, state.sectionIndices[getters.pageIndex] + 1);
  },

  previousSectionURI: function previousSectionURI(state, getters) {
    if (getters.previousSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex - 1);
  },

  nextSectionURI: function nextSectionURI(state, getters) {
    if (getters.nextSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex + 1);
  },

  previousPageIndices: function previousPageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: getters.pageIndex - 1,
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  previousDoublePageIndices: function previousDoublePageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: Math.ceil(getters.pageIndex - 2),
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  nextPageIndices: function nextPageIndices(state, getters) {
    if (getters.nextPage == null) return null;
    return {
      pageIndex: getters.pageIndex + 1,
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  nextDoublePageIndices: function nextDoublePageIndices(state, getters) {
    if (getters.nextNextPage == null) return null;
    return {
      pageIndex: 2 * parseInt((getters.pageIndex + 2) / 2.0),
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  previousSectionIndices: function previousSectionIndices(state, getters) {
    if (getters.previousSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex - 1
    };
  },

  nextSectionIndices: function nextSectionIndices(state, getters) {
    if (getters.nextSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex + 1
    };
  },

  pageContainerStyle: function pageContainerStyle(state, getters) {
    var styleObject = {
      transform: "scale(" + getters.pageContainerZoomLevel * state.pageScale + ")"
    };
    if (state.zoomLevel !== 1) {
      styleObject.transformOrigin = state.zoomOriginX + "px " + state.zoomOriginY + "px";
    } else {
      styleObject.transformOrigin = "0px 0px";
    }
    return styleObject;
  },

  pageContainerZoomLevel: function pageContainerZoomLevel(state, getters) {
    return state.zoomLevel;
  },

  searchObject: function searchObject(state, getters) {
    var searchArray = [];
    getters.pages.forEach(function (sections, pageIndex) {
      sections.forEach(function (section, sectionIndex) {
        searchArray.push({
          id: pageIndex + 1 + "-" + (sectionIndex + 1),
          pageIndex: pageIndex + 1,
          sectionIndex: sectionIndex + 1,
          title: section.title,
          body: section.searchText || "",
          image: section.original || "",
          thumb: section.index + 1
        });
      });
    });
    return searchArray;
  },

  pageScripts: function pageScripts(state, getters) {
    return getters.pages.map(function (page, pageIndex) {
      return page.filter(function (e) {
        return e.script;
      }).map(function (section, sectionIndex) {
        return section.script.replace("onPageEnter", "p" + pageIndex + "s" + sectionIndex + "onPageEnter").replace("onPageLeave", "p" + pageIndex + "s" + sectionIndex + "onPageLeave");
      });
    }).reduce(function (a, b) {
      return a.concat(b);
    }).join("\n");
  },

  documentScript: function documentScript(state) {
    return state.document.script;
  },

  //#region Mobile
  mobilePages: function mobilePages(state) {
    return state.document.mobilePages;
  },
  mobilePageLink: function mobilePageLink(state, getters) {
    return function (page) {
      if (page.pageLinks.length) {
        var pageLink = page.pageLinks[0];
        return "/" + (pageLink.index + 1) + "-" + (pageLink.subIndex + 1);
      }
    };
  },
  currentMobilePage: function currentMobilePage(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch || getters.readerEnabled)) return;
    var currentPage = getters.mobilePages.find(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
    if (currentPage) return currentPage;else return null;
  },
  currentMobilePageIndex: function currentMobilePageIndex(state, getters) {
    if (!getters.mobilePages) return;
    return getters.mobilePages.findIndex(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
  },
  nextMobilePage: function nextMobilePage(state, getters) {
    if (getters.currentMobilePageIndex >= getters.mobilePages.length) return null;
    return getters.mobilePages[getters.currentMobilePageIndex + 1];
  },
  nextMobilePageIndices: function nextMobilePageIndices(state, getters) {
    if (getters.nextMobilePage == null) return null;
    return {
      pageIndex: getters.nextMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.nextMobilePage.pageLinks[0].subIndex + 1
    };
  },
  previousMobilePage: function previousMobilePage(state, getters) {
    if (getters.currentMobilePageIndex <= 0) return null;
    return getters.mobilePages[getters.currentMobilePageIndex - 1];
  },
  previousMobilePageIndices: function previousMobilePageIndices(state, getters) {
    if (getters.previousMobilePage == null) return null;
    return {
      pageIndex: getters.previousMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.previousMobilePage.pageLinks[0].subIndex + 1
    };
  },

  mobilePageContent: function mobilePageContent(state, getters) {
    return function (mobilePage) {
      return mobilePage.pageLinks.map(function (e) {
        return getters.pages[e.index][e.subIndex].mobileHtml;
      }).reduce(function (a, b) {
        return a + b;
      }, "");
    };
  }

  //#endregion

  //#region doublePage

  //#endregion
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./src/store/mutations.js


var _types$RESET_SECTION_;



/* harmony default export */ var mutations = (_types$RESET_SECTION_ = {}, defineProperty_default()(_types$RESET_SECTION_, RESET_SECTION_INDICES, function (state, payload) {
  state.sectionIndices = payload;
}), defineProperty_default()(_types$RESET_SECTION_, CHANGE_SECTION_INDEX, function (state, payload) {
  state.sectionIndices[payload.pageIndex] = payload.sectionIndex;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_PAGE_SCALE, function (state, payload) {
  state.pageScale = payload.pageScale;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_VIDEO_URL, function (state, payload) {
  state.videoURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_AUDIO_URL, function (state, payload) {
  state.audioURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel = "";
  } else {
    state.activePanel = "Languages";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_EDITIONS, function (state) {
  if (state.activePanel == "Editions") {
    state.activePanel = "";
  } else {
    state.activePanel = "Editions";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel = "";
  } else {
    state.activePanel = "Contents";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel = "";
  } else {
    state.activePanel = "Search";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_GUIDE, function (state) {
  if (state.activePanel == "Guide") {
    state.activePanel = "";
  } else {
    state.activePanel = "Guide";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  // console.log('toggleZoom', payload.zoomOriginX)
  if (state.zoomLevel != 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
  } else {
    state.zoomLevel = payload.zoomLevel || 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  }
  console.log("Toggle Zoom: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || 2;
  // console.log('update zoom', payload)
  console.log("Update Zoom: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
  if (state.zoomLevel < 1) {
    state.zoomLevel = 1;
    console.log("Update Zoom2: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_INITIAL_WINDOW_SIZE, function (state, payload) {
  state.initialPageWidth = payload.width;
  state.initialPageHeight = payload.height;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_IS_DOUBLE_PAGE, function (state, payload) {
  state.isDoublePage = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY, function (state, payload) {
  state.galleryImages = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY_INDEX, function (state, payload) {
  state.galleryIndex = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_READER, function (state, payload) {
  state.isReader = !state.isReader;
}), _types$RESET_SECTION_);
// CONCATENATED MODULE: ./src/store/modules/contents.js



// initial state
var state = {
  showContents: false

  // getters
};var contents_getters = {};

// actions
var contents_actions = {};

// mutations
var contents_mutations = defineProperty_default()({}, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel == "";
  } else {
    state.activePanel == "Contents";
  }
});

/* harmony default export */ var contents = ({
  state: state,
  getters: contents_getters,
  actions: contents_actions,
  mutations: contents_mutations
});
// CONCATENATED MODULE: ./src/store/modules/languages.js



// initial state
var languages_state = {
  showLanguages: false

  // getters
};var languages_getters = {};

// actions
var languages_actions = {};

// mutations
var languages_mutations = defineProperty_default()({}, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel == "";
  } else {
    state.activePanel == "Languages";
  }
});

/* harmony default export */ var languages = ({
  state: languages_state,
  getters: languages_getters,
  actions: languages_actions,
  mutations: languages_mutations
});
// CONCATENATED MODULE: ./src/store/modules/zoom.js


var _mutations;



// initial state
var zoom_state = {
  isZoomed: false,
  zoomLevel: 1,
  zoomOriginX: 0,
  zoomOriginY: 0

  // getters
};var zoom_getters = {
  // isZoomed: (state, getters) => state.isZoomed,
  zoomLevel: function zoomLevel(state, getters) {
    return state.zoomLevel;
  }

  // actions
};var zoom_actions = {
  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.rootState.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    if (newX < -context.getters.width) newX = -context.getters.width;
    if (newY < -context.getters.height) newY = -context.getters.height;
    if (newX > context.getters.width) newX = context.getters.width;
    if (newY > context.getters.height) newY = context.getters.height;
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY });
  }
};

// mutations
var zoom_mutations = (_mutations = {}, defineProperty_default()(_mutations, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (state.activePanel == 'Zoom') {
    state.activePanel = "";
  } else {
    state.activePanel = 'Zoom';
  }
  if (state.activePanel == 'Zoom') {
    state.zoomLevel = 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  } else {
    state.zoomLevel = 1;
  }
}), defineProperty_default()(_mutations, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;
}), _mutations);

/* harmony default export */ var zoom = ({
  state: zoom_state,
  getters: zoom_getters,
  actions: zoom_actions,
  mutations: zoom_mutations
});
// CONCATENATED MODULE: ./src/store/modules/search.js



// initial state
var search_state = {
  showSearch: false

  // getters
};var search_getters = {}
// allProducts: state => state.all


// actions
;var search_actions = {}
// getAllProducts ({ commit }) {
//   shop.getProducts(products => {
//     commit(types.RECEIVE_PRODUCTS, { products })
//   })
// }


// mutations
;var search_mutations = defineProperty_default()({}, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel == "";
  } else {
    state.activePanel == "Search";
  }
});

/* harmony default export */ var modules_search = ({
  state: search_state,
  getters: search_getters,
  actions: search_actions,
  mutations: search_mutations
});
// CONCATENATED MODULE: ./src/store/modules/route.js



// initial state - straight from the router i.e.
// route:{
// fullPath:"/5-1",
// meta: {},
// name:"PublishPage",
// params: {
//     section: "1",
//     page: "5"
// },
// path:"/5-1",
// query: {},
// }

// getters
var route_getters = {
  pageIndex: function pageIndex(state) {
    return parseInt(state.params.page);
  },
  sectionIndex: function sectionIndex(state) {
    return parseInt(state.params.section);
  }

  // actions
};var route_actions = {};

// mutations
var route_mutations = {};

/* harmony default export */ var route = ({
  getters: route_getters,
  actions: route_actions,
  mutations: route_mutations
});
// CONCATENATED MODULE: ./src/store/index.js












vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: {
    document: src_document,
    sectionIndices: [],
    pageScale: 1,
    videoURL: "",
    audioURL: "",
    activePanel: "",
    zoomLevel: 1,
    zoomOriginX: 0,
    zoomOriginY: 0,
    isDoublePage: false,
    galleryImages: [],
    galleryIndex: 0,
    isReader: false,
    initialWindowWidth: 300,
    initialWindowHeight: 476
  },
  actions: actions,
  getters: getters,
  mutations: mutations,
  modules: {
    // contents,
    // languages,
    // search,
    // zoom,
    route: route
  },
  strict: debug
}));
// EXTERNAL MODULE: ./node_modules/hammerjs/hammer.js
var hammer = __webpack_require__("rxKx");
var hammer_default = /*#__PURE__*/__webpack_require__.n(hammer);

// CONCATENATED MODULE: ./src/helpers/modules/inputHandler.js


/* harmony default export */ var inputHandler = ({
  init: function init() {
    window.mouseDown = false;
    window.mouse = {
      x: 0,
      y: 0,
      startX: 0,
      startY: 0,
      lastX: 0,
      lastY: 0,
      upX: 0,
      upY: 0,
      deltaX: 0,
      deltaY: 0
      // Mouse Events
      // document.addEventListener("mousedown", this.mouseDownHandler)
      // document.addEventListener("mousemove", this.mouseMoveHandler)
      // document.addEventListener("mouseup", this.mouseUpHandler)
    };document.addEventListener("mousewheel", this.mouseWheelHandler);
    document.addEventListener("dblclick", this.doubleClickHandler);
    //Touch Events
    // document.addEventListener( "touchstart", this.touchStartHandler)
    // document.addEventListener( "touchend", this.touchEndHandler)
    // document.addEventListener( "touchmove", this.touchMoveHandler)
    //Keyboard Events
    document.onkeydown = this.keyDownHandler;
    var hammertime;
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto",
        inputClass: hammer_default.a.SUPPORT_POINTER_EVENTS ? hammer_default.a.PointerEventInput : hammer_default.a.TouchInput,
        recognizers: [[hammer_default.a.Swipe, {
          direction: hammer_default.a.DIRECTION_HORIZONTAL
        }]]
      });
      hammertime.add(new hammer_default.a.Swipe());
    } else {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto"
      });
    }

    hammertime.get("swipe").set({ direction: hammer_default.a.DIRECTION_ALL });

    // hammertime.add(new Hammer.Tap({ event: "doubletap", taps: 2 }))
    // hammertime.add(new Hammer.Tap({ event: "singletap" }))
    // hammertime.get("doubletap").recognizeWith("singletap")
    // hammertime.get("singletap").requireFailure("doubletap")

    // hammertime.on("singletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1)
    //   ) {
    //     mouse.lastX = e.srcEvent.clientX
    //     mouse.lastY = e.srcEvent.clientY
    //   } else {
    //     console.log("Could not single tap")
    //   }
    // })

    // hammertime.on("doubletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     console.log("WORKING - MOBILE")
    //     Publish.toggleZoom({
    //       zoomOriginX: e.srcEvent.clientX,
    //       zoomOriginY: e.srcEvent.clientY,
    //     })
    //   } else {
    //     console.log("Could not double tap")
    //   }
    // })

    // hammertime.on("pinchin", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch in")
    //   }
    // })


    // hammertime.on("pinchout", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch out")
    //   }
    // })

    hammertime.on("pan", function (e) {
      if (!Publish.isMobile) {
        mouse.x = e.srcEvent.clientX;
        mouse.y = e.srcEvent.clientY;
        mouse.deltaX = mouse.x - mouse.lastX;
        mouse.deltaY = mouse.y - mouse.lastY;
        mouse.lastX = mouse.x;
        mouse.lastY = mouse.y;
        // console.log(mouse.deltaX + ", " + mouse.deltaY)
        // console.log("Panning")
        if (mouseDown && Publish.isZoomed) {
          // console.log("is actually panning")
          Publish.updateZoom({
            x: mouse.x,
            y: mouse.y
          });
        }
      }
    });

    hammertime.on("panstart", function (e) {
      if (!Publish.isMobile) {
        if (Publish.isZoomed) {
          mouseDown = true;
          mouse.lastX = e.srcEvent.clientX;
          mouse.lastY = e.srcEvent.clientY;
        }
      }
    });

    hammertime.on("panend", function (e) {
      if (!Publish.isMobile) {
        if (mouseDown && Publish.pagesVisible) {
          mouse.lastX = mouse.x;
          mouse.lastX = mouse.y;
          mouseDown = false;
        }
      }
    });

    hammertime.on("swipe", function (e) {
      if (Publish.isMobile && document.documentElement.dataset.mobile == "iOS" && screen.width != window.innerWidth && screen.width != window.innerHeight) //Safari
        {
          // console.log('zoomed portrait')
        } else {
        if (Publish.isGalleryOpen) {
          if (e.direction === hammer_default.a.DIRECTION_LEFT) {
            if (!Publish.rightToLeft) {
              Publish.nextGallerySlide();
            } else {
              Publish.previousGallerySlide();
            }
          } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
            if (!Publish.rightToLeft) {
              Publish.previousGallerySlide();
            } else {
              Publish.nextGallerySlide();
            }
          }
        } else if (Publish.videoURL == "" && Publish.audioURL == "" && !Publish.isZoomed) {
          if (Publish.isMobile || Publish.isReader) {
            if (Publish.mobileSwitch || Publish.isReader) {
              if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                if (!Publish.rightToLeft) {
                  Publish.goToNextMobilePage();
                } else {
                  Publish.goToPreviousMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                if (!Publish.rightToLeft) {
                  Publish.goToPreviousMobilePage();
                } else {
                  Publish.goToNextMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                console.log('Hammering Up');
                if (Publish.pagesVisible) Publish.goToNextSection();
              } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                console.log('Hammering Down');
                if (Publish.pagesVisible) Publish.goToPreviousSection();
              }
            } else {
              if (!Publish.isZoomed) {
                if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToNextPage();
                  } else {
                    Publish.goToPreviousPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToPreviousPage();
                  } else {
                    Publish.goToNextPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                  console.log('Hammering Up');
                  if (Publish.pagesVisible) Publish.goToNextSection();
                } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                  console.log('Hammering Down');
                  if (Publish.pagesVisible) Publish.goToPreviousSection();
                }
              }
            }
          } else {
            if (e.direction === hammer_default.a.DIRECTION_LEFT) {
              if (!Publish.rightToLeft) {
                Publish.goToNextPage();
              } else {
                Publish.goToPreviousPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
              if (!Publish.rightToLeft) {
                Publish.goToPreviousPage();
              } else {
                Publish.goToNextPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_UP) {
              console.log('Hammering Up');
              if (Publish.pagesVisible) Publish.goToNextSection();
            } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
              console.log('Hammering Down');
              if (Publish.pagesVisible) Publish.goToPreviousSection();
            }
          }
        }
        // else {
        //   if (e.direction === Hammer.DIRECTION_LEFT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToNextPage()
        //     } else {
        //       Publish.goToPreviousPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_RIGHT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToPreviousPage()
        //     } else {
        //       Publish.goToNextPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_UP) {
        //     if (Publish.pagesVisible) Publish.goToPreviousSection()
        //   } else if (e.direction === Hammer.DIRECTION_DOWN) {
        //     if (Publish.pagesVisible) Publish.goToNextSection()
        //   }
        // }
      }
    });
  },
  mouseWheelHandler: function mouseWheelHandler(e) {
    if (e.wheelDelta > 0) {
      Publish.goToPreviousSection();
    } else {
      Publish.goToNextSection();
    }
  },
  mouseMoveHandler: function mouseMoveHandler(e) {
    if (Publish.pagesVisible && Publish.zoomEnabled) {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
      if (mouseDown && !Publish.isZoomed) {
        if (mouse.x - mouse.lastX < -100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToPreviousPage()
          //   else
          //     Publish.goToNextPage()
          // }
          mouseDown = false;
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
        } else if (mouse.x - mouse.lastX > 100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToNextPage()
          //   else
          //     Publish.goToPreviousPage()
          // }
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY < -100) {
          // if (Publish.pagesVisible) Publish.goToNextSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY > 100) {
          // if (Publish.pagesVisible) Publish.goToPreviousSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        }
      }
      if (mouseDown && Publish.isZoomed) {
        Publish.updateZoom({
          x: mouse.x,
          y: mouse.y
        });
      }
    }
  },
  mouseDownHandler: function mouseDownHandler(e) {
    if (!mouseDown && Publish.pagesVisible) {
      mouseDown = true;
      mouse.lastX = mouse.x;
      mouse.lastY = mouse.y;
    }
  },
  mouseUpHandler: function mouseUpHandler(e, fromTouch) {
    if (mouseDown && Publish.pagesVisible) {
      mouse.upX = mouse.x;
      mouse.upY = mouse.y;
      mouseDown = false;
    }
  },
  doubleClickHandler: function doubleClickHandler(e) {
    if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" && (e.target.className.search("currentPage") !== -1 || e.target.className.search("leftPage") !== -1 || e.target.className.search("rightPage") !== -1 || e.path.indexOf(document.getElementById("page-container") !== -1))) {
      console.log("WORKING");
      Publish.toggleZoom({
        zoomOriginX: e.pageX - window.innerWidth / 2,
        zoomOriginY: e.pageY - window.innerHeight / 2
      });
    } else {
      console.log("Double click failed!");
    }
  },
  keyDownHandler: function keyDownHandler(e) {
    e = e || window.event;
    if (e.target.tagName == "INPUT" || e.ctrlKey == true || e.metaKey == true) return;
    if (Publish.isGalleryOpen) {
      if (e.keyCode == "37") {
        if (!Publish.rightToLeft) {
          Publish.previousGallerySlide();
        } else {
          Publish.nextGallerySlide();
        }
      }
      if (e.keyCode == "39") {
        if (!Publish.rightToLeft) {
          Publish.nextGallerySlide();
        } else {
          Publish.previousGallerySlide();
        }
      }
    } else if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
      // if(!Publish.isZoomed){
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextMobilePage();else Publish.goToPreviousMobilePage();
      }
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousMobilePage();else Publish.goToNextMobilePage();
      }
      // }
    } else if (!Publish.videoURL == "" || !Publish.audioURL == "") {} else {
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextPage();else Publish.goToPreviousPage();
      } // left arrow
      if (e.keyCode == "38") Publish.goToPreviousSection(); // up arrow
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousPage();else Publish.goToNextPage();
      } // right arrow
      if (e.keyCode == "40") Publish.goToNextSection(); // down arrow
    }
  },
  throttle: function throttle(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

    var timer = null;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (timer === null) {
        timer = setTimeout(function () {
          func.apply(_this, args);
          timer = null;
        }, wait);
      }
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/platformHandler.js
/* harmony default export */ var platformHandler = ({
  init: function init() {
    var documentElement = document.documentElement;
    documentElement.setAttribute("data-useragent", navigator.userAgent);
    documentElement.setAttribute("data-platform", navigator.platform);
    documentElement.setAttribute("data-mobile", this.getMobileOperatingSystem());
    documentElement.setAttribute("data-browser", this.getBrowserInformation());
  },

  /**
   * Determine the mobile operating system.
   * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
   *
   * @returns {String}
   */
  getMobileOperatingSystem: function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  },
  getBrowserInformation: function getBrowserInformation() {
    var ua = navigator.userAgent,
        tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M[0];
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/pageHandler.js
/* harmony default export */ var pageHandler = ({
  init: function init() {
    var delay = 250;
    var timeout = false;
    this.actualResizeHandler();
    window.addEventListener('resize', this.debounce(this.actualResizeHandler, 250));
  },
  actualResizeHandler: function actualResizeHandler(event) {
    if (typeof Publish !== 'undefined') {
      if (!Publish.isMobile) {
        Publish.changeWindowSize({
          width: window.innerWidth,
          height: window.innerHeight
        });
      } else {
        if (document.documentElement.dataset.mobile == "Android") {
          Publish.changeWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
          });
        }
      }
    }
  },
  debounce: function debounce(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;

    var timeout = void 0;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(_this, args);
      }, wait);
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/index.js





/* harmony default export */ var helpers = ({
  inputHandler: inputHandler,
  platformHandler: platformHandler,
  pageHandler: pageHandler,
  trackingHandler: trackingHandler
});
// EXTERNAL MODULE: ./node_modules/vuex-router-sync/index.js
var vuex_router_sync = __webpack_require__("9JMe");
var vuex_router_sync_default = /*#__PURE__*/__webpack_require__.n(vuex_router_sync);

// CONCATENATED MODULE: ./src/main.js

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









var unsync = Object(vuex_router_sync["sync"])(store, router);

vue_esm["a" /* default */].config.productionTip = false;

vue_esm["a" /* default */].use(vue_analytics_default.a, {
  id: 'UA-159440454-31',
  router: router
});

/* eslint-disable no-new */
window.Publish = new vue_esm["a" /* default */]({
  el: "#app",
  router: router,
  store: store,
  template: '<App ref="app"/>',
  components: {
    App: src_App
  },
  created: function created() {
    if (this.mobileSwitch) this.checkMobileLanding();
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
  }), Object(vuex_esm["c" /* mapGetters */])(["currentPage", "pagesVisible", "isZoomed", "showContents", "zoomLevel", "rightToLeft", "zoomEnabled", "isMobile", "mobileSwitch", "currentMobilePageIndex", "videoURL", "isGalleryOpen", "doublePage", "isPhantom", "isDoublePage", "showGuide", "initialWindowWidth", "initialWindowHeight", "audioURL"])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleZoom: "TOGGLE_ZOOM"
  }), Object(vuex_esm["b" /* mapActions */])(["goToPage", "goToNextPage", "goToPreviousPage", "goToNextSection", "goToPreviousSection", "goToPreviousMobilePage", "goToNextMobilePage", "nextPage", "previousPage", "nextSection", "previousSection", "previousMobilePage", "nextMobilePage", "updateZoom", "startZoom", "changeWindowSize", "checkMobileLanding", "updateVideoURL", "pinchZoom", "panZoom", "openVideo", "isPhantom", "openGallery", "openGalleryTwo", "closeGallery", "goToGallerySlide", "nextGallerySlide", "previousGallerySlide", 'changeWindowSize', 'setInitialWindowSize', "updateAudioURL", "openAudio"])),
  mounted: function mounted() {
    helpers.pageHandler.init();
    helpers.inputHandler.init();
    helpers.platformHandler.init();
    helpers.trackingHandler.init();
    // if (!Publish.isPhantom) {
    // this.changeWindowSize({
    //   width: window.innerWidth,
    //   height: window.innerHeight,
    // })
    // }
  }
});

router.beforeEach(function (to, from, next) {
  if (Publish.isMobile && Publish.mobileSwitch) next();
  // console.log('Navigating from', from, ' to ', to)
  var p = parseInt(from.params.page) - 1;
  var s = parseInt(from.params.section) - 1;
  try {
    if (window["p" + p + "s" + s + "onPageLeave"] && !Publish.$store.getters.tmpMobile) {
      window["p" + p + "s" + s + "onPageLeave"]();
    }
    if (Publish.$store.state.isDoublePage && Publish.doublePage) {
      window["p" + p + "s" + s + "onPageLeave"]();
      window["p" + (p + 1) + "s" + s + "onPageLeave"]();
    }
  } catch (err) {
    console.error("WARNING - p" + p + "s" + s + "onPageLeave caused an error:");
    console.error(err.message);
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
    document.getElementById('mobile-container').style.position = "fixed";
    setTimeout(function () {
      document.getElementById('mobile-container').style.position = "";
    }, 100);
  }
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

/***/ }),

/***/ "NZMO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Pg37":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QkI9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S4/L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T53c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U2l4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V6ic":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WN8W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZQhR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Zf2O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eJtY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i9d8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oPvi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pXbK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tGyY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uDJ7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.9c687245133c052cdbc4.js